const english = {
    // Errors from API - dynamic error messages
    errors: {
        bad_request:
            'The request could not be processed. Please verify your information and try again.',
        unauthorized:
            'Your session has expired. Please sign in again to continue.',
        forbidden: 'You do not have permission to perform this action.',
        conflict: 'A data conflict occurred. Refresh the page and try again.',
        unprocessable:
            'Some fields contain invalid values. Please correct them and try again.',
        internal_server_error:
            'A system error occurred. Please try again shortly.',
        network:
            'The connection to the server could not be established. Check your internet connection and try again.',
        unknown_error: 'An unexpected error occurred. Please try again.',
    },

    Failed_wrong_update:
        'Failed to update. Please try again or contact support if the problem persists.',

    Successfully_created_wrongdoing: 'Wrongdoing created successfully.',
    Successfully_updated_wrongdoing: 'Wrongdoing updated successfully.',
    wrongDoingNameRequired: 'Please enter a name.',
    wrongDoingMinNameRequired: 'Name must be at least 4 characters.',
    wrongDoingNameMaxLength: 'Name cannot exceed 255 characters.',
    wrongDoingParagraph: 'Please enter Paragraph.',
    wrongDoingParagraphMinLength: 'Paragraph must be at least 4 characters.',
    wrongDoingCreateFailed: 'Could not create the offence. Please try again.',
    wrongDoingDeleteFailed: 'Could not delete the offence. Please try again.',
    clearReasonCreateSuccess: 'Clear fine reason created successfully.',
    clearReasonUpdateSuccess: 'Clear fine reason updated successfully.',
    clearReasonDeleteSuccess: 'Clear fine reason deleted successfully.',
    clearReasonCreateFailed:
        'Could not create the clear fine reason. Please try again.',
    clearReasonUpdateFailed:
        'Could not update the clear fine reason. Please try again.',
    clearReasonDeleteFailed:
        'Could not delete the clear fine reason. Please try again.',
    cameraSettingsNameRequired: 'Please enter a name.',
    cameraSettingsAddressRequired: 'Please select an address.',
    cameraSettingsTypeRequired: 'Please select a type.',
    cameraSettingsUsernameRequired: 'Please enter a username.',
    cameraSettingsPasswordRequired: 'Please enter a password.',
    cameraSettingsRtspUrlRequired: 'Please enter an RTSP URL.',
    'RTSP URL': 'RTSP URL',
    'Heartbeat URL': 'Heartbeat URL',
    trainingTitleRequired: 'Please enter a training title.',
    trainingContentRequired: 'Please enter the training content.',
    trainingReadDurationInvalid: 'Read duration must be greater than 0.',
    trainingSaveFailed: 'Could not save the training module. Please try again.',
    notificationSentToUsers: 'Notification sent to {{count}} user(s).',
    notificationSentToUsersShort: 'Sent to {{count}} user(s)',
    notificationFailedCount: '{{count}} failed',
    notificationSkippedCount: '{{count}} with skipped channels',
    notificationFailedToDeliver: 'Failed to deliver to {{count}} user(s).',
    notificationSendFailed: 'Failed to send notification. Please try again.',

    'User has not enabled push notifications on their device':
        'User has not enabled push notifications on their device.',
    'Push notification service is temporarily unavailable':
        'Push notification service is temporarily unavailable. Please try again later.',
    'Failed to deliver push notification to the device':
        'Could not deliver the push notification.',
    'Failed to deliver in-app notification':
        'Could not deliver the in-app notification.',
    'User has not set up notification preferences':
        'User has not set up notification preferences.',
    'Notification could not be delivered through any channel':
        'Notification could not be delivered through any channel.',

    // subscription rule page
    'rent.delete.title': 'Delete subscription rule',
    'rent.delete.error_title': 'Could not delete subscription rule',
    'rent.delete.warning_title':
        'You are about to delete this subscription rule',
    'rent.delete.warning_body':
        'This action will remove the rule and it may affect subscriptions using it.',
    'rent.delete.confirm_info_title': 'What happens when you confirm',
    'rent.delete.confirm_info_point_1':
        'The subscription rule will be deleted by ID.',

    // buy subscription page public.
    'subscription.invalid_page_title': 'An error occurred',
    'subscription.invalid_page_body':
        'This link is not valid right now. Please try again later or contact support.',

    VersionWatcher: 'New version available – refresh the page.',

    // Generic
    New: 'New',
    test: 'test',
    Update: 'Update',
    Cancel: 'Cancel',
    Create: 'Create',
    Delete: 'Delete',
    'Delete singular': 'Delete',
    Upload: 'Upload',
    Close: 'Close',
    Read: 'Read',
    'Generate Report': 'Generate Report',
    'Generating Report': 'Generating Report',
    'Download Report': 'Download Report',
    downloadXlsx: 'Download XLSX',
    reportFilterError:
        'Unable to generate report. Please apply filters to minimize the amount of results.',
    reportGeneratingSlow:
        'The report is being generated. Apply filters to speed it up.',
    'Search the table': 'Search the table',
    Page: 'Page',
    of: 'of',
    Images: 'Images',
    Dates: 'Dates',
    Date: 'Date',
    Time: 'Time',
    Note: 'Note',
    optional: '(optional)',
    Status: 'Status',
    Country: 'Country',
    'Select all': 'Select all',
    Allow: 'Allow',
    Business: 'Business',
    Search: 'Search',
    CarBrand: 'Car brand',
    FuelName: 'Fuel type',
    'Valve control': 'Valve control',
    SentToCasewhere: 'Sent to Casewhere',
    More: 'More',
    Hide: 'Hide',
    Other: 'Other',
    Save: 'Save',
    Saving: 'Saving',
    Unknown: 'Unknown',
    Choose: 'Choose',
    Website: 'Website',
    more: 'more',
    'Created date': 'Created date',
    'Last login web': 'Last login web',
    'Last login app': 'Last login app',
    Parkinglots: 'Parkinglot',
    Parkinglot: 'Parkinglot',
    Public: 'Public',
    Extra: 'Extra',
    'Activate discount codes': 'Activate discount codes',
    'Disable discount codes': 'Disable discount codes',
    'Discount codes': 'Discount codes',
    'Choose address': 'Choose address',
    'Validity period': 'Validity period',
    'Valid for an unlimited time': 'Valid for an unlimited time',
    'Set a specific validity period': 'Set a specific validity period',
    'Select the address where discount codes are allowed.':
        'Select the address where discount codes are allowed.',
    'Choose when the discount code should be active. The end date must be after the start date.':
        'Choose when the discount code should be active. The end date must be after the start date.',
    'The discount code is valid until you choose a specific period.':
        'The discount code is valid until you choose a specific period.',
    Copy: 'Copy',
    Copied: 'Copied',
    'Copy failed': 'Copy failed',
    'New code': 'New code',
    'Mail Settings': 'Mail Settings',
    'Unlimited period': 'Unlimited period',
    'Send mail directly': 'Send mail directly',
    'Send new mail': 'Send new mail',
    'App Fines': 'App Fines',
    'App Fines Revert': 'App Fines Revert',
    'App Subscriptions': 'App Subscriptions',

    // User
    Username: 'Username',
    Password: 'Password',
    'Created By': 'Created By',
    'Created by': 'Created by',
    'Created Date': 'Created Date',
    'Updated Date': 'Updated Date',
    'Updated by': 'Updated by',
    Admin: 'Admin',
    Write: 'Write',
    'Can manage all settings and permissions':
        'Can manage all settings and permissions',
    'Can manage standard settings and permissions':
        'Can manage standard settings and permissions',
    'Can access as a read-only user': 'Can access as a read-only user',
    'User Id': 'User Id',

    DeleteUserConfirmMsg:
        'Deleting this user will immediately end all their active permits and subscriptions as of today. Are you sure you want to proceed?',
    DeleteAddressAccordionTitle: 'Deactivate parking address',
    DeleteAddressHeading: 'You are about to deactivate the address',
    DeleteAddressIntro:
        'This action will delete the address and make it unavailable across the entire platform. Below you can see the consequences.',
    DeleteAddressEffectsTitle: 'This will happen:',
    DeleteAddressCategoriesRulesTitle: 'Parking rules',
    DeleteAddressCategoriesSubsTitle: 'Subscriptions',
    DeleteAddressCategoriesPermitsTitle: 'Permits',
    DeleteAddressCategoriesAccessTitle: 'Access and permissions',
    DeleteAddressRulesShortTerm:
        'Short-term rules will be deactivated and will no longer appear on the public map for purchasing parking tickets or in the platform.',
    DeleteAddressRulesSubscription:
        'Subscription rules will be deactivated. It will no longer be possible to purchase subscriptions via the public map, and the rules will not be shown in the platform.',
    DeleteAddressSubsCancelled:
        'All active subscriptions at the address will be cancelled. Affected customers will receive an email notification (same flow as “Stop subscription”).',
    DeleteAddressPermitsInactive:
        'All permits (permits) will be set to inactive and will no longer be valid.',
    DeleteAddressAccessNoSelectFinesPermits:
        'The address cannot be selected when creating fines or permits.',
    DeleteAddressAccessNoSelectUsers:
        'The address cannot be selected when creating users.',
    DeleteAddressAccessUsersLoseAccess:
        'All current users will lose access to this parking address.',
    DeleteAddressAccessOrgsLoseAccess:
        'All external organizations will also lose access to the address.',
    DeleteAddressVisibilityRemoved:
        'The address will be removed from all address lists and will disappear from the platform and the public map.',

    DeleteOrganisationAccordionTitle: 'Deactivate organization',
    DeleteOrganisationHeading: 'You are about to deactivate the organization',
    DeleteOrganisationIntro:
        'This action deletes the organization and makes it unavailable across the platform. All associated addresses, rules, permits and users will be affected. Below you can see the consequences.',
    DeleteOrganisationEffectsTitle: 'This will happen:',

    DeleteOrganisationCategoriesRulesTitle: 'Parking rules',
    DeleteOrganisationCategoriesSubsTitle: 'Subscriptions',
    DeleteOrganisationCategoriesPermitsTitle: 'Permits',
    DeleteOrganisationCategoriesAccessTitle: 'Access and permissions',

    DeleteOrganisationRulesTickets:
        'All short-term parking rules linked to the organization’s addresses will be deactivated and will no longer appear on the public map or in the platform.',
    DeleteOrganisationRulesSubscriptions:
        'All subscription terms linked to the organization’s addresses will be deactivated. It will no longer be possible to purchase subscriptions via the public map or in the platform.',
    DeleteOrganisationSubsCancelled:
        'All active subscriptions on the organization’s addresses will be canceled, but will remain active until the end of the current month. Affected customers will receive an email notification (same process as “Stop subscription”).',
    DeleteOrganisationPermitsInactive:
        'All permits linked to the organization’s addresses will be set to inactive and will no longer be valid.',

    DeleteOrganisationAccessUsersLoseAccess:
        'All of the organization’s users lose access to the platform and the app.',
    DeleteOrganisationAccessLoginBlocked:
        'Users from this organization cannot log in.',
    DeleteOrganisationAccessOrgsLoseAccess:
        'All external organizations also lose access to the addresses.',
    DeleteOrganisationAccessOrganisationUnavailable:
        'The organization is no longer available anywhere in the platform.',
    DeleteOrganisationAccessAddressesUnavailable:
        'All of the organization’s addresses are no longer available in the platform or on the public map.',
    DeleteOrganisationVisibilityRemoved:
        'The organization, all its addresses and users are removed from all lists and search results and are no longer visible anywhere in the platform or on the public map.',
    'Only 1 permit per car per day?': 'Only 1 permit per car per day?',
    'User Distribution': 'User Distribution',
    'Parking Guard Provision': 'Parking Guard Provision',
    'Please provide at least 20 characters':
        'Please provide at least 20 characters',
    'Select Users': 'Select Users',
    'Select Organisation': 'Select Organisation',

    // Menu
    Home: 'Home',
    Dashboard: 'Dashboard',
    'Parking Lots': 'Parking Lots',
    'Map of Parking Lots': 'Map of Parking Lots',
    Users: 'Users',
    Permits: 'Permits',
    'Permit Reasons': 'Permit Reasons',
    Fines: 'Fines',
    Fines2: 'Fines',
    Tickets: 'Tickets',
    Customers: 'Customers',
    Backoffice: 'Backoffice',
    Map: 'Map',
    mapExportSaveAs: 'Save map as',
    mapExportSaveAsHint:
        'Download the current map view and caption as a PDF or PNG file.',
    mapExportAsPdf: 'PDF',
    mapExportAsPng: 'PNG',
    mapExportSaving: 'Saving…',
    mapExportFailed: 'Could not export the map. Try again or use a screenshot.',
    mapExportPdfFailed:
        'Could not save the map as PDF. Try PNG or a screenshot.',
    mapExportPngFailed:
        'Could not save the map as PNG. Try PDF or a screenshot.',
    mapExportCaptionExportedAt: 'Exported: {{datetime}} (CET)',
    mapExportCaptionMode: 'Mode: {{mode}}',
    mapExportCaptionPeriod: 'Period: {{from}} – {{to}}',
    mapExportCaptionOrganisations: 'Organisations: {{count}} (IDs: {{ids}})',
    mapExportCaptionParkingLots: 'Parking lots: {{count}} (IDs: {{ids}})',
    mapExportCaptionUsers: 'Users: {{count}} (IDs: {{ids}})',
    mapExportCaptionStreets: 'Streets: {{count}} ({{names}})',
    mapExportCaptionStreetNumbers: 'Street numbers: {{from}} – {{to}}',
    mapExportCaptionAddressTypes:
        'Parking address types: {{count}} (IDs: {{ids}})',
    mapExportCaptionAreaFilter: 'Area polygon filter: {{count}} vertices',
    mapExportCaptionAreaDraft:
        'Area selector (draft): {{count}} point(s) — add at least 3 and search to apply',
    mapExportCaptionAreaPendingSearch:
        'Area selector: {{count}} points — run Search to apply to map data',
    mapExportOn: 'On',
    mapExportOff: 'Off',
    mapExportCaptionZones: 'Parking zones overlay: {{state}}',
    mapExportCaptionPins: 'Parking lot pins: {{state}}',
    mapExportCaptionGpsLive: 'GPS live only: {{state}}',
    Statistics: 'Statistics',
    Subscriptions: 'Subscriptions',
    oparkoGo: 'Oparko Go',
    permits: 'Permits',
    fines: 'Fines',
    subscriptions: 'Subscriptions',
    'Subscription permits': 'Subscription permits',
    Finance: 'Finance',
    'Ticket Service': 'Buy a permit',
    'Buy a permit': 'Buy a permit',
    'Get a permit': 'Get a permit',
    'Private Ticket Service': 'Get a permit',
    Reports: 'Reports',
    Rent: 'Rent',
    Prices: 'Prices',
    'Short term': 'Short term',
    discountCodes: 'Discount Codes',
    unusedCodes: 'Unused Codes',
    usedCodes: 'Used Codes',
    Rental: 'Pricing Terms',
    Profile: 'Profile',
    Notifications: 'Notifications',
    Videowall: 'Videowall',
    'Camera Scans': 'Camera Scans',
    'Camera scan': 'Camera scan',
    'Spot scan': 'Spot scan',
    'App Permits': 'App Permits',
    'Weekly Heat Map': 'Weekly Heat Map',
    Daily: 'Daily',
    Area: 'Area',
    Documentation: 'Documentation',

    // Settings
    Settings: 'Settings',
    'User Details': 'User Details',
    Language: 'Language',
    'Parking Lot': 'Parking Lot',
    'Parking lot': 'Parking lot',
    'Parking Zone': 'Parking Zone',
    'P-Zone': 'P-Zone',
    Street: 'Street',
    Streets: 'Streets',
    'Street Number': 'Street Number',
    ZipCode: 'ZipCode',
    'Parking Ticket ID': 'Parking Ticket ID',
    'Discounted Price': 'Discounted Price',
    'Valid From': 'Valid From',
    'Valid To': 'Valid To',
    'Email Sent To': 'Email Sent To',
    'Used At': 'Used At',
    City: 'City',
    'Notification settings': 'Notification settings',
    'WELCOME TO': 'WELCOME TO',
    'Only receive notifications on the selected days and within the specified time period.':
        'Only receive notifications on the selected days and within the specified time period.',
    'Enable work hours': 'Enable work hours',
    'Get notified when new possible fines are detected.':
        'Get notified when new possible fines are detected.',

    // Login
    Login: 'Login',
    'Log out': 'Log out',
    'Forgot Password': 'Forgot Password',
    Email: 'Email',
    'Reset Password': 'Reset Password',
    'Password reset email sent. Please check your email.':
        'Password reset email sent. Please check your email',
    'Something went wrong': 'Something went wrong',
    'Wrong username or password': 'Wrong username or password',
    'Error resetting password, please retry':
        'Error resetting password, please retry',
    'Digital parking solution for every need':
        'Digital parking solution for every need',

    // Search bar
    'None selected': 'None selected',
    'All selected': 'All selected',
    'Only active': 'Only active',
    'Show cancelled': 'Show cancelled',

    // Frontoffice
    'Latest fines': 'Latest fines',
    'No data available!': 'No data available!',
    'There were no datapoints to show on this graph':
        'There were no datapoints to show on this graph',
    'Good fines': 'Good fines',
    Annulled: 'Annulled',
    'Could not fetch fines - please refresh and try again':
        'Could not fetch fines - please refresh and try again',
    'Something went wrong, could not find any users - Please refresh and try again.':
        'Something went wrong, could not find any users - Please refresh and try again.',
    Activated: 'Activated',
    Deactivated: 'Deactivated',
    'Indefinite validity': 'Indefinite validity',
    'Email sent to': 'Email sent to',
    'No email sent': 'No email sent',
    Customer: 'Customer',
    'User list': 'User list',
    'Total Users Shown': 'Total Users Shown',
    'Total Events in Period': 'Total Events in Period',
    'Average Events per User': 'Average Events per User',
    'Create User': 'Create User',
    Yes: 'Yes',
    No: 'No',
    'Permit list': 'Permit list',
    'Create Permit': 'Create Permit',
    'Start date': 'Start date',
    'Start Date': 'Start Date',
    End: 'End',
    'End date': 'End date',
    'End Date': 'End Date',
    'End Session': 'End Session',
    'End with Payment': 'Afslut med betaling',
    'End date & time': 'End date & time',
    Type: 'Type',
    'Something went wrong, could not find any parking lots - Please refresh and try again.':
        'Something went wrong, could not find any parking lots - Please refresh and try again.',
    'Parking Lots List': 'Parking Lots List',
    Address: 'Address',
    'Parking Map': 'Parking Map',
    'Something went wrong, could not find any hourly data - Please refresh and try again.':
        'Something went wrong, could not find any hourly data - Please refresh and try again.',
    'Something went wrong, could not find any daily data - Please refresh and try again.':
        'Something went wrong, could not find any daily data - Please refresh and try again.',
    'Something went wrong, could not find any look up data - Please refresh and try again.':
        'Something went wrong, could not find any look up data - Please refresh and try again.',
    'Hourly visits count': 'Hourly visits count',
    'Daily visits count': 'Daily visits count',
    'Fine list': 'Fine list',
    'Could not generate the report - please refresh and try again':
        'Could not generate the report - please refresh and try again',
    'Country code': 'Country code',
    'Country Code': 'Country code',
    cancelFine: 'Why are you canceling this Fee?',
    'Cancel reason': 'Cancel reason',
    Comments: 'Comments',
    'Cancelled fines': 'Cancelled fines',
    'Cancelled fines2': 'Cancelled fee',
    'Cancelled data': 'Cancelled',
    'cancellation rate': 'Cancellation rate',
    'Active fines': 'Active fines',
    'Active fines2': 'Fee',
    'Active data': 'Active',
    'Total fines': 'Total fines',
    'Parking Lot list': 'Parking Lot list',
    'Reg. nr.': 'Reg. no.',
    'Reference number': 'Reference number',
    'Reference id  / fine id / invoice id':
        'Reference id  / fine id / invoice id',
    'You cannot pay the fine right now.': 'You cannot pay the fine right now.',
    'If this seems unexpected, please try again later or contact support.':
        'If this seems unexpected, please try again later or contact support.',
    'This fine has been cancelled.': 'This fine has been cancelled.',
    'You cannot pay this fine as it has been cancelled.':
        'You cannot pay this fine as it has been cancelled.',
    'This fine is under recovery.': 'This fine is under recovery.',
    'This case has been sent to debt collection.':
        'This case has been sent to debt collection.',
    CollectionMessage:
        'You cannot pay the fine here. Please use the payment instructions provided in the letter, e-Boks message, or email you received. If you want information about payment, you can use the form under the "Submit an appeal" tab and ask for information',
    'Something went wrong, please try again or contact support if the problem persists.':
        'Something went wrong, please try again or contact support if the problem persists.',

    CollectionMessageDocu:
        'The case is sent to debt collection, and it is not possible to access the documentation about the case here. If you believe this is an error, please use the form under the "Submit an appeal" tab.',
    // Handle fine flow
    documentation: {
        header: 'View Your Documentation',
        subtitle:
            'Get an overview of your documentation and details about the fee.',
    },
    complaint: {
        header: 'Submit Appeal',
        subtitle: 'State the reason and attach documentation for your appeal.',
    },
    payFine: {
        header: 'Complete Payment',
        subtitle: 'Pay your case here.',
    },

    emailSent: {
        header: 'Email Sent Successfully',
        subtitle:
            'Your message is on its way. You can expect a response shortly.',
    },

    paymentAccepted: {
        header: 'Payment Successful',
        subtitle: 'Thank you. Your payment has been processed.',
    },

    paymentDeclined: {
        header: 'Payment Declined',
        subtitle: 'Unfortunately, your payment could not be processed.',
    },

    Case: 'Case',

    // Backoffice
    'Customer list': 'Customer list',
    'Something went wrong in searching for customers':
        'Something went wrong in searching for customers',
    'Create Customer': 'Create Customer',
    Name: 'Name',
    description: 'description',
    Description: 'Description',
    'Create Fine': 'Create Fine',
    'Generate DMR report': 'Generate DMR report',
    'Advanced Report': 'Advanced Report',
    'Mass change': 'Mass change',
    'Customers info': 'Customers info',
    'Accounting info': 'Accounting info',
    'Create p-lot': 'Create p-lot',
    'Organisation list': 'Organisation list',
    Add: 'Add',
    'Parking Lot Info': 'Parking Lot Info',
    'Add ruleset': 'Add ruleset',
    Rules: 'Rules',
    'Show child parking lots': 'Show child parking lots',
    'Permit sharing': 'Permit sharing',
    'Group id': 'Group ID',
    'minimum 20 characters': 'minimum 20 characters',
    // Modals
    Directions: 'Directions',
    ParkingLotAngles: 'Angles',
    'Send Password': 'Send Password',
    'Settlement dates': 'Settlement dates',
    'Parking Lot Type': 'Parking Lot Type',
    'Location Configuration': 'Location Configuration',
    areaSelector: 'Area Selector',
    createParkingZone: 'Create parking zone',
    clearZone: 'Clear zone',
    clickToSelectArea: 'Click to Select Area',
    clickToClearArea: 'Click to Clear Area',
    enterManually: 'Enter Manually',
    mapSelector: 'Map Selector',
    areaCoordinatesMinError: 'Area coordinates must have at least 3 points, ',
    clickMapToAddPoints: 'click on the map to add points',
    'Single Point(Latitude/Longitude)': 'Single Point(Latitude/Longitude)',
    'Wont Update Status': 'Wont Update Status',
    'Wont Update Parking Guard': 'Wont Update Parking Guard',
    'Wont Update Organization': 'Wont Update Organization',
    Offence: 'Offence',
    selectOffense: 'Select offence',
    streetQualifier: 'Street qualifier',
    Contractor: 'Contractor',
    'Incident information': 'Incident information',
    'Incident Information': 'Incident Information',
    'Leave a comment...': 'Leave a comment...',
    'Cancel Fee': 'Cancel Fee',
    'Cancel Reason': 'Cancel Reason',
    'Additional Information': 'Additional Information',
    Latitude: 'Latitude',
    'Area coordinates': 'Area coordinates',
    'Map pin': 'Map pin',
    'Loading...': 'Loading...',
    'Could not find the parking lot you were looking for.':
        'Could not find the parking lot you were looking for.',
    'Successfully updated the parking lot!':
        'Successfully updated the parking lot!',
    'Successfully created new parking lot!':
        'Successfully created new parking lot!',
    'You can now close the modal.': 'You can now close the modal.',
    'Geographic coordinate': 'Geographic coordinate',
    Longitude: 'Longitude',
    'Parking lot details': 'Parking lot details',
    'Rules for parking': 'Rules for parking',
    'Rules for guest parking': 'Rules for guest parking',
    ruleName: 'Rule name',
    advancedRuleName: 'Advanced rule name',
    customRuleName: 'Custom rule name',
    'Custom permit rules': 'Custom permit rules',
    'Select parking lots': 'Select parking lots',
    '+ Overwrite rule': '+ Overwrite rule',
    maxActivePermits: 'Max number of active permits',
    maxPermitsPerMonth: 'Max number of created permits',
    durationMinutes: 'Duration of permits (in minutes)',
    'Show customer': 'Show customer',
    'Number of active permits created by one user at the same time':
        'Number of active permits created by one user at the same time',
    'Maximum length for created permits in app':
        'Maximum length for created permits in app',
    'Note for app': 'Note for app',
    Warning: 'Warning',
    'Changing Reg. No.': 'Changing Reg. No.',
    'Country and reg. no.': 'Country and reg. no.',
    'If reg. no. is not correct and you need to adjust it, "Registered before" will not update. Please doublecheck your changes are correct before applying them':
        'If reg. no. is not correct and you need to adjust it, "Registered before" will not update. Please doublecheck your changes are correct before applying them',
    'Control Type': 'Control Type',
    'Camera Fines': 'Camera Fines',
    'Camera fine list': 'Camera fine list',
    'Camera Settings': 'Camera Settings',
    'Camera control': 'Camera control',
    'Camera Control': 'Camera Control',
    'Guard control': 'Guard control',
    'Guard Control': 'Guard Control',
    'Self control': 'Self control',
    'Need for collection': 'Need for collection',
    'Parking Spots': 'Parking Spots',
    'Rent?': 'Rent?',
    Distribution: 'Distribution',
    'Amount of Duty': 'Amount of Duty',
    'Why are you canceling this Fine? - Minimum 20 characters':
        'Why are you canceling this Fine? - Minimum 20 characters',
    'Send and Cancel Fee': 'Send and Cancel Fee',
    'Could not find the fine you were looking for.':
        'Could not find the fine you were looking for.',
    'Could not find the permit you were looking for.':
        'Could not find the permit you were looking for.',
    'Belongs to': 'Belongs to',
    'Internal note': 'Internal note',
    'External note': 'External note',
    'Could not create the permit - close and try again please':
        'Could not create the permit - close and try again please',
    'Could not update the permit - close and try again please':
        'Could not update the permit - close and try again please',
    'User successfully created, you can close the modal again':
        'User successfully created, you can close the modal again',
    'User successfully updated, you can close the modal again':
        'User successfully updated, you can close the modal again',
    'User credentials': 'User credentials',
    'Confirm password': 'Confirm password',
    'New password': 'New password',
    'The password matches': 'The password matches',
    'Error changing your password. Please ensure your current password is correct.':
        'Error changing your password. Please ensure your current password is correct.',
    'The password does not matches': 'The password does not matches',
    'Password changed successfully.': 'Password changed successfully.',
    Permissions: 'Permissions',
    'Users to manage': 'Users to manage',
    'Activate User': 'Activate User',
    'Access to Website': 'Access to Website',
    'Access to App': 'Access to App',
    'Access to API': 'Access to API',
    'Handle Fines': 'Handle Fines',
    'Handle Permits': 'Handle Permits',
    'Handle Subscriptions': 'Handle Subscriptions',
    User: 'User',
    Permit: 'Permit',
    Fine: 'Fine',
    'Update customer': 'Update customer',
    'Customer Type': 'Customer Type',
    Created: 'Created',
    Updated: 'Updated',
    'Connected Users': 'Connected Users',
    'Connected parking lots': 'Connected parking lots',
    'Total amount of users:': 'Total amount of users:',
    'Fine successfully updated, you can close the modal again':
        'Fine successfully updated, you can close the modal again',
    'Fine successfully created, you can close the modal again':
        'Fine successfully created, you can close the modal again',
    'Update Fine': 'Update Fine',
    Brand: 'Brand',
    Fuel: 'Fuel',
    'New Fine': 'New Fine',
    Owner: 'Owner',
    'Parking guard': 'Parking guard',
    'House number': 'House number',
    'House nr.': 'House nr.',
    'Open Parking Lot': 'Open Parking Lot',
    'Update parking lot': 'Update parking lot',
    'External Customers': 'External Customers',
    'Back to Fine': 'Back to Fine',
    'Update user': 'Update user',
    'Update User': 'Update User',
    'New user': 'New user',
    'Update subscription': 'Update subscription',
    'New subscription': 'New subscription',
    'Create subscription': 'Create subscription',
    'Create Subscription': 'Create Subscription',
    'Creating subscription...': 'Creating subscription...',
    'Available subscriptions left': 'Available subscriptions left',
    'subscription limit reached': 'subscription limit reached',
    'permit limit exceeded': 'permit limit exceeded',
    'permit.history_deactivated':
        'Permit deactivated due to deletion of user {{userID}} by user {{actorID}}',
    'permit.history_transferred':
        'Permit transferred from user {{fromUserID}} to user {{toUserID}} due to deletion by user {{actorID}}',
    'permit.limit_exceeded_title': 'Too many permits',
    'permit.limit_exceeded_message':
        'The number of permits exceeds the allowed limit. Please remove permits until you are within the allowed limit and try again.',
    'You already have a user. Please login instead':
        'You already have a user. Please login instead',
    'Could not create subscription for you, try close and open the page again':
        'Could not create subscription for you, try close and open the page again',
    'Could not create the subscription - please try again.':
        'Could not create the subscription - please try again.',
    Payment: 'Payment',
    'Payment ID': 'Payment ID',
    'Current status': 'Current status',
    'Payment Amount': 'Payment Amount',
    'Payment history details': 'Payment history details',
    'Payment history details Operations': 'Payment history details Operations',
    'Redirect you to the payment page, do not refresh or go back!':
        'Redirect you to the payment page, do not refresh or go back!',
    'out of': 'out of',
    'Time rules for parking': 'Time rules for parking',
    'Time rules': 'Time rules',
    time: 'tid',
    Payments: 'Payments',
    'Subscription Id': 'Subscription Id',
    Phone: 'Phone',
    'Parkinglot image': 'Parkinglot image',
    'Parkinglot images': 'Parkinglot images',
    'Signage images': 'Signage images',
    'parkingLots.minObservationTime': 'Min Observation Time (min)',
    'parkingLots.fineDurationMinutes.label': 'Fine expiry - App fines',
    'parkingLots.fineDurationMinutes.disabled':
        'End time is always set to midnight',
    'parkingLots.fineDurationMinutes.enabled':
        'End time is set to 24 hours after creation',
    'Collection Price': 'Collection Price',
    'Post Collection Price Per Hour': 'Post Collection Price Per Hour',
    'Post Collection Price Per Day': 'Post Collection Price Per Day',
    'Post collection by Day': 'Post collection by Day',
    'Days with free cancellation': 'Days with free cancellationø',
    'Allowed free fine cancellation per year':
        'Allowed free fine cancellation per year',
    'Car user type': 'Car user type',
    "Keywords (comma-separated, e.g. 'taxi, cab')":
        "Keywords (comma-separated, e.g. 'taxi, cab')",
    'Fine restrictions and settings for this parking lot (App)':
        'Fine restrictions and settings for this parking lot (App)',
    'Confirm licenseplate': 'Confirm licenseplate',
    'No Connected Users': 'No Connected Users',
    'Monthly billing': 'Monthly billing',
    'Billing Period': 'Billing Period',
    'Minimum Rent': 'Minimum Rent',
    'Minimum Rent Period': 'Minimum Rent Period',
    '+ Add Coordinate': '+ Add Coordinate',
    '− Remove Last': '− Remove Last',
    'Shift report': 'Shift report',
    'Organisation and parkinglots': 'Organisation and parkinglots',
    'Select an organization to see their parking lots':
        'Select an organization to see their parking lots',
    'User and permissions': 'User and permissions',
    'Permission Preset': 'Permission Preset',
    'Admin User': 'Admin User',
    'Basic Dashboard User': 'Basic Dashboard User',
    'Reception user': 'Reception user',
    'Subscription user': 'Subscription user',
    'Parking Guard user': 'Parking Guard user',
    'Attention Permit': 'Attention Permit',
    'Alarm Permit': 'Alarm Permit',
    'Session Permit': 'Camera Permit',
    'Ticket rules': 'Ticket rules',
    'Finance Reports': 'Finance Reports',
    'Camera scan statistics': 'Camera scan statistics',
    'Camera spot statistics': 'Camera spot statistics',
    'Customer subscriptions': 'Customer subscriptions',
    'Create Ticket Rule': 'Create Ticket Rule',
    Rulesets: 'Rulesets',
    'Fee price (DKK)': 'Fee price (DKK)',
    'Additional hours': 'Additional hours',
    'Before you upload, make sure your': 'Before you upload, make sure your',
    'Image is no more than 4mb big': 'Image is no more than 4mb big',
    'Handle Camera Fine': 'Handle Camera Fine',
    'Min park time': 'Min park time',
    Missing: 'Missing',
    'Scan Date': 'Scan Date',
    Direction: 'Direction',
    'Review and Action': 'Review and Action',
    'Total Permits': 'Total Permits',
    'Total Subscriptions': 'Total Subscriptions',
    'Change Password': 'Change Password',
    'Current Password': 'Current Password',
    'Confirm new password': 'Confirm new password',
    enableAll: 'Enable all',
    'Card details': 'Card details',
    'Current Permits': 'Current permits',
    'Next Payment': 'Next Payment',
    Accept: 'Accept',
    'Enter your name': 'Enter your name',
    'Enter your address': 'Enter your address',
    'Enter your phonenumber': 'Enter your phonenumber',
    'Enter your email address': 'Enter your email address',
    'Enter your license plate': 'Enter your license plate',
    'Every day': 'Every day',
    'Max permits per subscription': 'Max permits per subscription',
    'Subscription Limit': 'Subscription limit for parkinglot',
    'Subscription Rule': 'Subscription Rule',
    'Add timerule': 'Add timerule',
    'Start Time': 'Start Time',
    'End Time': 'End Time',
    'Subscription information': 'Subscription information',
    'Show Expired': 'Show Expired',
    'Please select a company': 'Please select a company',
    "Customer's parking lots": "Customer's parking lots",
    'User Identity': 'User Identity',
    Identity: 'Identity',
    'User Identities': 'User Identities',
    'No identities for user': 'No identities for user',
    'Fine Details': 'Fine Details',
    'QR Code': 'QR Code',
    'Parking Lot Information': 'Parking Lot Information',
    'Active Parking lots': 'Active Parking lots',
    'Inactive Parking lots': 'Inactive Parking lots',
    'No parking lot statistics available.':
        'No parking lot statistics available.',
    'Parkinglot Id': 'Parkinglot Id',
    'No one has commented or changed status yet.':
        'No one has commented or changed status yet.',
    'Leave a note on the incident': 'Leave a note on the incident',
    'Update Fines': 'Update Fines',
    'This will reset the password and email the new password. Do you want to continue?':
        'This will reset the password and email the new password. Do you want to continue?',
    'Parking Info': 'Parking Info',
    Organizations: 'Organizations',
    Organization: 'Organization',
    'Payout Details': 'Payout Details',
    'Bank Registration Number': 'Bank Registration Number',
    'Bank Account Number': 'Bank Account Number',
    '% for parking guard': '% for parking guard',
    '% for customer': '% for customer',
    '% for PK': '% for OPARKO',
    '% for operator': '% for operator',
    'Charge Distributions': 'Charge Distributions',
    'There are no Parking Lots': 'There are no Parking Lots',
    'There are no Users': 'There are no Users',
    'External Organizations': 'External Organizations',
    'Select image': 'Select image',
    'Outside booth': 'Outside booth',
    'No permit to the parking area': 'No permit to the parking area',
    'P-disc exceeded': 'P-disc exceeded',
    'Parking or stopping in prohibited area':
        'Parking or stopping in prohibited area',
    'Parking in fire lane': 'Parking in fire lane',
    'Handicap booth without permission': 'Handicap booth without permission',
    "Organization's Parking Lots": "Organization's Parking Lots",
    'Choose Parking bays': 'Choose Parking bays',
    'Permanent user': 'Permanent user',
    'New Permit': 'New Permit',
    'Update Permit': 'Update Permit',
    'Created for user': 'Created for user',
    Notes: 'Notes',
    'Permit Information': 'Permit Information',
    'Date not assigned': 'Date not assigned',
    'Note from creation': 'Note from creation',
    'Created at': 'Created at',
    'Updated at': 'Updated at',
    'Address ID': 'Address ID',
    'Address name': 'Address name',
    'Arrival date': 'Arrival date',
    'Arrival Date': 'Arrival Date',
    'Depart. Date': 'Depart. Date',
    'Depart. date': 'Depart. date',
    Camera: 'Camera',
    'Camera note': 'Camera note',
    'Other - Leave a note': 'Other - Leave a note',
    'Total parking time': 'Total parking time',
    Approve: 'Approve',
    Decline: 'Decline',
    Back: 'Back',
    'Employee Paid Ticket': 'Employee Paid Ticket',
    'Street name': 'Street name',
    'Postal code': 'Postal code',
    'Fine price': 'Fine price',
    'Profile Image': 'Profile Image',
    'Parking Terms': 'Parking Terms',
    'No results found': 'No results found',
    'Buffer time in minutes': 'Buffer time in minutes',
    'New active permits': 'New active permits',
    'Active permits': 'Active permits',
    'Total active permits for the chosen period':
        'Total active permits for the chosen period',
    'Daily average for the chosen period':
        'Daily average for the chosen period',
    'Month View': 'Month View',
    'Day View': 'Day View',
    'Duration of permits': 'Duration of permits',
    selected: 'selected',
    Distance: 'Distance',
    'Organization type': 'Organization type',
    'Organization address': 'Organization address',
    'Organization details': 'Organization details',
    'Create Organization': 'Create Organization',
    'Comment added by': 'Comment added by',
    'Status changed from': 'Status changed from',
    'Status changed by': 'Status changed by',
    'Type changed from': 'Type changed from',
    'Start Date changed from': 'Start Date changed from',
    'End Date changed from': 'End Date changed from',
    'Reg. number has been changed to': 'Reg. number has been changed to',
    'New parking fee ID:': 'New parking fee ID:',
    'Fine cancelled by': 'Fine cancelled by',
    'changed from': 'changed from',
    'Not defined': 'Not defined',
    'Not Defined': 'Not Defined',
    'Self ticketing': 'Self ticketing',
    Combination: 'Combination',
    'P-guard': 'P-guard',
    'Registered before': 'Registered before',
    'Send receipt copy': 'Send receipt copy',
    'You already have a user': 'You already have a user',
    'Login to purchase an extra subscription':
        'Login to purchase an extra subscription',
    'Missing payment in min': 'Missing payment in minutes',
    'Missing payment in days': 'Missing payment in days',
    'Missing price': 'Missing price',
    'Open Subscriber': 'Open Subscriber',
    'Every permit row is clickable and show data in Permit Modal':
        'Every permit row is clickable and show data in Permit Modal',
    'Choosing multiple parking lots creates a singular permit for each address selected':
        'Choosing multiple parking zones creates a singular permit for each zone selected',
    'These rules only affects the permits created from the app, not permits created by admin from Web':
        'These rules only affects the permits created from the app, not permits created by admin from Web',
    'No images to show!': 'No images to show!',
    'There has not yet been uploaded any images':
        'There has not yet been uploaded any images',
    PermitGuestRuleDescription:
        'Max active permits: 0 = unlimited. Otherwise, enter a number for the maximum permits.',
    'Permit length: The maximum number of minutes a permit can be created for':
        'Duration of permits: 0 = unlimited. Otherwise, enter the maximum number of minutes a permit can be created for',
    Location: 'Location',
    'Additional images': 'Additional images',
    'Fine rules': 'Fine rules',
    'Enforcement type': 'Enforcement type',
    'Offense restrictions': 'Offense restrictions',
    'Select which offences can be used on this parking lot.':
        'Select which offences can be used on this parking lot.',
    'Permit rules': 'Permit rules',
    Permitrules: 'Permit rules',
    'Connected organisations & users': 'Connected organisations and users',
    'Profile image': 'Profile image',
    'ID generated upon creation': 'ID generated upon creation',
    'Bank name': 'Bank name',
    'Bank country': 'Bank country',
    'Billing Email': 'Billing Email',
    'Payment frequency': 'Payment frequency',
    'Agreed by': 'Agreed by',
    'Agreed on (Date - Start)': 'Agreed on (Date - Start)',
    'Agreed on (Date - End)': 'Agreed on (Date - End)',
    'Connected parking lots & users': 'Connected parking lots and users',
    'Terms of service': 'Terms of service',
    privateLabelSettings: 'Private label settings',
    privateLabelLogo: 'Private label logo',
    complaintEmail: 'Complaint e-mail',
    'complaints@example.com': 'complaints@example.com',
    complaintPhoneNumber: 'Complaint phone number',
    appServiceEmail: 'App service e-mail',
    appServicePhone: 'App service phone',
    addPhoneHours: 'Add phone hours',
    showDeleted: 'Show deleted',
    counterDataRetention: 'Data Retention',
    counterDataRetentionPeriod: 'Counter data retention period',
    retentionDays30: '30 days',
    retentionDays60: '60 days',
    retentionDays90: '90 days',
    retentionDays180: '180 days',
    retentionDays365: '1 year (365 days)',
    retentionDays730: '2 years (730 days)',
    featureFlags: 'Feature flags',
    featureModules: 'Modules',
    featureSettings: 'Settings',
    featureOthers: 'Others',
    noFeatureFlagsConfigured: 'No feature flags configured',
    featureFlagsAvailableAfterCreate:
        'Feature flags can be configured after the organisation has been created. Save the organisation first, then reopen it to edit feature flags.',
    caseportal: 'Case portal',
    caseportalUrl: 'Case portal URL',
    upload: 'Upload',
    paymentFrequency: 'Payment frequency',
    paymentFrequencyMonthly: 'Monthly',
    paymentFrequencyQuarterly: 'Quarterly',
    paymentFrequencyYearly: 'Yearly',
    feat_others: 'Others',
    feat_fine: 'Fines',
    feat_fine_create: 'Create fine',
    feat_fine_update: 'Update fine',
    feat_fine_bulk_change: 'Bulk change',
    feat_fine_cancel: 'Cancel fine',
    feat_fine_print: 'Print fine',
    feat_fine_export: 'Export fines',
    feat_fine_qr_fine: 'QR fine',
    feat_fine_settlement_dates: 'Settlement dates',
    feat_fine_yolo: 'YOLO',
    feat_permit: 'Permits',
    feat_permit_create: 'Create permit',
    feat_permit_delete: 'Delete permit',
    feat_permit_export: 'Export permits',
    feat_permit_update: 'Update permit',
    feat_permit_types: 'Permit types',
    feat_user: 'Users',
    feat_user_create: 'Create user',
    feat_user_delete: 'Delete user',
    feat_user_update: 'Update user',
    feat_user_export: 'Export users',
    feat_user_access_group_address: 'Access group address',
    feat_user_access_group_auth_permissions: 'Access group permissions',
    feat_user_access_group_members: 'Access group members',
    feat_parkinglot: 'Parking lots',
    feat_parkinglot_create: 'Create parking lot',
    feat_parkinglot_update: 'Update parking lot',
    feat_parkinglot_delete: 'Delete parking lot',
    feat_parkinglot_export: 'Export parking lots',
    feat_camera: 'Cameras',
    feat_camera_create: 'Create camera',
    feat_camera_settings: 'Camera settings',
    feat_camera_scanning: 'Camera scanning',
    feat_subscription: 'Subscriptions',
    feat_subscription_create: 'Create subscription',
    feat_subscription_delete: 'Delete subscription',
    feat_subscription_export: 'Export subscriptions',
    feat_ticket: 'Tickets',
    feat_ticket_create: 'Create ticket',
    feat_ticket_update: 'Update ticket',
    feat_ticket_delete: 'Delete ticket',
    feat_organisation: 'Organisation',
    feat_organisation_create: 'Create organisation',
    feat_organisation_update: 'Update organisation',
    feat_finance: 'Finance',
    feat_finance_report_create: 'Create finance report',
    feat_training_module: 'Training module',
    feat_api_doc: 'API documentation',
    feat_dashboard_statistics: 'Dashboard statistics',
    feat_dashboard_statistics_fine_activity: 'Fee overview',
    feat_dashboard_statistics_oparkogo_activity: 'OparkoGo activity',
    feat_dashboard_statistics_camera_occupancy: 'Camera occupancy',
    feat_dashboard_statistics_active_permits: 'Active permits',
    feat_dashboard_statistics_app_activity: 'App activity',
    feat_dashboard_statistics_user_information: 'User information',
    feat_dashboard_statistics_parkinglot_information: 'Parking lot information',
    feat_oparkogo: 'OparkoGo',
    feat_public_oparko_link: 'Oparko public link',
    feat_faq: 'FAQ',
    trainingModules: 'Training modules',
    apiDocumentation: 'API documentation',
    createCamera: 'Create camera',
    createFines: 'Create fines',
    bulkChangeFines: 'Bulk change fines',
    createPermits: 'Create permits',
    parkingInfoOnDashboard: 'Parking info on dashboard',
    fineSearchOnDashboard: 'Fine search on dashboard',
    publicPages: 'Public pages',
    mapOfParkingSpaces: 'Map of parking spaces',
    oparkoComLink: 'Oparko.com link',
    standardLoginOnly: 'Standard login only',
    featureLabels: 'Labels',
    permissionsLabel: 'Permissions label',
    parkingSpacesLabel: 'Parking spaces label',
    mapLabel: 'Map label',
    feesLabel: 'Fees label',
    feeActivityLabel: 'Fee activity label',
    availableLanguages: 'Available languages',
    'Expose to different backoffices': 'Expose to different backoffices',
    exposeToBackoffices: 'Expose {{name}} to the following backoffices',
    'Belongs to backofficeID': 'Belongs to backofficeID',
    'Privacy policy URL': 'Privacy policy URL',
    'Complaint E-mail': 'Complaint E-mail',
    VAT: 'VAT',
    Both: 'Both',
    Collection: 'Collection',
    'Collection By Day': 'Collection By Day',
    'Set to now': 'Set to now',
    'Add spot': 'Add spot',
    'No limit': 'No limit',
    'Subscription rules': 'Subscription rules',
    'Spot limit': 'Spot limit',
    'Parking subscription': 'Subscription rule',
    'Section id': 'Section ID',
    'Subscription rule ID': 'Subscription rule ID',
    'Create multiple permits': 'Create multiple permits',
    'Cancel immediately': 'Cancel immediately',
    Skip: 'Skip',
    Finish: 'Finish',
    'Backoffice organisations': 'Backoffice organisations',
    'User Count': 'User Count',
    'Address Count': 'Address Count',
    // Finance
    DKK: 'DKK',
    pcs: 'pcs.',
    k: 'k',
    Revenue: 'Revenue',
    'Paid Permits': 'Paid Permits',
    'Coming soon': 'Coming soon',
    'Total revenue': 'Total revenue in DKK',
    totalRevenueSubtitle: 'Combined revenue across all sources',
    'Total paid out': 'Total paid out',
    'Total outstanding': 'Total unsettled',
    'Revenue sources for permits in DKK': 'Revenue sources for permits in DKK',
    'Permits per parking operator': 'Permits per parking operator in DKK',
    'Number of parking tickets made through each parking operator.':
        'Number of parking tickets made through each parking operator.',
    'Subtext: This shows the economy and the number of parking tickets':
        'This shows the economy and the number of parking tickets for each parking operator in the area, so the revenue distribution can be seen for the selected period.',
    'You have no permits to show': 'You have no permits to show',
    'Revenue by type in DKK': 'Revenue by type in DKK',
    'Revenue distribution from the car parks owned by your organisation. The graph visualizes the turnover of the different products offered.':
        'Revenue distribution from the car parks owned by your organisation. The graph visualizes the turnover of the different products offered. ',
    'Fines by status': 'Fines by status in DKK',
    fineShares: 'Fine shares',
    'Number of fines': 'Number of fines',
    'Customer share': 'Customer share',
    'P-Warden share': 'P-Warden share',
    'OPARKO share': 'OPARKO share',
    'Total Price': 'Total Price',
    Fees: 'Fees',
    OpenFees: 'Open Fees',
    PaidFees: 'Paid Fees',
    SettledFees: 'Settled Fees',
    CancelledFees: 'Cancelled Fees',
    'No Records found': 'No Records found',
    financeNoRecordsHint:
        'Try adjusting the date range or filters to see data.',
    'Post collections': 'Post collections',
    'Post collection': 'Post collections',
    'Distribution key': 'Distribution key',
    'Camera fees': 'Camera fees',
    'Parking permit sales': 'Parking permit sales',
    'Guard fees': 'Guard fees',
    'Subscription sales': 'Subscription sales',
    'Self-ticketing fees': 'Self-ticketing',
    Earning: 'Earning',
    Payout: 'Payout',
    Invoice: 'Invoice',
    'Report date': 'Report date',
    finance_revenue_barchart:
        'Revenue in DKK per month for the current year separated by revenue type',

    revenue_by_type_explanation:
        'Revenue is based on the revenue generated from the parking lots that your organization has ownership of. The chart visualizes the revenue for each revenue type.',
    'reveneue_sub_text_sub: abo':
        'This shows the economy and the number of subscriptions for each service provider in the area, so the revenue distribution can be observed for the selected period.',
    'Fines: Every fine that is paid or settled':
        'Fines: Every fine that is paid or settled',
    'Permits: Every permit that is paid': 'Permits: Every permit that is paid',
    'Subscriptions: Every payment on all subscriptions':
        'Subscriptions: Every payment on all subscriptions',
    post_collection_explanation: `Post collection: Calculated as 'collection fee' + 'price per hour' * 'hours parked more than permitted' and is an extra charge to parkers that have parked longer than their permits allowed them too and serves as an alternative to parking fees.`,

    'Active: status explained':
        'Active: A fine that has been created but is still in process',
    'Cancelled: status explained':
        'Cancelled: Charges cancelled by you or OPARKO',
    'Paid: status explained': 'Paid: The fee is paid to OPARKO',
    'Settled: status explained': 'Settled: Fine have been paid to customer',
    'Protected: status explained': 'Protected: Its on hold for now.',
    'Debt collection/Collectia: status explained':
        'Debt collection/Collectia: Debt collection is ongoing.',

    permit_revenue_sources_explanation:
        'The amount of revenue in DKK, that has been made on permits for each parking operator.',
    number_of_permits_per_parking_operator_explained:
        'The number of permits that have been made by each of the parking operators.',

    fine_status_distribution_explanation:
        'The percentage distribution of fine statuses.',
    'Please wait, your data is being prepared...':
        'Please wait, your data is being prepared...',
    'ex-VAT': 'ex-VAT',
    Period: 'Period',
    Subject: 'Subject',
    Pages: 'Pages',
    Number: 'Number',
    Amount: 'Amount',
    'Service and operation of camera system':
        'Service and operation of camera system',
    'Batch Run Reports': 'Batch Run Reports',
    "Cannot send invoice while there's a pending report for earlier period":
        "Cannot send invoice while there's a pending report for earlier period",
    'Last Batch Run': 'Last Batch Run',
    // Statistic
    fee_search: 'Old App',
    fine_search: 'App - Fine created',
    permit_search: 'App - Permit created',
    permit_created: 'App - Permit created',
    scanner_used: 'App - Scanner used',
    'Shows a graph of app events for multiple days, sorted by hours.':
        'Shows a graph of app events for multiple days, sorted by hours.',
    'Shows a graph of app events, sorted by dates.':
        'Shows a graph of app events, sorted by dates.',
    'The use of the old app.': '- The use of the old app.',
    'Creation of permits in the oparko app.':
        '- Creation of permits in the oparko app.',
    'Creation of Fines in the oparko app':
        '- Creation of Fines in the oparko app',
    'Scanning of license plates in the oparko app.':
        '- Scanning of license plates in the oparko app.',
    'Permits and Subscriptions per month':
        'Permits and Subscriptions per month',
    'Show Day Graph Date': 'Show Day Graph Date',

    'Occupancy by permits': 'Occupancy by permits',
    'Total parking spots': 'Total parking spots',
    'Permits: Shows the amount of permits by period. If more than one week is chosen, the sum of all weeks will be shown on a give period on a weekday.':
        'Permits: Shows the amount of permits by period. If more than one week is chosen, the sum of all weeks will be shown on a give period on a weekday.',
    'Total parking spots: Shows the total amount of parking spots':
        'Total parking spots: Shows the total amount of parking spots',
    'Average hourly occupancy over the selected period.':
        'Average hourly occupancy over the selected period.',
    'Average daily occupancy over the selected period.':
        'Average daily occupancy over the selected period.',
    'Average monthly occupancy over the selected period.':
        'Average monthly occupancy over the selected period.',
    'Average for the chosen period': 'Average for the chosen period',
    'Fines for the chosen period': 'Fee for the chosen period',
    'Average fines per day': 'Average fees per day',
    Occupancy: 'Occupancy',
    'Highest Occupancy': 'Highest Occupancy',
    'Lowest Occupancy': 'Lowest Occupancy',
    'Highest avg for the days in the period.':
        '- Highest avg for the days in the period.',
    'Lowest avg for the days in the period.':
        '- Lowest avg for the days in the period.',
    'Avg for the days in the period.': '- Avg for the days in the period.',
    'Show Spot Scan': 'Showing Spot Scan',
    'Show Camera Scan': 'Showing Camera Scan',
    no_permit: 'No Permit',
    permit: 'Permit',
    ticket: 'Ticket',
    subscription: 'Subscription',
    'Too many organisations selected': 'Too many organisations selected',
    'Can not generate report for the selected parking lots.':
        'Can not generate report for the selected parking lots.',
    'Can not generate report for the selected organisations.':
        'Can not generate report for the selected organisations.',

    Average: 'Average',
    Highest: 'Highest',
    Lowest: 'Lowest',
    'Hourly camera activity count': 'Hourly camera activity count',
    'Daily camera activity count': 'Daily camera activity count',
    'Camera activity': 'Camera activity',
    'App activity': 'App activity',
    Arrivals: 'Arrivals',
    Departures: 'Departures',
    'Show only fine activity': 'Show only fine activity',
    'Hourly app activity count': 'Hourly app activity count',
    'Daily app activity count': 'Daily app activity count',
    Scanner: 'Scanner',
    'Fine created': 'Fine created',

    // Date Picker
    Between: 'Between',
    From: 'From',
    To: 'To',
    Unit: 'Unit',
    Max: 'Maximum count',
    Min: 'Minimum count',
    Prior: 'Prior',
    Custom: 'Custom',
    Today: 'Today',
    'Since Yesterday': 'Since Yesterday',
    'This Week': 'This Week',
    Anytime: 'Anytime',
    'Last month': 'Last month',
    'Last 3 months': 'Last 3 months',
    'Last 12 months': 'Last 12 months',
    'Start Date cannot be after End Date':
        'Start Date cannot be after End Date',
    'Date cannot be after today': 'Date cannot be after today',
    Details: 'Details',
    Ticket_Rule: 'Ticket Rule',
    Rule_sets: 'Rule Sets',
    InformationGuide: 'Information Guide',
    RuleSetsDescription:
        "Under 'Rule Sets', you can define unique ticket rules. You can make as many as you need:",
    PickDays: 'Choose which days the rules apply for',
    PickTime: 'Choose the time of day',
    PickUnit:
        'Choose the unit followed by the "minimum" and "maximum" number of hours/days that can be purchased with this rule',

    'Parking time exceeded': 'Parking time exceeded',
    'The permit will be made for every parking lot chosen, and based on the users start and end date.':
        'The permit will be made for every parking lot chosen, and based on the users start and end date.',

    // Table Values
    company: 'company',
    private: 'private',
    Inactive: 'Inactive',
    Active: 'Active',
    Paid: 'Paid',
    'Not paid': 'Not paid',
    Settled: 'Settled',
    Hidden: 'Hidden',
    Cancelled: 'Cancelled',
    Protected: 'Protected',
    'Guest parking': 'Guest parking',
    Ticket: 'Ticket',
    'Paid Ticket': 'Paid Ticket',
    'Only for backoffice': 'Only for backoffice',
    'Editable permit': 'Redigerbar tilladelse',
    Employee: 'Employee',
    'Permanent permit': 'Permanent permit',
    'Debt collection': 'Debt collection',
    Collectia: 'Collectia',
    'Active - System': 'Active - system',
    'Active - handled manually': 'Active - handled manually',
    'Active - Manuel': 'Active - Manuel',
    'Under - Recovery': 'Under - Recovery',
    'Settled with parking guard': 'Settled with parking guard',
    'Cancelled - Pending approval': 'Cancelled - Pending approval',
    'Fine Exported': 'Fine Exported',
    'Export Failed': 'Export Failed',
    'Time Frame': 'Time Frame',
    'Create Permit Reason': 'Create Permit Reason',
    permitTypes: 'Permit Types',
    createPermitType: 'Create Permit Type',
    approval: 'Approval',
    neutral: 'Neutral',
    disapproved: 'Disapproved',
    approved: 'Approved',
    nameEnglish: 'Name English',
    keyValues: 'Key Values',
    lookupInfo: 'Lookup Info',
    lookupTitle: 'Lookup Title',
    regnoEditable: 'Regno Editable',
    confirmDelete: 'Confirm Delete',
    None: 'None',
    'Multi Select': 'Multi Select',
    'QR App Fine': 'QR App Fine',
    'Print App Fine': 'Print App Fine',
    'Send App Fine': 'Send App Fine',
    'Camera Fine': 'Camera Fine',
    'Camera Collection': 'Camera Collection',
    'Camera Collection By Day': 'Camera Collection By Day',
    Parent: 'Parent',
    'Parent ID': 'Parent ID',
    PaymentZone: 'Payment Zone',
    ResidentZone: 'Resident Zone',
    FlexParkingZone: 'Flex Parking Zone',
    ResidentStreetsZone: 'Resident Streets Zone',
    PatrolArea: 'Patrol Area',
    'addressTypeName.parkingLot': 'Parking lot',
    'addressTypeName.group': 'Group/Parent',
    'addressTypeName.parkingSpot': 'Parking spot',
    'addressTypeName.test': 'Test',
    'addressTypeName.paymentZone': 'Payment zone',
    'addressTypeName.residentZone': 'Resident zone',
    'addressTypeName.flexParkingZone': 'Flex parking zone',
    'addressTypeName.residentStreetsZone': 'Resident streets zone',
    'addressTypeName.patrolArea': 'Patrol area',
    showPatrolAreas: 'Show Patrol Areas',
    showParkingZones: 'Show Parking Zones',
    addressType: 'Address Type',
    'Show street name in app': 'Show street name in app',
    'Clean Fine Reasons': 'Clean Fine Reasons',
    'Create Clean Fine Reasons': 'Create Clean Fine Reasons',
    'Permit Limits': 'Permit Limits',
    'Wrong Doings': 'Wrong Doings',
    'Create Wrong Doing': 'Create Wrong Doing',
    'Wrong Doing Details': 'Wrong Doing Details',
    Translations: 'Translations',
    Actions: 'Actions',
    'Add translation...': 'Add translation...',
    'Removal Reason': 'Removal Reason',
    'Cleaning Fine Reason Details': 'Clear Fine Reason Details',
    'Add Key-Value': 'Add Key-Value',
    Key: 'Key',
    Value: 'Value',
    'Remove Key-Value': 'Remove Key-Value',
    'Add New Value': 'Add New Value',
    'Print Template': 'Print Template',
    Parking_status: 'Parking Status',
    Applies_to: 'Applies To',
    Show_in_app: 'Show in app fine list',
    Can_cancel: 'Possible to cancel in platform',
    Can_pay: 'Possible to pay',
    Can_see_documentation: 'Can see documentation',
    Public_message: 'Public message',
    Public_message_placeholder: 'Message shown to the citizen (optional)',
    Alias_of: 'Alias of',
    Show_in_app_graph: 'Show in app graphs',
    Graph_type_fee: 'Fine',
    Graph_type_cancelled: 'Cancelled',
    Graph_type_hidden: 'Hidden',
    'Print Templates': 'Print Templates',
    'Create Template': 'Create Template',
    'Create Templates': 'Create Templates',
    'Fine Print Templates': 'Fine Print Templates',
    'Last Updated': 'Last Updated',
    'Filter organsisations by name or id':
        'Filter organsisations by name or id',
    'Select own organisation': 'Select own organisation',
    userShiftTitle: 'User shift',
    userShiftActiveUsersInPeriod: 'Active users in period',
    userShiftSelectDateRangePrompt:
        'Select a date range and click Search to view shift activity.',
    userShiftLoadFailedMessage:
        'Failed to load shift activity. Please try again.',
    userShiftModeTooltip:
        'Overview shows organisation-wide activity. P-wardens shows per-user heatmaps.',
    userShiftReportDownloadedSuccessfully: 'Report downloaded successfully.',
    userShiftReportTruncatedMaxRows:
        'Report was truncated because it exceeded the maximum row limit.',
    userShiftActiveDays: 'Active Days',
    userShiftEventsInPeriod: 'Events for the selected period',
    userShiftAvgPerDay: 'Events per day',
    userShiftAvgEventsPerDay: 'Average per day',
    userShiftMostLeastActive: 'Most / Least Active',
    userShiftPeakActiveWardens: 'Peak Active Wardens',
    events: 'events',
    Less: 'Less',
    userShiftMoreEvents: 'More events',
    userShiftPatrolEvents: 'Patrol events',
    userShiftPatrolEventsHint: 'Fines, permits & scans logged on shift',
    userShiftTotalPatrolEvents: 'Total patrol events',
    userShiftActiveTime: 'Active time',
    userShiftActiveTimeHint: 'Time between first and last patrol event',
    userShiftActiveLessThanMinute: '< 1 min',
    userShiftWardensOnShift: 'P-wardens on shift',
    userShiftUserDaysActive: 'Days active',
    userShiftLastActive: 'Last active',
    userShiftNoActivityDash: '—',
    userShiftTopActiveUsersNote:
        'Note: Without user selection, the top 10 most active users are shown by default',
    Shift: 'Shift',
    userShiftNoActivityFoundForPeriod: 'No activity found for this period.',
    userShiftShowPWardens: 'Show P-wardens',
    userShiftShowPWardensCount: 'Show {{count}} P-wardens',
    userShiftShowingPWardens: 'Showing {{shown}} of {{total}} parking wardens',
    userShiftPwardensDescription:
        'P-wardens are parking enforcement officers. Enable this to view individual per-officer heatmaps instead of the organisation-wide overview.',
    userShiftPwardensModeActive: 'Per-user view',
    userShiftSortBy: 'Sort by',
    userShiftSortByEvents: 'Total events',
    userShiftSortByName: 'Name',
    userShiftSortByLastActive: 'Last active',
    'Notification Templates': 'Notification Templates',
    'Notification Template': 'Notification Template',
    Resource: 'Resource',
    'Enter body content': 'Enter body content',
    'Enter title': 'Enter title',
    'Mobile Preview': 'Mobile Preview',
    'Economic Invoice Period': 'Economic Invoice Period',
    '% to Customer': '% to Customer',
    '% to Oparko': '% to Oparko',
    'Cancellations of fines': 'Cancellations of fines',
    'Total subscription': 'Total subscription',
    Summary: 'Summary',
    'OPARKO cut': 'OPARKO cut',
    'Customer cut': 'Customer cut',
    Org: 'Org',
    ORG: 'ORG',
    'Org mail': 'Org mail',
    'Org account info': 'Org account info',
    'Org ecn': 'Org ecn',
    'Economic department ID': 'Economic department ID',
    'Grouped addresses': 'Grouped addresses',
    'Invoice created by': 'Invoice created by',
    'Invoice sent date': 'Invoice sent date',
    'Due date (Days added to sent date)': 'Due date (Days added to sent date)',
    Reject: 'Reject',
    'Park Time': 'Park Time',
    'Create Settings': 'Create Settings',
    number: 'number',
    'Camera Count': 'Camera Count',
    'General Information': 'General Information',
    'Gateway Address Id': 'Gateway Address Id',
    'Multiple Addresses': 'Multiple Addresses',
    'Pause Start': 'Pause Start',
    'Pause End': 'Pause End',
    'Pause Camera': 'Pause Camera',
    'Gateway Control': 'Gateway Control',
    'Check on Exit Only': 'Check on Exit Only',
    'Stream and scans': 'Stream and scans',
    'Start Preview': 'Start Preview',
    'Detection Zone': 'Detection Zone',
    'Entrance Overlay': 'Entrance Overlay',
    'Exit Overlay': 'Exit Overlay',
    'Detection & Placement Settings': 'Detection & Placement Settings',
    'Shared Settings': 'Shared Settings',
    'Update Camera Setting': 'Update Camera Setting',
    'New Camera Setting': 'New Camera Setting',
    'Generates Camerafines': 'Generates Camerafines',
    'EasyPark Auto Enabled': 'EasyPark Auto Enabled',
    'Enable "Park now, pay later"': 'Enable "Park now, pay later"',
    'Skip Fine for Reception Permits': 'Skip Fine for Reception Permits',
    '(if permit valid between entry and exit)':
        '(if permit valid between entry and exit)',
    'Minimum Park Time (s)': 'Minimum Park Time (s)',
    'Oparko Go Minimum Park Time (s)': 'Oparko Go Minimum Park Time (s)',
    'Max Park Time': 'Max Park Time',
    'Buffer Percentage': 'Buffer Percentage',
    'Buffer Time (s)': 'Buffer Time (s)',
    'Entrance Angle': 'Entrance Angle',
    'Entrance Tolerance': 'Entrance Tolerance',
    'Exit Angle': 'Exit Angle',
    'Exit Tolerance': 'Exit Tolerance',
    Apply: 'Apply',
    'Connection Information': 'Connection Information',
    'Last Sync Date': 'Last Sync Date',
    'Camera Scan List': 'Camera Scan List',
    'Camera Fine ID': 'Camera Fine ID',
    'Camera Name': 'Camera Name',
    'Other Reg. No. List': 'Other Reg. No. List',
    'Handle Camera Scan': 'Handle Camera Scan',
    'Registration Number': 'Registration Number',
    'Other Registration Numbers': 'Other Registration Numbers',
    'No other registration numbers': 'No other registration numbers',
    'Scan Time': 'Scan Time',
    'Scan Direction': 'Scan Direction',
    'Address Details': 'Address Details',
    'Camera Details': 'Camera Details',
    'Camera ID': 'Camera ID',
    'External Camera ID': 'External Camera ID',
    'Using the API': 'Using the API',
    Groups: 'Groups',
    'User Settings': 'User Settings',

    // Validation
    'Issues: ': `Issues: `,

    'no Name chosen, ': 'no Name chosen, ',
    'no Organization chosen, ': 'no Organization chosen, ',
    'no Street Name chosen, ': 'no Street Name chosen, ',
    'no Street Number chosen, ': 'no Street Number chosen, ',
    'no Postal Code chosen, ': 'no Postal Code chosen, ',
    'no City chosen, ': 'no City chosen, ',
    'no Latitude chosen, ': 'no Latitude chosen, ',
    'Latitude must be above -90, ': 'Latitude must be above -90, ',
    'Latitude must be below 90, ': 'Latitude must be below 90, ',
    'no Longitude chosen, ': 'no Longitude chosen, ',
    'Longitude must be above -90, ': 'Longitude must be above -90, ',
    'Longitude must be below 90, ': 'Longitude must be below 90, ',
    'no Type chosen, ': 'no type chosen, ',
    'parking terms do not accept more than 255 character':
        'parking terms do not accept more than 255 character',

    Reset: 'Reset',
    'Accept our terms': 'Accept our terms',
    'Enter your registration no.': 'Enter your registration no.',
    'Indtast dit fulde navn': 'Enter your full name',
    'phone number': 'phone number',
    email: 'email',
    'Enter e-mail': 'Enter e-mail',
    'then press ok': 'and then press create',
    'Your permit ends': 'Your permit ends',
    'by today 23:59': 'by today 23:59',
    'by the chosen date 23:59': 'by the chosen date 23:59',
    after: 'after',
    'after the creation': 'after the creation',
    minutes: 'minutes',
    and: 'and',
    until: 'at',
    'ends in': 'in ',
    "Not Found Error: It's not allowed to buy a ticket with the time unit provided":
        'It is not allowed to buy a ticket with the time unit provided. Please check the applicable rules and try again.',
    'An error occurred, please try again':
        'An error occurred, please try again',

    'Reg. no.': 'Reg. no.',
    'Phone number': 'Phone number',
    Subscription_percentage_not_within_range: `Subscription '% for OPARKO' must be within the range 0% to 100%`,
    Permit_percentage_not_within_range: `Permit '% for OPARKO' must be within the range 0% to 100%`,
    Camera_control_percentage_not_within_range: `Camera control '% for OPARKO' must be within the range 0% to 100%`,
    Selfticketing_percentage_not_within_range: `Self ticketing '% for OPARKO' must be within the range 0% to 100%`,
    Guard_control_percentage_not_within_range: `Guard control '% for OPARKO' must be within the range 0% to 100%`,
    authenticationFailed: 'Authentication failed. Please try again.',
    'validation.statusMissing': 'Please select a status.',
    'validation.belongsToMissing': 'Please select the user this belongs to.',
    'validation.typeMissing': 'Please select a permit type.',
    'validation.noVehicles': 'Please add at least one vehicle.',
    'validation.missingCountryCode': 'Please select a country code.',
    'validation.invalidRegNo': 'Please enter a valid registration number.',
    'validation.noParkingLot': 'Please select a parking lot.',
    'validation.noEmail': 'Please enter an email address.',
    'validation.endDateRequired':
        'Please provide an end date, or mark this as permanent.',
    'validation.endDateTooOld': 'Please enter an end date after 1970.',
    'validation.endBeforeStart': 'End date must be on or after the start date.',
    'validation.startDateTooOld': 'Please select a start date.',
    'validation.invalidTimeRule': 'Please enter a start date after 1970.',
    'validation.startDateEmpty': 'Please select a start date.',
    'validation.endDateEmpty': 'Please select an end date.',
    'validation.endAfterStart': 'End date must be after the start date.',
    'validation.missingAddress': 'Please select an address.',
    'validation.missingOffence': 'Please select an offence.',
    'validation.minImages': 'Please upload at least 2 images.',
    'validation.noFineOrigin': 'Please select a fine origin.',
    'validation.missingPayment': 'Please fill in the payment field.',
    'validation.regNoEmpty': 'Please enter a registration number.',
    'validation.dateEmpty': 'Please select a date.',
    'validation.noAddress': 'Please select an address.',
    'validation.updateAtLeastOne': 'Please update at least one value.',
    'validation.cancelReasonMinLength':
        'Please provide a cancellation reason of at least 20 characters.',
    'validation.noNameChosen': 'Please enter a name.',
    'validation.noEmailChosen': 'Please enter an email address.',
    'validation.noOrganisationTypeChosen':
        'Please select an organisation type.',
    'validation.noStreetNameChosen': 'Please enter a street name.',
    'validation.noStreetNumberChosen': 'Please enter a street number.',
    'validation.missingZipcode': 'Please enter a zip code.',
    'validation.missingCity': 'Please enter a city.',
    'validation.startDateBeforeToday': 'Start date cannot be in the past.',
    'validation.noUsernameChosen': 'Please enter an username.',
    'validation.organisationNotChosen': 'Please select an organisation.',
    'validation.startDateNotChosen': 'Please select a start date.',
    'validation.endDateNotChosen': 'Please select an end date.',
    'validation.parkinglotNotChosen': 'Please select a parking lot.',
    'validation.apiUserOnly':
        'Please grant access to at least one of API, App, or Website.',
    'validation.rulesNotChosen': 'Please select rules and settings.',
    'validation.permitRegNoNotChosen': 'Please select a permit type.',
    'validation.selectAtLeastOnePermission':
        'Please select at least one permission before submitting.',
    Rule: 'Rule',
    'validation.nameRequired': 'Please enter a name.',
    'validation.maxPermitsNegative':
        'Max active permits cannot be a negative number.',
    'validation.durationNegative': 'Duration cannot be a negative number.',
    'validation.parkingLotRequired': 'Please select at least one parking lot.',
    'validation.requiredFields': 'Please fill out all the required fields.',
    'validation.invalidAddress': 'Please select a valid address.',
    'validation.pauseTimesMissing':
        'Please set both a pause start and a pause end time.',
    'validation.pauseStartAfterEnd':
        'Pause start time must be before pause end time.',
    'validation.failedSave':
        'Could not save camera settings. Please try again.',
    'validation.updated': 'Camera settings updated.',
    'validation.failedCreate':
        'Could not create the camera setting. Please try again.',
    'validation.created': 'Camera settings created.',
    'validation.invalidUrl':
        'Please enter a valid URL (e.g. https://example.com).',

    // Ticket Service validation
    'must be a positive integer': 'must be a positive integer',
    'Reg. no. have not been specified': 'Reg. no. have not been specified',
    'E-mail has not been specified': 'E-mail has not been specified',
    'Terms and conditions must be accepted':
        'Terms and conditions must be accepted',
    Issues: 'Issues',

    // Status page
    'Status Overview': 'Status Overview',
    'Could not load status data.': 'Could not load status data.',
    'Open status page': 'Open status page',
    'All Systems Operational': 'All Systems Operational',
    'Service Disruption': 'Service Disruption',
    'Active Services': 'Active Services',
    'Inactive Services': 'Inactive Services',
    'uptime over 30 days': 'uptime over 30 days',
    Statuspage: 'Status',

    // ### UPDATED TERMS ###
    appSupport: 'App support',
    supportPhoneHours: 'Support phone hours',
    'Privacy policy': 'Privacy Policy',
    'Trade policy': 'Trade Policy',
    'Company info': 'Company Information',
    'Terms and conditions': 'Terms and Conditions',
    '"Parking provider" - Will refer to the company above throughout the policy.':
        '"parking provider" – Will refer to the company above throughout the policy.',
    Last_updated: 'Last updated',
    updated_at_description:
        'This policy is effective from the date stated above. If changes are made, the new version will be published on this page, and relevant data subjects will be notified of the update.',
    // ### Privacy Policy content ###
    // --- 1. Introduction
    Terms_main_point_1: {
        main_title: 'Introduction',
        sub_point_1:
            'In this privacy policy (the “Policy”), we describe how parking provider (“us,” “we,” or “our”) collects and processes personal data when you park via our parking areas, including our ANPR sites, purchase our services and products, use our websites or other service applications in general, as well as other media controlled by us.',
        sub_point_2:
            'The Policy is drafted and made available to comply with the General Data Protection Regulation (2016/679 of 27 April 2016) (“GDPR”) and its rules on the duty to inform.',
    },
    // --- 2. Types of personal data processed
    Terms_main_point_2: {
        main_title: 'Types of personal data processed',
        sub_point_1: {
            sub_point_1_title:
                'We process personal data about you when this is relevant and in accordance with applicable law. Depending on the specific circumstances, the personal data processed may include the following types of personal data:',
            sub_point_1_1: 'a) name',
            sub_point_1_2: 'b) address',
            sub_point_1_3: 'c) phone number',
            sub_point_1_4: 'd) email',
            sub_point_1_5: 'e) username',
            sub_point_1_6: 'f) password',
            sub_point_1_7: 'g) purchase history',
            sub_point_1_8: 'h) invoicing and bookkeeping documents',
            sub_point_1_9: 'i) account status (balance, customer points, etc.)',
            sub_point_1_10: 'j) credit card information',
            sub_point_1_11:
                'k) bank information (card details or account information)',
        },
        sub_point_2: {
            sub_point_2_title: 'License plate number',
            sub_point_2_1:
                'We also process information in connection with the performance of our parking control, or when you enter this information during registration and parking via our sites and apps, when you sign up as a “regular user,” or otherwise use our ANPR sites, as well as when you contact us regarding any imposed control fee.',
            sub_point_2_2:
                'In addition, CCTV is used at certain of our parking facilities. If CCTV is used, this will be indicated by signage at the entrance to the site.',
        },
        sub_point_3: {
            sub_point_3_1:
                'We collect personal data directly from you and, where relevant, from external sources.',
            sub_point_3_2:
                'As a rule, we collect personal data directly from you, but we may also collect information from, among others, public authorities, educational institutions, employers, and therefore the source of collection varies.',
        },
        sub_point_4:
            'If we need to collect and process additional personal data beyond what is stated above, we will inform you at the time of collection. Such notice may also occur by updating this Policy.',
    },
    // --- 3. Especially for users
    Terms_main_point_3: {
        main_title: 'Especially for users',
        sub_point_1: {
            sub_point_1_title: 'Collection of information',
            sub_point_1_1:
                'When the User uses parking provider services, the User simultaneously consents to parking provider collecting and processing the personal data and information provided by the User in accordance with parking provider’s applicable data policy.',
            sub_point_1_2:
                'Personal data is stored only if it is provided voluntarily, and only as long as it is relevant to parking provider. The data in question is stored on parking provider’s internal networks and can only be accessed with special permissions.',
        },
        sub_point_2: {
            sub_point_2_title: 'User obligations',
            sub_point_2_1:
                'When the User provides information about another person, the User warrants that they have the right to provide such information to parking provider.',
        },
        sub_point_3: {
            sub_point_3_title: 'Transfer of data',
            sub_point_3_1:
                'The User accepts that if parking provider finds it necessary to move the User’s information to another platform established for the same purpose as contained in this agreement, this will occur without prior notice and in accordance with applicable data protection rules.',
        },
        sub_point_4:
            'NOTE that the User is obliged to keep the information registered with parking provider up to date. That is, the User must inform parking provider if there are changes in address, email, etc., or any license plate number for the vehicle to be used in parking provider. If this is not complied with, parking provider is entitled to delete the information already registered and terminate the subscription parking agreement in order to comply with applicable personal data legislation.',
    },
    // --- 4. Purpose of processing personal data
    Terms_main_point_4: {
        main_title: 'Types of personal data processed',
        sub_point_1: {
            sub_point_1_title:
                'We only process your personal data if we have a legitimate purpose and then in accordance with the rules in the GDPR. Depending on the circumstances, personal data may be processed for the following purposes:',
            sub_point_1_1:
                'a) To communicate with and exchange information with public authorities where the law requires this.',
            sub_point_1_2:
                'b) To prevent fraud and deception or improper use of our products, services, and website, including processing of personal data for use in connection with litigation.',
            sub_point_1_3: 'c) To send newsletters via email.',
            sub_point_1_4: 'd) To improve our products, services, or website.',
            sub_point_1_5:
                'e) To store personal data to the extent required under applicable law, for example retention of accounting and bookkeeping records.',
            sub_point_1_6:
                'f) To be able to deliver or offer services or products to users, customers, or members.',
            sub_point_1_7:
                'g) To respond to inquiries and/or complaints from users, customers, or members.',
            sub_point_1_8:
                'h) To send direct marketing to users, customers, or members (such as emails, MMS, direct messages on social media, etc.).',
            sub_point_1_9:
                'i) To prevent fraud and misuse of IT system(s) and/or products or services provided via IT system(s).',
            sub_point_1_10:
                'j) To deliver service messages and information to users, customers, or members.',
            sub_point_1_11:
                'k) To provide support and service messages, including answering questions or complaints and sending updates about our products and services.',
        },
        sub_point_2: {
            sub_point_2_title:
                'In addition to the above, we process personal data for the following purposes:',
            sub_point_2_1:
                'To be able to charge and receive payment for your parking',
            sub_point_2_2:
                'To be able to respond to inquiries/objections from parkers',
            sub_point_2_3:
                'To be able to issue control fees, additional charges, etc.',
            sub_point_2_4: 'To be able to carry out our parking control',
            sub_point_2_5:
                'To be able to administer rental/reservation of parking spaces, including waiting lists for parking spaces',
            sub_point_2_6:
                'To be able to ensure crime prevention and generally provide parkers with a safe experience when using the parking areas',
            sub_point_2_7:
                'To be able to register and issue digital parking registrations/permits',
            sub_point_2_8:
                'So that you can register your information on our sites or app as a “regular user” or through your general use of our ANPR sites, or when you use parking provider’s website.',
        },
    },
    // --- 5. Legal basis for processing personal data
    Terms_main_point_5: {
        main_title: 'Legal basis for processing personal data',
        sub_point_1: {
            sub_point_1_title:
                'We only process your personal data when we have a lawful basis for processing in accordance with the GDPR. Depending on the specific circumstances, the processing of personal data takes place on the following legal bases:',
            sub_point_1_1:
                'a) The processing is necessary to comply with applicable law, cf. GDPR, Article 6(1)(c).',
            sub_point_1_2:
                'b) The processing is necessary for the performance of a contract with the data subject, cf. GDPR, Article 6(1)(b), first limb.',
            sub_point_1_3:
                'c) The processing is necessary for the pursuit of a legitimate interest, where the interests or fundamental rights and freedoms of the data subject requiring protection of personal data do not override those interests, cf. GDPR, Article 6(1)(f).',
            sub_point_1_4:
                'd) The basis for processing the specific personal data is your consent, cf. GDPR, Article 6(1)(a). You can withdraw your consent at any time by contacting us via the contact details listed at the top of this Policy. If you withdraw your consent, the personal data processed on the basis of the consent will be deleted unless it can or must be processed, for example, to comply with a legal obligation.',
        },

        sub_point_2: {
            sub_point_2_title:
                'Our legitimate interests under GDPR, Article 6(1)(f), consist in being able to pursue a claim against you as a parker if, for example, you have parked in violation of the provisions at a parking site and have been issued a control fee.',
            sub_point_2_1:
                'In this connection, we may collect your name and address information from the Motor Register (SKAT), which we are entitled to under Article 6(1)(f) of the GDPR, as we have a legitimate interest in being able to direct our claim against the person who has parked in violation of the rules at the parking area.',
            sub_point_2_2:
                'In this connection, it is stated that we have terminal access as one of the types of businesses, etc., mentioned in Section 17(2) of the Danish Act on Registration of Vehicles, which have access to information about the name and address of the registered primary owner and primary user of the vehicle, cf. Executive Order no. 1643 of 17/12/2018 Section 102(1).',
            sub_point_2_3:
                'The processing of the personal data collected about you via CCTV is based on GDPR, Article 6(1)(f), on the grounds of crime prevention. This interest is not overridden by your interests or fundamental rights and freedoms.',
        },
    },
    // --- 6. Disclosure and transfer of personal data
    Terms_main_point_6: {
        main_title: 'Disclosure and transfer of personal data',
        sub_point_1:
            'We only disclose personal data to others when the law allows or requires it. Our organization is part of a group where personal data is shared among group companies depending on the specific circumstances.',
        sub_point_2: {
            sub_point_2_title:
                'We disclose personal data to the following recipients within the EU/EEA:',
            sub_point_2_1:
                'a) Banks (in connection with payouts, receipt of payments, etc.)',
            sub_point_2_2: 'b) Data processors',
            sub_point_2_3: 'c) Suppliers',
            sub_point_2_4: 'd) Partners',
        },
        sub_point_3: {
            sub_point_3_title:
                'In specific situations we may disclose your personal data to the following recipients:',
            sub_point_3_1: 'The police for use in any criminal investigation',
            sub_point_3_2: 'Public authorities',
            sub_point_3_3: 'Debt collection agencies',
            sub_point_3_4: 'The Parking Complaints Board',
            sub_point_3_5:
                'Parking apps that can be used in parking areas administered by parking provider, including but not limited to EasyPark',
            sub_point_3_6:
                'Another parking company, if this company is to take over operations, so you are not burdened by a change of administrator',
            sub_point_3_7:
                'Owners/business tenants of parking spaces in connection with parking control. Based on a balancing of interests and/or contractual obligations, your information may be disclosed to the site owner and/or the site owner’s property manager, business space tenants, including, but not limited to, compliance with the obligations of property associations, contractual relations between the Company and the site owner/site owner’s property manager/business space tenants, as well as changes in the physical arrangements of the parking area.',
            sub_point_3_8:
                'If, through your work, you may be entitled to parking, your inquiry in connection with an issued control fee and the associated personal data may, based on a balancing of interests, be disclosed to the site owner/employer in order to confirm your employment and right to park and to ensure proper case processing.',
        },
        sub_point_4:
            'We generally use various external and professional organizations as suppliers and partners to deliver or assist us in delivering our services and products. The external organizations will not receive or process personal data unless the law allows the transfer and processing thereof. If the external organizations or partners are data processors for us, their processing of personal data always takes place under a data processing agreement that meets the legal requirements. If the external organizations or partners are independent controllers, their processing of personal data is in accordance with their own privacy, data protection, or personal data policy, which the external organizations will draw attention to unless otherwise required by law.',
        sub_point_5:
            'You may contact us for more information, including questions about our use of data processors, cooperation with other controllers, including subsidiaries, or disclosure of personal data to third countries, as well as to receive a copy of documentation of the transfer basis.',
    },
    // --- 7. Deletion and storage of personal data
    Terms_main_point_7: {
        main_title: 'Deletion and storage of personal data',
        sub_point_1:
            'We ensure that personal data is deleted when it is no longer relevant to our processing purposes as described above. We always store personal data for the period that applicable law requires us to, including for documentation of compliance with, among other things, the provisions of the Danish Bookkeeping Act. If you have questions regarding the storage and processing of personal data, you are welcome to contact us at the email address you find under parking provider at the top of the page.',
    },
    // --- 8. Your rights
    Terms_main_point_8: {
        main_title: 'Your rights',
        sub_point_1: {
            sub_point_1_title:
                'As a data subject, you have a number of rights:',
            sub_point_1_1:
                'You have the right to request access to which personal data we process about you, the purpose of the processing, and whether we disclose the personal data to others.',
            sub_point_1_2:
                'You have the right to have inaccurate personal data about you rectified.',
            sub_point_1_3:
                'In certain cases, you have the right to have some of your personal data deleted.',
            sub_point_1_4:
                'In certain cases, you have the right to have the processing of your personal data restricted, so that we only store your personal data for a given period.',
            sub_point_1_5:
                'In certain cases, you have the right to object to our processing of your personal data on the basis of reasons and circumstances relating to your particular situation. An objection may be justified in relation to processing of personal data for the purpose of direct marketing.',
            sub_point_1_6:
                'You have the right not to be subject to a decision based solely on automated processing without human involvement, unless the decision is necessary for your employment with us, or the making of the decision is provided for by law or your explicit consent.',
            sub_point_1_7:
                'If we have obtained your consent for part of our processing of your personal data, you have the right to withdraw your consent at any time. If you choose to withdraw your consent, this does not affect the lawfulness of the processing based on the consent before the withdrawal.',
            sub_point_1_8:
                'In certain cases, you have the right to so-called data portability of the personal data you have provided to us.',
            sub_point_1_9:
                'You can always complain to the Danish Data Protection Agency.',
        },
        sub_point_2:
            'There may be conditions or limitations to these rights. Therefore, for example, you may not have the right to data portability in the specific case—this depends on the specific circumstances connected to the processing activities.',
        sub_point_3:
            'You can find more information about your rights as a data subject on the Danish Data Protection Agency’s website.',
        sub_point_4:
            'Please use the contact details below if you want to exercise your rights.',
        sub_point_5:
            'We strive to meet your wishes regarding our processing of personal data, but you can always submit a complaint to the Danish Data Protection Agency.',
    },
    // --- 9. Changes to this policy
    Terms_main_point_9: {
        main_title: 'Changes to this policy',
        sub_point_1:
            'We reserve the right to update and amend this Policy. If we change the Policy, we will change the date and version at the top of the document. In the event of significant changes, we will notify you in the form of a visible notice on our website, by email, or by using other means of communication.',
    },
    // --- 10. Contact information
    Terms_main_point_10: {
        main_title: 'Contact information',
        sub_point_1: {
            sub_point_1_title:
                'You are welcome to contact us at the contact information at the top of the page if you:',
            sub_point_1_1:
                'a) disagree with our processing or believe that our processing of your personal data violates the law,',
            sub_point_1_2:
                'b) have questions or otherwise have comments on this Policy, or',
            sub_point_1_3:
                'c) wish to exercise one or more of your rights as a data subject.',
        },
        sub_point_2:
            'For questions or comments on this policy, or when invoking one or more rights, we can be contacted via the contact details at the top of the page.',
    },

    // ### Trade Policy content ###
    trade_policy_description:
        'We store and transmit user information in encrypted form. Personal data entered is recorded as described in our data policy (see section 4). By accepting these terms, the User simultaneously acknowledges and accepts the present terms and conditions for the use of parking provider products.',
    trade_policy_description_2:
        'For special rules on parking provider subscription parking, see below under “parking provider Subscription Parking.”',
    trade_policy_description_3:
        'Parking provider may collect information and prepare statistics and reports in order to improve and deliver the best product and service to the User.',

    // --- 1. Use
    Trade_Terms_main_point_1: {
        main_title: 'Use',
        sub_point_1: {
            sub_point_1_title:
                'These General Terms and Conditions (the “General Terms and Conditions”) apply to the delivery of Services from parking provider. More information about parking provider can be found at the top of the page.',
        },
        sub_point_2:
            'NOTE! Use of parking provider services requires that you are the registered owner or user of the vehicle, or that you otherwise have permission to use and register the vehicle.',
        sub_point_3: {
            sub_point_3_title:
                'All Services are provided in accordance with applicable law and in accordance with:',
            sub_point_3_1: 'any individually agreed terms and conditions, and',
            sub_point_3_2: 'these General Terms and Conditions.',
            sub_point_3_3:
                'In the event of discrepancies between the above provisions, they take priority in the order listed above.',
        },
        sub_point_4:
            'Clause 4.1.4, 5.4, and 6.7 contain special provisions on the correct and valid entry of license plate number and area code.',
        sub_point_5:
            'Clause 4.3 contains special provisions on the use of parking provider-charge.',
        sub_point_6:
            'By registering with parking provider (see clause 4), the User agrees to be bound by these General Terms and Conditions. A binding agreement (the “Agreement”) is concluded when parking provider has confirmed the User’s registration, and the User gains access to parking provider Services.',
        sub_point_7:
            'These General Terms and Conditions constitute the Agreement between parking provider and the User.',
        sub_point_8:
            'These General Terms and Conditions apply to all transactions and registrations via parking provider, including parking provider and parking provider Subscription Parking.',
    },
    // --- 2. Definitions
    Trade_Terms_main_point_2: {
        main_title: 'Definitions',
        sub_point_1: {
            sub_point_1_title:
                'In these General Terms and Conditions and in connection with the Services, the following definitions apply:',
            sub_point_1_1:
                '“parking provider” means the digital parking service that can be used for payment for parking via the App and the website;',
            sub_point_1_2:
                '“App” means the parking provider mobile application;',
            sub_point_1_3:
                '“parking provider System” is parking provider’s digital system for modern parking, which the User accesses via the App and/or via the Website;',
            sub_point_1_4: '“Website” refers to the parking provider website.',
            sub_point_1_5:
                '“Parking Service” is the User’s ability to manage parking in the App;',
            sub_point_1_6:
                'A “Parking Site” is a physical area that matches a parking area marked on the overview map (by parking site this is not to be understood as a marked parking bay);',
            sub_point_1_7:
                '“Parties” and “Party” means parking provider and/or the User;',
            sub_point_1_8:
                '“User” in these General Terms and Conditions refers to the parker who uses parking provider in connection with payment for parking.',
            sub_point_1_9:
                '“Partner” means partners with whom parking provider cooperates;',
            sub_point_1_10:
                '“Service(s)” has the meaning set out in clause 3.1.1.',
            sub_point_1_11:
                '“Parking Fee” is the price for the parking carried out.',
            sub_point_1_12:
                '“Active Vehicle” refers to a vehicle that the User has selected for automatic payment in connection with parking at so-called ANPR parking sites. Payment is made via the payment method that the User has designated as preferred.',
            sub_point_1_13:
                '“ANPR” stands for Automatic Number Plate Recognition, meaning that the vehicle’s number plate is read automatically and the license plate number is registered in the parking system. Parking sites with ANPR systems are marked with a camera in parking provider, and the signage at the parking site indicates that the number plate is being read.',
            sub_point_1_14:
                '“parking provider-Charge” means parking provider’s own and affiliated systems and third-party apps that can be used for charging electric and hybrid cars. This includes charging stations, payment systems, and apps.',
        },
        sub_point_2:
            'Definitions may be given elsewhere in these General Terms and Conditions.',
    },
    // --- 3. General Terms and Conditions for the Services
    Trade_Terms_main_point_3: {
        main_title: 'General Terms and Conditions for the Services',
        sub_point_1: {
            sub_point_1_title: 'General',
            sub_point_1_1:
                'parking provider offers a digital system for parking (“parking provider”), whereby parking provider (in cooperation with other Partners) enables the User to manage the parking of vehicles (the “Parking Service”) and the charging of electric vehicles. The Parking Service and the Services otherwise provided by parking provider from time to time are collectively referred to as the “Services.”',
        },
        sub_point_2:
            'For a detailed description of the Services, refer to the information provided on the website from time to time.',
    },
    // --- 4. Special terms and conditions for use of parking provider
    Trade_Terms_main_point_4: {
        main_title: 'Special terms and conditions for use of parking provider',

        sub_point_1: {
            sub_point_title: 'Conditions of use',

            sub_point_1_1:
                'The Parking Service may only be used at parking lots and in parking areas/zones (each a “Parking Site”) that:',
            sub_point_1_1_1: 'have parking provider signage installed,',
            sub_point_1_1_2:
                'and have machines with parking provider stickers, or otherwise bear parking provider marks indicating that parking provider can be used.',

            sub_point_1_2:
                'When the Parking Service is used, the User must start a parking session by activating either the App or a linked and approved payment system',

            sub_point_1_3:
                'To ensure that parking has been started correctly, the User must check that a confirmation of correctly and validly started parking has been received via',
            sub_point_1_3_1: 'the App, if the App is used; or',
            sub_point_1_3_2: 'email confirmation',

            sub_point_1_4:
                'A parking session is only valid if the App has confirmed the parking and shows an ongoing correctly registered parking/payment.',

            sub_point_1_5:
                'When using the Parking Service, the User must correctly enter the parked vehicle’s license plate number as well as the area code for the Parking Site in question.',

            sub_point_1_6:
                'It is the User’s responsibility that the vehicle’s license plate number and the area code are entered correctly. Errors in registration and entry will result in a control fee.',

            sub_point_1_7:
                'The User must ensure that the area code corresponds to the area code at the relevant Parking Site or E-charge station, as shown on parking provider signage at the parking site or near the Parking Site’s machines/E-charge stations. The User is responsible for indicating the correct area code and license plate number. Parking provider assumes no responsibility in connection with incorrectly indicated license plate numbers and/or area codes.',

            sub_point_1_8:
                'When parking at parking sites where the vehicle’s number plate is read, no area code must be entered. The license plate number used for parking must be entered correctly.',

            sub_point_1_9:
                'It is a condition for valid registration of the parking that the license plate number and area code are entered correctly.',

            sub_point_1_10:
                'Registration of parking in parking provider can be done in one of the following ways:',
            sub_point_1_10_1:
                'For manual registration, the User must indicate the desired parking time and will in this connection be informed of the price for the desired parking. Upon the User’s confirmation of the entered registration, the stated amount is reserved. When the User stops the parking session, the reserved amount is adjusted so that payment is only made for the registered parking time.',
            sub_point_1_10_2:
                'For automatic registration (when parking at ANPR sites), the User must, prior to parking, have activated the vehicle under “vehicles.” When parking at an ANPR parking site, the parking session starts at entry and ends and is settled upon exit. Payment is made for the parking time used.',
            sub_point_1_10_2_1:
                'By activating a vehicle, the User accepts that automatic payment will be made via the preferred payment method when parking at an ANPR parking site.',

            sub_point_1_11:
                'parking provider cannot be held responsible for the accuracy of the User’s phone GPS position, nor can parking provider be held responsible for mobile coverage/signal in/at the parking area. The User is responsible for ensuring that the stated position matches the position of the User’s parked vehicle.',

            sub_point_1_12:
                'Information about parking sessions carried out by the User will be available to the User via “Parkings,” and such information will as a rule be available for at least 12 months.',
        },

        sub_point_2: {
            sub_point_title: 'General',

            sub_point_2_1:
                'The Parking Service enables the User to start a parking session and, for manual start, indicate a provisional parking time, stop and end the started parking session. Furthermore, it is possible for the User to extend the provisionally indicated parking time.',
            sub_point_2_1_1:
                'Reminder: It is possible to receive a reminder before the manually started parking expires, provided that push notifications are enabled in the App. It is the User’s responsibility to ensure proper termination of parking, regardless of whether a reminder is missed.',
            sub_point_2_1_2:
                'Stop parking: If the parking site is left before the selected parking time expires, it is possible to actively stop the ongoing parking session, thereby paying only for the period during which the parking has been active. The User is referred to always consider the parking price as shown on the signage and/or payment machine. Depending on the pricing structure at the parking site, it will in most parking sites be possible to stop the parking so that there is no payment for “unused time.” NOTE! Some parking sites require payment per started time period and possibly in advance, which means that if such a parking session is stopped, the pre-approved amount will be charged regardless of stopping. If the parking is not stopped, no refund for “excess time” can be made.',
            sub_point_2_1_2_1:
                '“Excess time” is understood as the period during which there is a valid registration of parking at the parking site, but the vehicle has not been at the parking site.',
            sub_point_2_1_3:
                'Extension: Extending a parking session is done by pressing “extend” and then entering the new end time for the parking; the amount is then approved. The countdown of the parking period for the vehicle will then be updated based on the extended parking time. Extension means that a new parking session starts at the expiry of the original parking session.',
            sub_point_2_1_4:
                'If it is not possible to make a purchase at a given time using the parking provider software, the User is responsible for paying for parking in another way, e.g., by purchasing a valid parking ticket at the payment machine and otherwise observing the posted rules and terms for parking. Reasons why parking provider cannot be used include, but are not limited to, e.g.: poor/no internet access, server downtime due to maintenance, updates, etc.',

            sub_point_2_2:
                'If the User was not the driver of the vehicle at the time of parking, but the User has marked the vehicle as active, the User has accepted that payment is made automatically via the preferred payment method. The internal relationship between the User and any third party is of no concern to parking provider.',

            sub_point_2_3:
                'If a control fee is imposed on the parked vehicle for a parking session that does not comply with the rules and terms shown on the signage at the parking site, the driver is liable for payment of such a control fee, regardless of who made the payment for the parking.',
            sub_point_2_3_1:
                '“Control fee” is used here as a collective term for, e.g., control fee, penalty charge, etc.',

            sub_point_2_4:
                'In the event that the parking was carried out with a vehicle where the registered owner/user is a company, and the vehicle is imposed a control fee, it is the User’s responsibility to sufficiently document that the parking carried out was not for business purposes. If the User cannot discharge this burden of proof, the registered owner/user will be considered the correct debtor and, in this case, in the event of late payment, a compensation amount of DKK 310.00 will be charged in addition to any reminders in accordance with Order no. 105 of 31/01/2013 Section 2(1).',

            sub_point_2_5:
                'If the User was not the driver of the vehicle at the time of parking, the User hereby accepts the obligation to state who the driver was. Incomplete or incorrect information will result in the control fee, and any reminder fees, being maintained in full against the User.',

            sub_point_2_6:
                'The User’s payment of the relevant parking fee (including VAT) is determined based on the applicable rates (the “Parking Fee”) when the User ends a parking session, or alternatively starts a fixed parking time through the Parking Service.',

            sub_point_2_7:
                'The User cannot claim a reduction of the control fee based on completed payment in parking provider. This term applies regardless of whether the control fee was imposed due to the User’s incorrect registration in parking provider or the User’s parking in violation of the other posted rules and terms at the parking site.',

            sub_point_2_8:
                'The User is also not entitled to a refund of payment made via parking provider, unless the charge is due to an error by parking provider which the User did not have, or could not have had, influence over.',
        },

        sub_point_3: {
            sub_point_title: 'Parking provider charge terms',

            sub_point_3_1:
                'Payment for charging a vehicle can be made through apps related to the charging stations installed at the site. Payment for parking must be made separately through parking provider (see clause 4).',

            sub_point_3_2:
                'NOTE: When parking in bays reserved for electric vehicles while charging, the charging must be registered in the app used before parking and charging begin. In addition, the parking must be registered in the parking provider app, as stated in clause 4.',

            sub_point_3_3:
                'The app used must be used to pay for charging via the installed charging stations.',

            sub_point_3_4:
                'When using parking provider in connection with the use of an installed charging station, the User informs parking provider that charging of the parked vehicle is starting, the provisional charging time, the end of charging, and, if necessary, any extended charging time.',

            sub_point_3_5:
                'When paying for and using an installed charging station, a charging fee is paid.',
            sub_point_3_5_1: 'The charging fee is variable.',
            sub_point_3_5_2:
                'Payment for the charging fee is made separately and the charge is shown in the app used before registration and payment are completed.',

            sub_point_3_6:
                'Upon registration, the other terms and conditions for use of the parking provider app likewise apply, including that correct and valid registration and payment presupposes the correct entry of the area code and the parked vehicle’s license plate number. It is the User’s responsibility that the information entered is correct and verifiable and that payment can be completed.',

            sub_point_3_7:
                'The area code to be used in connection with payment for charging and parking appears on the signage posted at the bays reserved for electric vehicles. It is the User’s responsibility to enter the correct area code.',
            sub_point_3_7_1:
                'If payment is made to an area code linked to a parking provider-charge charging station, but without using a parking bay reserved for parking provider-charge, no refund will be made.',

            sub_point_3_8:
                'It is at all times the User’s responsibility to observe the posted rules and terms shown at the parking site. In the event of inconsistencies between the signage and these terms and conditions, the wording of the signage shall prevail. If parking is not carried out in accordance with the posted rules and terms, a control fee may be imposed, which cannot subsequently be annulled.',
            sub_point_3_8_1:
                'Parking in bays reserved for electric vehicles can only take place against payment, and the vehicle must be charging for the entire period during which the parking bay is used. If the vehicle is not charging and/or the parking is not registered in parking provider, a control fee that cannot be annulled will be imposed.',
            sub_point_3_8_2:
                'If problems arise in connection with the use of a parking provider-charge charging station, the User must contact parking provider at the phone number stated on the charging station.',

            sub_point_3_9:
                'Information that the User has registered in connection with registration and payment is processed in the same way as mentioned in clause 4.',
        },
    },
    // --- 5. Access to the Services, registration of information, etc.
    Trade_Terms_main_point_5: {
        main_title: 'Access to the Services, registration of information, etc.',
        sub_point_1:
            'Access to the Services, creating an account, and payment for parking via parking provider can occur when the User is created as a user. Use of parking provider requires that a valid means of payment is linked in the User’s parking provider App. The means of payment that the User can validly link as a means of payment are: bank card. It is a condition of validity that there are sufficient funds on the linked and selected means of payment.',

        sub_point_2: {
            sub_point_2_title:
                'When creating an account and later use of parking provider, it is a prerequisite that the User provides correct and valid:',
            sub_point_2_1: 'Name',
            sub_point_2_2: 'Email address',
            sub_point_2_3: 'Mobile number',
            sub_point_2_4: 'Password',
            sub_point_2_5: 'License plate number, for at least one vehicle',
            sub_point_2_6: 'Means of payment',

            sub_point_2_6_1:
                'Groups of employees with access to the registered information:',
            sub_point_2_6_1_1: 'Subcontractors (while performing support)',
            sub_point_2_6_1_2:
                'parking provider Employees (while performing support in connection with User inquiries)',
        },

        sub_point_3: 'A parking session is started via the App or the website.',

        sub_point_4: {
            sub_point_4_title:
                'To use parking provider, prior to registering the parking, a valid means of payment must be linked and selected in the App or on the website.',
            sub_point_4_1:
                'NOTE: It is not possible to change the means of payment during an ongoing parking session, which is why it is the User’s responsibility to select the correct and valid means of payment before the parking session begins.',
        },

        sub_point_5: {
            sub_point_5_title:
                'The instructions shown on the screen must be followed:',
            sub_point_5_1:
                'For the User to use parking provider to pay for parking, it is a condition of validity that the User registers a correct and valid license plate number, area code, means of payment, and parking time.',
            sub_point_5_2:
                'The User must check that the registered license plate number and area code are correctly indicated.',
            sub_point_5_3:
                'parking provider reserves the right to reject an application for registration and payment for parking.',
            sub_point_5_4:
                'It is clarified that payment for the parking has only been validly made if the license plate number of the vehicle being parked has been correctly entered and the area code entered matches the area code shown on parking provider signage applicable to the specific parking bay where the vehicle is located.',
        },

        sub_point_6:
            'If the parking is not validly registered, the vehicle risks being subject to a control fee.',
        sub_point_7:
            'Upon completion of purchase/reservation, a confirmation is sent via email to the email address provided by the User.',
        sub_point_8:
            'When purchasing through parking provider, an unspecified parking bay is made available at the selected parking lot/location and for the selected period. parking provider cannot be held responsible if there are no available parking bays (as there is no booking). Parking should therefore not be purchased until the vehicle is duly parked at the parking lot.',
        sub_point_9:
            'The User is not entitled to a refund for unused parking. See clause 4.2.1.2.',
    },
    // --- 6. The User’s obligations and responsibility
    Trade_Terms_main_point_6: {
        main_title: 'The User’s obligations and responsibility',

        sub_point_1:
            'The User is at all times responsible for providing correct information about the User, and that relevant vehicles are correctly registered with parking provider. Immediately after creation/registration, the User must log in to “My Account” to ensure that the registered information is correct. Parking provider can never be or become responsible for incorrect registrations/entries, regardless of the registration method.',

        sub_point_2:
            'The User is responsible for ensuring on an ongoing basis that the means of payment that is registered and used via parking provider is not blocked, is valid, and that there are sufficient funds on the registered means of payment. Upon expiry of a registered means of payment, the User must provide parking provider with information (by updating in the App under “payment methods”) about a new means of payment. Notice of the new means of payment must be given no later than the end of the calendar month preceding the calendar month in which the registered means of payment is no longer usable.',

        sub_point_3:
            'Secure and responsible storage of login details is the User’s responsibility.',

        sub_point_4:
            'Furthermore, it is the User’s responsibility that login details are not disclosed or otherwise made available to unauthorized persons.',

        sub_point_5: {
            sub_point_5_title:
                'It is solely the User’s responsibility that the User’s parking provider account is only used and is used by the correct persons.',

            sub_point_5_1_title:
                'The User must immediately inform parking provider (e.g., by contacting parking provider Customer Service or by updating the information in “My Account”) if:',

            sub_point_5_1_1:
                'The User has reason to believe that an unauthorized person has gained access to or knowledge of the Login details;',
            sub_point_5_1_2:
                'registered information about the User has been changed and/or should be updated; or',
            sub_point_5_1_3:
                'the User no longer has control over a registered vehicle or no longer has to pay for parking carried out with a registered vehicle,',

            sub_point_5_2:
                'Initially, the information must be provided by the User updating the information in parking provider. It is the User’s responsibility that there are no registered vehicles for which the User should not pay. Parking provider may then take the necessary precautions, for example to change/block the Login details and/or the User’s account or ask the User to update the User’s registered information. The User is likewise obliged to inform parking provider of other matters of importance to the Agreement and/or the delivery of the Services.',

            sub_point_5_3:
                'The User is responsible for ensuring that the App is at all times updated. The correct functionality of the mobile phone or other technical equipment is at all times the User’s responsibility. It is the User’s responsibility that the medium used is compatible with the Services and the App. The current functional requirements for the Services and the App can be obtained by contacting Customer Service.',
        },

        sub_point_6:
            'The User is at all times obliged to comply with applicable laws and regulations as well as the rules and terms shown on the signage at the parking site where the User parks the vehicle.',

        sub_point_7:
            'The User is responsible for ensuring that parking is started correctly by indicating the license plate number of the parked vehicle and the area code applicable to the parking site used. The User is responsible for ensuring that the area code indicated by the User is correct, even if the area code is suggested by the App’s location function. NOTE: If the correct license plate number and/or area code are not entered, valid payment for parking has not been made, and the parked vehicle therefore risks being imposed a control fee.',

        sub_point_8:
            'The User is responsible for ensuring that a started parking session is ended. If the User does not state a provisional end time or a total parking time when the parking session begins, the User is responsible for ending the parking session manually. Termination of parking can be done via the App or by contacting parking provider using the contact details shown in the App, on the website, and on parking provider signage.',

        sub_point_9:
            'If the Parking Service is not available or is out of service when the User needs to park, or while the User is parking (e.g., due to reasons attributable to the phone, mobile phone, or other technical equipment used by the User, or due to errors, interruptions, or delays in telephone, internet, or other communication networks), the User is responsible for making payment by other means as indicated by the posted signage at the parking site (for example by paying at the relevant machine).',

        sub_point_9_1:
            'The User is responsible for payment of any control fees or charges for incorrect parking (as notified or collected in connection with parking restriction violations).',

        sub_point_9_2:
            'If the parked vehicle is registered to a company, the parking is considered to have been carried out in a work-related context, and the Company will in this situation be considered the correct debtor.',

        sub_point_10:
            'The User has the option to see the parking history for the parking sessions the User has paid for via parking provider.',

        sub_point_11:
            'All parking purchased/reserved via parking provider is at the User’s own risk unless otherwise specifically stated in these terms and conditions.',

        sub_point_12:
            'Parking provider assumes no responsibility in connection with accidents, theft, injuries to persons, vehicles, equipment, and effects, in connection with the vehicle being parked at a parking site. Parking provider cannot be held responsible for any form of indirect loss or consequential damages.',
    },
    // --- 7. Complaints
    Trade_Terms_main_point_7: {
        main_title: 'Complaints',
        sub_point_1:
            'By submitting a complaint, you accept that the specified email address may be used as contact information in connection with handling the case, including in connection with any collection of the parking charge in question.',
        sub_point_2:
            'In the event of a deficient Service or incorrect charge, the User must immediately, and no later than 30 days after the relevant Service was delivered or after the User discovered or ought to have discovered the incorrect charge, submit a written complaint to parking provider customer service. The complaint must clearly state the deficiency or error. The User must provide reasonable assistance to parking provider in connection with any investigations regarding the complaint.',
        sub_point_3:
            'Complaints regarding imposed control fees must be directed to the issuer of the imposed control fee(s).',
    },

    // --- 8. Terms and Prices
    Trade_Terms_main_point_8: {
        main_title: 'Terms and Prices',
        sub_point_1:
            'The User is at all times liable for all payments made via parking provider.',
        sub_point_2:
            'Payments are made by the User registering a valid means of payment in the App. Payment will be charged via the means of payment registered by the User. When a vehicle is marked as active, the User has accepted that payment is made automatically via the designated preferred means of payment. The Administrator will be invoiced for payments where Business Parking is registered as the means of payment. The User selects and approves the payment method in connection with the application for registration. It is the User’s responsibility to specify the correct and valid means of payment before the parking session is started. Incorrect use of Business Parking is solely a matter between the Administrator and the User.',
        sub_point_3:
            'In the event of late payment, any reminders will be charged in accordance with applicable law.',
        sub_point_4:
            'All prices are stated in Danish kroner and inclusive of VAT. The price to be paid for the parking carried out depends on the selected parking site, the selected parking period, and whether an ongoing parking session is extended.',
        sub_point_5:
            'When creating a parking session and when extending it, the price of the relevant parking or extension is stated, and this amount must be approved before the parking is created and/or extended.',
        sub_point_6:
            'In some cases, in addition to the hourly price for parking, an operational fee will be charged. This will always be shown in the App or on the Website when purchasing a permit.',
        sub_point_7:
            'parking provider reserves the right to change fees and prices.',
        sub_point_8:
            'NOTE: parking provider reserves the right to update and change the content of the App as well as the website without prior notice.',
    },

    // --- 9. Right of withdrawal
    Trade_Terms_main_point_9: {
        main_title: 'Right of withdrawal',
        sub_point_1:
            'Under the Danish Consumer Contracts Act (Act no. 1457 of 17 December 2013), the User has the right to withdraw from the Agreement by notifying parking provider customer service within 14 days after approval of the registration.',
        sub_point_2:
            'The User understands that the ordinary 14-day right of withdrawal under the Danish Sale of Goods Act (Act no. 1853 of 24/09/2021) only applies to parking that has not yet commenced (is valid) at the time of withdrawal. If the User orders parking with a validity period starting the same day (immediately), the right of withdrawal likewise ends the same day (immediately), and the otherwise applicable 14-day right of withdrawal is thereby waived by the User. When the User purchases parking with a validity period beginning later than 14 days after entering into the subscription agreement, the User has a 14-day right of withdrawal.',
        sub_point_3: {
            sub_point_3_title:
                'To exercise the right of withdrawal, the withdrawal notice must be submitted to parking provider no later than on the 14th day from the day the payment was registered by parking provider.',
            sub_point_3_1:
                'If the deadline expires on a public holiday, Saturday, Constitution Day, Christmas Eve, or New Year’s Eve, the deadline is extended to the following business day.',
            sub_point_3_2:
                'To exercise the right of withdrawal, the User must send parking provider an email stating that the purchase/reservation is withdrawn (see clause 11.2.8).',
        },
        sub_point_4:
            'Please note that entering the parking lot/approval of the purchase in the app or on the website is considered acceptance that parking begins. If you then withdraw your purchase in the app or on the website, your refund will be reduced by a proportionate part of the total price for the parking in the purchased period, based on the number of days/hours/minutes the vehicle has been parked until parking provider received the registration of the exercise of the right of withdrawal.',
    },

    // --- 10. Terms for termination
    Trade_Terms_main_point_10: {
        main_title: 'Terms for termination',
        sub_point_1:
            'The User may choose to close the User’s account in the App or by closing the User’s account via the website, thereby invalidating the User’s parking provider account so that the User no longer has the option to pay for parking via parking provider.',
        sub_point_2:
            'Unpaid matters will be collected in accordance with the concluded agreement, even if the User closes the parking provider account.',
    },
    // --- 11. Term, early termination, etc.
    Trade_Terms_main_point_11: {
        main_title: 'Term, early termination, etc.',

        sub_point_1:
            'This Agreement is valid from parking provider’s approval of the User and until it is terminated in accordance with the terms of the Agreement or until otherwise agreed in writing.',

        sub_point_2: {
            sub_point_title:
                'parking provider is entitled to immediately suspend the User’s access to the Services, cancel the User’s account and/or terminate the Agreement with immediate effect if:',
            sub_point_2_1:
                'the User materially breaches the User’s obligations under this Agreement;',
            sub_point_2_2:
                'the User does not fulfill, or there is reasonable cause to assume that the User will not fulfill, the User’s payment obligations to parking provider,',
            sub_point_2_3:
                'the User, in parking provider’s reasonable assessment, can be expected to become insolvent;',
            sub_point_2_4:
                'the User uses the parking provider Services in violation of the Agreement or otherwise in a way that is harmful to or negatively affects parking provider or any third parties;',
            sub_point_2_5:
                'the User has repeatedly parked a vehicle in violation of applicable laws, regulations, and/or rules stated by the relevant Parking Operator;',
            sub_point_2_6:
                'the User has provided incorrect, incomplete, or misleading information; or',
            sub_point_2_7:
                'parking provider, on the basis of an overall assessment, finds it likely that the User may be involved in or connected to criminal activities.',
            sub_point_2_8:
                'Termination of the Agreement must be made in writing to the parking provider contact email or via the form on the website',
        },

        sub_point_3:
            'Termination of the Agreement (regardless of reason) does not affect the rights and/or obligations that a Party has incurred towards the other Party prior to the date of termination of the Agreement.',
    },

    // --- 12. Parking provider liability for damages
    Trade_Terms_main_point_12: {
        main_title: 'Parking provider liability for damages',

        sub_point_1:
            'Parking provider’s total liability for damages can under no circumstances exceed an amount corresponding to DKK 38,000.00, unless parking provider has acted willfully or has exhibited gross negligence.',

        sub_point_2:
            'parking provider is not liable for accidents, theft, personal injuries, damage to vehicles, equipment, or other effects mounted on or in the vehicle.',

        sub_point_3:
            'parking provider is not liable for either indirect losses or consequential damages. parking provider is not liable for damages in relation to the User’s relationship with any third party',

        sub_point_4: {
            sub_point_4_title:
                'parking provider is not liable for damages or losses that the Administrator and/or the User has incurred as a result of:',
            sub_point_4_1: 'Parking at a parking site;',
            sub_point_4_2:
                'the User’s error or negligence, including if the User has not correctly started or ended a parking session (regardless of whether the User has chosen to receive a reminder or a push notification from parking provider), or if the User has entered an incorrect area code for a Parking Site and/or license plate number at the start of a parking session (regardless of whether the User entered such area code manually or it was suggested via the location function in the App);',
            sub_point_4_3:
                'the User not having complied with the User’s obligations under this Agreement and the terms for use of parking provider or the User otherwise not having followed parking provider’s instructions;',
            sub_point_4_4:
                'the User having parked the vehicle in violation of applicable laws, regulations, and/or rules stated on the posted signage at the relevant parking site where the User parks the vehicle;',
            sub_point_4_5:
                'malfunction or insufficient functionality of the User’s mobile phone or other technical equipment (such as the equipment being switched off or the battery having run out of power);',
            sub_point_4_6:
                'breakdowns, interruptions, or delays in telephone, internet, or other communication networks, or the actions or omissions of the telecommunications operator that affect the functionality or availability of the Service;',
            sub_point_4_7:
                'an error or defect in a technical function that indicates the price of the relevant Parking Fee;',
            sub_point_4_8:
                'the Service having been interrupted by parking provider due to circumstances that turn out to be incorrect but which parking provider had reason to believe were correct at the time of the interruption and that justified the interruption;',
            sub_point_4_9:
                'interruptions or insufficient access to one or more Services that parking provider could not reasonably have foreseen;',
            sub_point_4_10:
                'a Parking Site proposed by parking provider not being available when the User arrives there;',
            sub_point_4_11:
                'unauthorized use of Login details and/or Services; or',
            sub_point_4_12: 'force majeure (see clause 15).',
        },

        sub_point_5:
            'Under no circumstances is parking provider liable for indirect damages such as, for example, loss of operations and loss of data. Parking provider is not liable for damages in relation to the Administrator’s and/or the User’s relationship with any third parties.',
    },

    // --- 13. The User’s liability for damages
    Trade_Terms_main_point_13: {
        main_title: 'The User’s liability for damages',
        sub_point_1:
            'The User shall indemnify parking provider for claims for damages or losses resulting from the User’s error or negligence, the User’s failure to fulfill the User’s obligations under this Agreement, or otherwise failure to comply with parking provider’s instructions. The User shall likewise indemnify parking provider for claims from third parties that are a direct or indirect consequence of the User’s use of a Service.',
    },

    // --- 14. Intellectual property rights
    Trade_Terms_main_point_14: {
        main_title: 'Intellectual property rights',

        sub_point_1:
            'The User accepts that software can never be tested in all possible situations, and that deviations from the agreed functionality and unforeseen errors and interruptions may occur. Parking provider is generally available 24 hours a day, except for planned interruptions for upgrades, changes, and maintenance. The right to update parking provider with new features or otherwise make changes, for example to adapt the system to new technology, new security standards, or new administrative procedures, etc., is reserved by parking provider. Parking provider assumes no responsibility for any damage or loss in connection with lack of access to parking provider, parking provider being out of service, or containing errors.',

        sub_point_2:
            'All copyrights (including rights to source code, computer programs, algorithms, and object code) and other intellectual property rights (including patent rights and trademarks) regarding parking provider and its content are owned or licensed by parking provider or its suppliers and partners. Neither the Administrator nor the User is granted any of these rights under this Agreement. It is not permitted to use parking provider or its content for commercial purposes. The User is not entitled to copy, distribute, sell, publish, transfer, lend, sublicense, modify, or otherwise dispose of the software contained in parking provider. The User is not entitled to perform disassembly, reverse engineering, decompilation, or otherwise attempt to gain access to the software source code.',

        sub_point_3:
            'The User must ensure and guarantee that all information and data transferred to parking provider is free of harmful elements, source code, or malware (such as viruses, worms, and trojan horses). Information that the User uploads to My Pages or makes available via the App must not infringe third-party intellectual property rights or otherwise violate laws, regulations, or the rights of others. It is the User’s responsibility to ensure that third-party or others’ intellectual property rights are not infringed.',

        sub_point_4:
            'Unless parking provider has acted with gross negligence or intent, parking provider is not responsible for any data being made available to third parties. parking provider uses customary security measures to protect data',
    },

    // --- 15. Force majeure
    Trade_Terms_main_point_15: {
        main_title: 'Force majeure',
        sub_point_1:
            'parking provider is not liable for damages or responsible for breakdowns or delays in the performance of the terms of this Agreement due to circumstances beyond parking provider’s reasonable control.',
    },

    // --- 16. Confidentiality
    Trade_Terms_main_point_16: {
        main_title: 'Confidentiality',
        sub_point_1:
            'The User accepts that parking provider reports any misuse of the Services, illegal activities, unlawful or inappropriate behavior and/or suspicion thereof to the police or other competent authorities.',
    },

    // --- 17. Governing law and disputes
    Trade_Terms_main_point_17: {
        main_title: 'Governing law and disputes',

        sub_point_1:
            'This Agreement is governed by and shall be interpreted in accordance with Danish law. Any dispute, disagreement, or claim arising out of or in connection with this Agreement, or any breach, termination, or invalidity thereof, shall as a starting point be resolved by voluntary agreement between the Parties. If agreement cannot be reached at first instance, a discussion shall be held between a representative chosen by the User and parking provider. If the Parties cannot reach an agreement, the dispute may be handled by the Danish courts with the City Court in Aarhus as the court of first instance. This clause 17.1 applies after the termination or expiry of this Agreement.',

        sub_point_2:
            'If a provision of this Agreement is set aside as invalid, the Agreement shall otherwise remain in force, and the invalid provision shall be replaced with a valid provision where possible.',

        sub_point_3:
            'parking provider reserves the right to amend these general terms and conditions for the use of parking provider. If this happens, parking provider shall immediately notify thereof and make a new version of the general terms and conditions for the use of parking provider available. If the User thereafter continues to use the services, this will be considered an acceptance of these changes. Notwithstanding this, parking provider reserves the right to change prices and fees/charges as a result of increases in operating costs, other costs, and increases in duties and charges, etc. The applicable general terms and conditions at any time can be found in the App or on the website.',
    },

    // --- 18. Subscription terms
    Trade_Terms_main_point_18: {
        main_title: 'Subscription terms',

        sub_point_1:
            'By registering for and using parking provider Subscription Parking, in addition to the below, the general terms and conditions for use of parking provider are also accepted. These terms appear in the parking provider app and on the website.',
        sub_point_1_1:
            'When entering into an agreement on subscription parking, the User obtains a time-limited digital parking permit.',

        sub_point_2:
            'The subscription parking agreement applies to the selected number of subscription parking agreements, which entitle to parking in the same number of parking bays at the selected parking site. For Subscription Parking, it is a condition of validity that the vehicle is correctly registered in parking provider. Correct and valid registration requires that the license plate number is correctly registered and that the vehicle is correctly registered on the subscription parking product. The registered vehicle may park in parking bays that are not otherwise reserved. This applies 24/7, every day of the week.',
        sub_point_2_1:
            'The subscription parking will appear under active parkings, rented parking spaces.',
        sub_point_2_2:
            'It is a condition of validity for correct and valid registration that the registered vehicle is selected as the favorite vehicle and appears correctly registered on the subscription parking product under rented parking spaces.',

        sub_point_3:
            'The subscription parking agreement applies to the use of a marked parking bay on a “first come, first served” basis. That is, with the subscription parking agreement the User only obtains a “floating right” to a marked parking bay that is not otherwise reserved. In the event that there is no available marked parking bay, parking provider cannot be held responsible, and the User is not entitled to a reduction of the fee.',
        sub_point_3_1:
            'The fact that the User does not use subscription parking for the entire selected period does not entitle the User to a reduction of the fee.',

        sub_point_4:
            'The subscription parking agreement takes effect from and including the date selected by the User and runs for the stated period. The subscription parking agreement may be terminated immediately by parking provider without further justification. The User may terminate no earlier than the end of a purchased period. Termination occurs by the User not renewing or extending the subscription parking agreement. If the User has chosen automatic renewal, the User must stop automatic renewal to terminate the subscription parking agreement.',
        sub_point_4_1:
            'The User may at any time only terminate the subscription parking agreement to the end of the selected period. In that case, no money will be debited from the User’s payment card until a new subscription parking agreement is created.',
        sub_point_4_2:
            'The subscription parking is valid from the selected date and for the selected period. A subscription parking agreement is therefore not necessarily valid from the 1st to the 1st of a month unless the User has chosen this.',

        sub_point_5:
            'The User is at all times solely responsible for ensuring that there is a valid subscription agreement for the vehicle parked at the parking site. It is likewise the User’s own responsibility that linked vehicles are registered correctly and completely on the profile. A control fee may be imposed if there has not been correct and complete registration of a parked vehicle. The control fee cannot subsequently be waived.',

        sub_point_6:
            'The content of the subscription parking agreement, prices, and any special conditions for the Product Packages will at all times be stated on the Website and in the App. The fee is paid in advance, the first time upon entering into the subscription parking agreement.',
        sub_point_6_1:
            'In some cases, the User will be given a unique product code to be used during registration. In connection with receiving the unique product code, the User is informed about how to proceed in relation to the payment obligation and how to register the unique product code.',
        sub_point_6_2:
            'In the event that the subscription parking agreement is terminated, rescinded, or withdrawn, or that the issued unique product code is canceled or blocked, parking provider is entitled to use the registered information, including the user’s email address, etc., to give notice thereof.',

        sub_point_7:
            'The fee is price-indexed each year on 1 January without further notice, and is adjusted by the net price index for October in the preceding year, but with a minimum of 3% (rounded to the nearest whole kroner) compared to the fee payment the year before. Indexation of the fee is based on the fee applicable immediately before the indexation, regardless of whether this fee may have arisen by regulation in a manner other than by indexation.',
        sub_point_7_1:
            'In addition to the above indexation, parking provider reserves the right to change prices and fees/charges as a result of increases in operating costs, other costs, and increases in duties and charges, etc. Such changes take effect at the earliest at the end of the current month + 1 month after the user has been informed of such changes.',

        sub_point_8:
            'Parking provider reserves the right for pricing errors, price changes, and update errors.',

        sub_point_9:
            'If the User has chosen automatic renewal, it is the User’s own responsibility to “stop” the automatic renewal by terminating the subscription parking agreement. Stopping payment is not considered termination. Payment is charged until termination of the subscription parking agreement.',

        sub_point_10:
            'All traffic and parking are at the user’s own risk. Parking provider is not responsible for theft or damages that may be inflicted on the user’s vehicle, regardless of the cause.',

        sub_point_11:
            'The subscription parking agreement may not, without written consent from parking provider, be used for anything other than parking of the correctly registered vehicle, with a registered total weight of max. 3,500 kg.',

        sub_point_12:
            'The User is expressly made aware by this subscription parking agreement that entering into this subscription parking agreement does not entitle the user to cancel imposed control fees. The subscription parking agreement is only valid from the time when the license plate number is correctly registered. The subscription parking agreement is only valid for the vehicle that is correctly registered.',
        sub_point_12_1:
            'The subscription parking agreement only entitles the User to park in the area stated in the subscription parking agreement, in the marked parking bays where it is not indicated that there are special rules applicable for parking in these parking bays. Please note that the subscription parking agreement is not a valid parking permit for parking in bays that are reserved.',

        sub_point_13:
            'In the event of the user’s material breach of the agreement, parking provider may terminate the subscription parking agreement with immediate effect. Material breach includes, among other things, but is not limited to, non-payment of the agreed fee, breach of the provisions of this agreement, and any violation of the parking rules. In the event of material breach, parking provider is entitled to impose a control fee and possibly remove or take the user’s vehicle into custody until the outstanding fees and costs are paid. The User has no right of set-off, even if there is/are disagreement(s) about the claim.',
        sub_point_13_1:
            'parking provider may terminate the subscription parking agreement with 1 month’s written notice in the event that maintenance, reconstruction, renovation, or similar circumstances must be carried out that mean that parking provider can no longer permanently use the parking bay.',

        sub_point_14:
            'Under the Danish Consumer Contracts Act (Act no. 1457 of 17 December 2013), the User has the right to withdraw from the Agreement by notifying parking provider customer service within 14 days after approval of the registration. To exercise the right of withdrawal, the withdrawal notice must be submitted to parking provider no later than on the 14th day from the day the payment was registered by parking provider.',
        sub_point_14_1:
            'If the deadline expires on a public holiday, Saturday, Constitution Day, Christmas Eve, or New Year’s Eve, the deadline is extended to the following business day',
        sub_point_14_2:
            'To exercise the right of withdrawal, the User must send us an email or a letter stating that the purchase/reservation is withdrawn. Please note that entering the parking lot/approval of the purchase in the app or on the website is considered acceptance that parking begins and an acceptance that the 14-day right of withdrawal is waived. If you then withdraw your purchase in the app or on the website, your refund will be reduced by a proportionate part of the total price for the parking in the purchased period, based on the number of days/hours/minutes the vehicle has been parked until parking provider received the registration of the exercise of the right of withdrawal',

        sub_point_15:
            'Any disputes between parking provider and the User regarding the interpretation of this agreement shall be settled by the ordinary courts applying Danish law. The Court of Aarhus is agreed as the venue.',

        sub_point_16:
            'The User is not entitled to sublet the parking bay. Violation hereof is considered a breach, cf. clause 13.',

        sub_point_17:
            'parking provider is the parking administrator on behalf of the site owner/site owner’s property administrator. All inquiries regarding this contract must be made to parking provider. If parking provider ceases to be the parking administrator, the agreement will be transferred to a new parking administrator.',

        sub_point_18:
            'With regard to the storage and processing of personal data, reference is made to the applicable data policy as stated above at any time. If the information is requested to be deleted, this is considered termination of the subscription parking agreement. This is because, in such cases, parking provider cannot maintain the agreement without the aforementioned information.',
    },

    // ### UPDATED TERMS END ###

    Footer_contact_info: {
        updatedAt: `Revised on 16.11.2022`,
    },

    // Act as user
    'Take Over': 'Take over',

    // Old Terms
    Terms_title: 'Terms and conditions',
    Terms_heading: 'DATAPOLICY AND COOKIES',
    Terms_last:
        'It is the drivers full responsibility that the information provided is correct. At the same time, the provider disclaims responsibility for any errors during creation.',

    Terms_1: {
        para_1: 'These guidelines apply to the information we collect on the people who provide these through the website, email and by phone. Upon providing Parkingskompagniet with personal information, you also consent to us processing your personal data in accordance with our datapolicy Personal data refers to any information related to an identifiable person We retain the right to change and update our datapolicy in accordance to the law and will, to the best of our ability, notify our customers of any changes',
        para_2: 'Databehandler er Parkeringskompagniet ApS',
        para_3: 'Ryesgade 7b, 8000 Aarhus',
        para_4: 'CVR-nr: 37127485',
        link_1: 'Telefon: <a href="tel:+ 45 88 77 31 50" class="text-pk-blue">+ 45 88 77 31 50</a>',
        link_2: 'Mail: <a href="mailto:service@oparko.com" class="text-pk-blue">service@oparko.com</a>',
    },

    Terms_2: {
        heading: 'Personal data policy',
        para_1: 'Personal data is only stored, if they are voluntarily submitted and we store them only in so far they are relevant for us',
        para_2: 'If you provide us information regarding another person, it is your responsibility to ensure that you have the right to provide us with this information.',
        para_3: 'We will only disclose your personal information, in so far that it is necessary for the service we provide.',
        link_1: 'You retain the right at all time to perview the personal data we have stored regarding yourself, and should they be incorrect, you retain the right to have the aforementioned information corrected. Furthermore you always retain the right to have your profile deleted from our systems. You always retain all the rights the European Union general data protection regulation has ensured private individuals. Should you have any inqueries regarding your personal data, please contact <a href="mailto:service@oparko.com" class="text-pk-blue">service@oparko.com</a>.',
    },

    Terms_3: {
        heading: 'Collection and processing of your personal data',
        para_1: 'We register and store your personal data, depending on the services you use. Should you eg. submit a complaint or become a customer at Parkeringskompagniet, your name, email-address and phonenumber will typically be stored. We store your personal data in order to facilitate the best service possible for you. You will be informed at any time in connection with the collection of information.',
        ul: {
            heading:
                'Collection of personal information generally happens in connection with:',
            list: [
                '♦ Payment of a parking fee',
                '♦ Contact in case of complaint or interest in making an agreement',
                '♦ Parking fee issuance',
                '♦ Parking control',
                '♦ Renting or reservation of a parking space',
                '♦ By using our app',
                '♦ Use of service that require payment, will necessary creditcard data and invoice information be stored',
                '♦ Newsletters and monthlyreports, insofar as you are already an existing customer at Parkeringskompagniet',
            ],
        },
    },

    Terms_4: {
        heading: 'Disclosure of personal data',
        para_1: 'We do not disclose your personal information with others, unless you have given your consent or in the case that it is required by the applicable legislation on personal data policy.',
        row_1: {
            heading: 'The legal basis for processing',
            para_1: 'Article 6 of the Data Protection Regulation, subsection 1, letter b, when a contract has been entered into between you as a parker and Parkeringskompagniet ApS',
            para_2: 'Article 6 of the Data Protection Regulation, subsection 1, letter f, when Parkeringskompagniet ApS has a legitimate interest in pursuing a claim against you as a parker, e.g. if you have parked in violation of the regulations in a parking space and have been charged a parking fee.',
            para_3: 'Article 6 paragraph 1, letter a of the Data Protection Regulation, when Parkeringskompagniet ApS has obtained your consent to send you newsletters.',
        },

        row_2: {
            heading: 'Source',
            para_1: 'Parkeringskompagniet collects personal data directly from you and/or third parties, eg. from our customer or from our subcontractors.',
        },

        row_3: {
            heading: 'Where is your personal data stored?',
            para_1: 'Your personal data is stored on our internal network and can only be accessed with special rights. We do not have access to paymentinformation, as these are encrypted by our payment partners.',
            para_2: 'Cookies is a textfile, that is placed in the device you use to connect to our website, this makes it possible to recognize the device and gather information on which site and functions that are visited. Cookies contain data in an anonymized form.',
            para_3: 'You are anonymous in our cookie-data, until you yourself subscribe to any of our services or contact us and provide your personal information.',
            link: 'Our website uses Google Analytics, which is a website that provides us with webbased analysis service - they use cookies. This is used solely for the purpose of improving the experience of our users. We collect exclusively information on your use of Parkeringskompagniet’s website. Google Analytics collects information regarding your OS, browser, IP-address, previously visited website and date and time for when you visited our website. We do not use data from cookies to collect personal data and none of the information provided by cookies, is ever sold or disclosed. For more information on Google Analytics’ use of cookies, please visit: <a href="https://policies.google.com/privacy?hl=da" class="text-pk-blue">HTTPS://POLICIES.GOOGLE.COM/PRIVACY?HL=DA</a>',
        },

        row_4: {
            heading: 'Opt-out of cookies',
            link: 'Should you at some point wish to opt out of cookies, you can visit your browser-settings and turn them off from there. You can read more about opting out of cookies on your browser, at: <a href="http://www.minecookies.org/" class="text-pk-blue">WWW.MINECOOKIES.ORG</a>',
        },

        row_5: {
            heading: 'What happens if I opt-out of cookies?',
            para_1: 'If you opt out of cookies, it will not be registered when you browse Please be advised, if you disable cookies, some functions on the website might not work as intended and may result in the website not functioning properly.',
        },

        row_6: {
            heading: 'Why do we provide information on cookies?',
            para_1: 'We provide information on cookies, as all Danish websites are required to inform on the use of these, according to the requirement on information and consent to storing of or access to information of the end user’s terminal equipment.',
        },

        row_7: {
            heading: 'Do you wish to contact us?',
            link: 'If you have unsolved questions or wish to contact us further, please refer to the <a href="https://parkeringskompagniet.dk/kontakt/" class="text-pk-blue">kontakt siden</a>',
        },
    },
    ReceptionUser: {
        countryError: 'Country have not been chosen',
        registrationError: 'Registration no. have not been chosen',
        emailError: 'Email have not been chosen',
        customEndDateError: 'Select end time (at least 30 min from now)',
        phoneNumberError: 'Phone number have not been chosen',
        acceptError: 'Accept terms have not been chosen',
        countryCodeError: 'Country Code have not been chosen',
    },
    'Select the Date of Parking': 'Select the Date of Parking',
    'Enter your Full Name': 'Enter your Full Name',

    Phonenumber: 'Phonenumber',
    'Enter your Email': 'Enter your email',
    'Choose your enddate': 'Choose enddate',
    'Choose your startdate': 'Choose startdate',
    'Valid from': 'Valid from',
    'Valid until': 'Valid until',
    'Create new guest parking': 'Create new guest parking',
    ERR_TIME_RULE_HOUR: 'Permits may only be created during these hours:',
    ERR_TIME_RULE_DAY_Monday: 'Permits can not be created on mondays',
    ERR_TIME_RULE_DAY_Tuesday: 'Permits can not be created on tuesday',
    ERR_TIME_RULE_DAY_Wednesday: 'Permits can not be created on wednesday',
    ERR_TIME_RULE_DAY_Thursday: 'Permits can not be created on thursday',
    ERR_TIME_RULE_DAY_Friday: 'Permits can not be created on friday',
    ERR_TIME_RULE_DAY_Saturday: 'Permits can not be created on saturday',
    ERR_TIME_RULE_DAY_Sunday: 'Permits can not be created on sunday',
    'Custom end date': 'Ability to choose enddate',
    'Max time in min (0 is no limit)': 'Max time in minutes (0 = no limit)',

    'Please enter your registration number':
        '* Please enter your registration number',
    'Please enter your E-mail address': '* Please enter your E-mail address',
    fillField: '* Please fill in this field',
    'Please choose a date/time':
        '* The end date/time should be at least 30 minutes after the current time',
    'Start time before end time': 'Start time cannot be before end time.',
    'Please enter your phone number': '* Please enter your phone number',
    'Please accept our terms to continue': '* Required',

    ConfirmPermit: {
        lineOne: 'A guest parking lot has now been set up at',
        for: 'for',
        on: 'on',
        at: 'at',
        lineTwo: 'which is valid up to and including',
    },
    'Receive SMS?': 'Receive SMS?',
    'Guest Parking has been created!': 'Guest Parking has been created!',
    'A Guest parking permit has now been created':
        'A Guest parking permit has now been created',

    ReceptionPermitSuccessPopup: {
        created: 'A new permit has been successfully created!',
        subtitle: 'You can view the details below.',
        createAnother: 'Click here to create another permit.',
        notValid: 'Not valid',
        onePermitAllowedPerDay:
            'A permit has already been given for this car today Only 1 permit pr. car pr. day allowed',
        erroPermitLimit: 'ERROR - Permit Limit',
    },

    // Entities

    Reception: 'Reception',
    HotelReception: 'Hotel Reception',
    EmployeeReception: 'Employee Reception',
    TimesReception: 'Times Reception',
    HotelAdmin: 'Hotel Admin',
    ConfirmationReception: 'Confirmation Reception',
    HotelReceptionConfirmation: 'Hotel Reception Confirmation',
    StayNTouchReception: 'Stay-N-Touch Reception',
    APIPartner: 'API Partner',
    SMSConfirmationReception: 'SMS Confirmation Reception',
    Guest_parking_created:
        'A guest parking for {{regNo}} has been created, valid until {{date}}.',
    'Something went wrong. Please try again.':
        'Something went wrong. Please try again.',
    Enter_registration_number: 'Enter registration number',
    Confirm: 'Confirm',
    Clear_all: 'Clear all',

    View: 'View',
    Edit: 'Edit',
    AppFines: 'AppFines',
    AppPermits: 'AppPermits',
    NOT_DEFINED: 'NOT_DEFINED',
    SELF_TICKETING: 'SELF_TICKETING',
    SelfTicketing: 'SelfTicketing',
    'Self Ticketing': 'Self Ticketing',
    COMBI: 'COMBI',
    P_WARDEN: 'P_WARDEN',
    CAMERA_CONTROL: 'CAMERA_CONTROL',
    Partner: 'Partner',
    Private: 'Private',
    Company: 'Company',
    'Not Handled': 'Not Handled',
    'Not handled': 'Not handled',
    Approved: 'Approved',
    Rejected: 'Rejected',
    'Other - write a comment in the note':
        'Other - write a comment in the note',
    'Outside Booth': 'Outside Booth',
    'No permission to the area': 'No permission to the area',
    'Parking disc exceeded': 'Parking disc exceeded',
    'Parking or full stop on prohibited area':
        'Parking or full stop on prohibited area',
    'Parking on fire access road': 'Parking on fire access road',
    'Handicapped parking without permission':
        'Handicapped parking without permission',
    Deleted: 'Deleted',
    'Guest Parking': 'Guest Parking',
    'Oprettelse af medarbejderparkering': 'Creation of employee parking',
    'Employee Parking Creation': 'Creation of employee parking',
    'Employee parking creation': 'Creation of employee parking',
    Resident: 'Resident',
    'Paid ticket': 'Paid ticket',
    'Employee paid ticket': 'Employee paid ticket',
    'Employee upper basement': 'Employee upper basement',
    'Employee lower basement': 'Employee lower basement',
    Permanent: 'Permanent',
    License: 'License',
    Reminder: 'Reminder',
    'Active - Foreign': 'Active - Foreign',
    'Debt collection - Paragraph': 'Debt collection - Paragraph',
    Ended: 'Ended',
    Foreign: 'Foreign',
    Paused: 'Paused',
    'Debt collection - Paragraph - installment agreement with demand':
        'Debt collection - Paragraph - installment agreement with demand',
    'Debt collection - Paragraph - with demand':
        'Debt collection - Paragraph - with demand',
    'Debt collection - Liquidation': 'Debt collection - Liquidation',
    'Debt collection - Liquidation - installment agreement with demand':
        'Debt collection - Liquidation - installment agreement with demand',
    'Complaint Council': 'Complaint Council',
    All: 'All',
    'Occupancy in': 'Occupancy in percent',

    // Subscription
    Next: 'Next',
    Previous: 'Previous',
    Subscription: 'Subscription',
    Submit: 'Submit',
    Subscribers: 'Subscribers',
    'Already subscribed': 'Already subscribed',
    'Your Cars': 'Your Cars',
    'E.g.': 'E.g.',
    'Location Name': 'Location Name',
    '12th Star Avenue': '12th Star Avenue',
    'Step 1: Which parking lot do you want to park at?':
        'Step 1: Which parking lot do you want to park at?',
    'Step 2: Which license plate does your car have?':
        'Step 2: Which license plate does your car have?',
    'Step 3: When should your subscription start?':
        'Step 3: When should your subscription start?',
    'Step 4: Your monthly price is based on the selected parking lot, and will be:':
        'Step 4: Your monthly price is based on the selected parking lot, and will be:',
    'Step 5: To be allowed to create a subscription for this private parking lot, you must enter a pin code below. Next, click on Create to go to the payment site. Once you are done, you will be redirected back to our page, where you can find your subscription in the table.':
        'Step 5: To be allowed to create a subscription for this private parking lot, you must enter a pin code below. Next, click on Create to go to the payment site. Once you are done, you will be redirected back to our page, where you can find your subscription in the table.',
    'Step 5:  Click on Create to go to the payment site. Once you are done, you will be redirected back to our page, where you can find your subscription in the table.':
        'Step 5:  Click on Create to go to the payment site. Once you are done, you will be redirected back to our page, where you can find your subscription in the table.',
    'Below you can below see the available days, times and prices':
        'Below you can below see the available days, times and prices',
    'Available days, times and prices': 'Available days, times and prices',
    'Transaction fee': 'Transaction fee',
    'Subscription Info': 'Subscription Info',
    'Monthly price': 'Monthly price',
    'Last recurring payment date': 'Last recurring payment date',
    'Car Info': 'Car Info',
    'Enter registration number': 'Enter registration number',
    'Buy monthly subscription': 'Buy monthly subscription',
    'Buy short ticket': 'Buy short ticket',
    'Short ticket': 'Short ticket',
    'The price is': 'The price is',
    'kr pr. month, but the price on specific parking spots may vary':
        'kr pr. month, but the price on specific parking spots may vary',
    'Registration number': 'Registration number',
    'PIN code': 'PIN code',
    'Email id is already registered with us':
        'Email id is already registered with us',
    'Buy ticket': 'Buy ticket',
    'Get ticket': 'Get ticket',
    'Permit id': 'Permit id',
    'Last payment': 'Last payment',
    'Price per period': 'Price per period',
    'Stop subscription': 'Stop subscription',
    'Price: 500 kr. per month (normal price is 625 kr. per month - The discount is active for the rest of 2023)':
        'Price: 500 kr. per month (normal price is 625 kr. per month - The discount is active for the rest of 2023)',
    'Payment Options': 'Payment options',
    'Create Subscription Rule': 'Create Subscription Rule',

    // FAQs
    'How do I see and create a permit?': 'How do I see and create a permit?',
    'How do I see the fines that has been made at my parking space?':
        'How do I see the fines that has been made at my parking space?',
    'How do I cancel a fine?': 'How do I cancel a fine?',
    'How do I create a user?': 'How do I create a user?',
    'How do I change the numberplate on an existing permit?':
        'How do I change the numberplate on an existing permit?',
    'How do I extend a permit?': 'How do I extend a permit?',
    "What to do if something doesn't work?": `What to do if something doesn't work?`,
    'How often do you pay out customer shares?': `How often do you pay out customer shares?`,
    'Why am I being paid for a parking fee that is several years old now?':
        'Why am I being paid for a parking fee that is several years old now?',
    'Status and their meanings': 'Status and their meanings',

    // FAQ
    Introduction: 'Introduction',
    'Usage of platform': 'Usage of platform',
    'Platform features': 'Platform features',
    'Usage of app': 'Usage of app',
    Settlements: 'Settlements',
    Danish: 'Danish',
    English: 'English',

    // Introduction
    'Hvor kan jeg se en præsentationsvideo af OPARKO?': `Where can I see a presentation video of OPARKO?`,
    'Hvad gør jeg hvis noget ikke virker?': `What do I do if something doesn't work?`,

    // answerIntro_1: {
    //     paragraph1: `Here is a presentationvideo of OPARKO`,
    // },

    answerIntro_2: {
        paragraph: `It often helps to log out and back in again, so we always recommend that you try this first. If it still doesn't work, you are always welcome to email us at service@oparko.com. To help us assist you more quickly, please include screenshots of the issue (if applicable). If you need immediate assistance, our phone line is open Monday, Tuesday, and Thursday from 11:00 to 15:00, and Friday from 11:00 to 13:00. Call us at 8874 3194.`,
    },

    // Usage of platform
    'Hvordan ser og opretter man tilladelser?': `How do I see and create permits?`,
    'Hvordan ser jeg afgifter som er lavet på min parkeringsplads?': `How do I see the fines that have been made at my parking lot?`,
    'Hvordan opretter man en bruger?': `How do I create a user?`,
    'Hvordan annullerer jeg en afgift?': `How do I cancel a fine?`,
    'Hvordan ændrer jeg nummerplade på en tilladelse?': `How do I change the license plate on a permit?`,
    'Hvordan forlænger jeg en tilladelse?': `How do I extend a permit?`,
    'Status og deres betydninger': `Status and their meanings`,

    answerParkOparko_1: {
        paragraph: `Click on "Dashboard" on the left side, then select "Permits." On this page, you can view the latest permits. To search for a specific permit, you can do so by entering a license plate number or ID in the search field at the top. To create a new permit, click on the "Create Permit" button. Fill in the fields with the car's information. License plate number, Parking spot, and Type are mandatory fields. Notes can be used to provide additional information about the permit. "Note" can only be seen by the administrator. "External note" can be seen by the guards when they conduct parking inspections. If a car is only allowed to park in a specific spot, you can, for example, write in the external note; "Spot 22." Remember to set an "End date" for the permit. If the car requires a permanent permit, click on the "Permanent permit" box. Finally, click "Create."`,
    },

    answerParkOparko_2: {
        paragraph: `Click on "Dashboard" and then on "Fines." On this page, you can see the most recently issued fines. If you want to search for a specific fine, you can do so by searching for the car's license plate number or the fine's ID in the search field at the top. To see more information about a specific fine, click on it. "Status" indicates the stage of the fine in the enforcement process. "Active" means the fine has been issued. "Enforcement" means a letter has been sent to the fine recipient. "Paid" means we have received payment for the fine. "Settled" means your share of the fine has been paid out to you. "Cancelled" means the fine has been annulled.`,
    },

    answerParkOparko_3: {
        paragraph: `Click on "Dashboard" and then on "Users." Here, you can see a list of all the users associated with your organization. To create a new user, click on "Create User." Enter the user's information. For convenience, we recommend using the email address as the username as well. Select which parkinglots the user should have access to and whether the user should have access to the platform and/or the app. Choose an end date for the user. If the user should be permanent, check the "Permanent User" box. Finally, click "Create." An email will then be sent to the user with their login information.`,
    },

    answerParkOparko_4: {
        paragraph: `Open the fine you wish to cancel by clicking on it. A window with more information will then open. Click on the "Status" field and select "Cancelled." Scroll down the page and write a comment explaining why the fine should be cancelled. Click "Save" to save the comment, and finally, click "Update." The fine is now cancelled.`,
    },

    answerParkOparko_5: {
        paragraph: `On the 'Permits' page, enter the vehicle's license plate number in the search field and press enter/Search. In the list below, click on the relevant permit. In the 'Reg. No.' field, change it to the new license plate number. Then, check that the parking space, end date, and other details are correct, and click on 'Update.'`,
    },

    answerParkOparko_6: {
        paragraph: `On the 'Permits' page, enter the vehicle's license plate number in the search field and press enter/Search. In the list below, click on the relevant permit. In the 'End date' field, select a new end date. Then, check the remaining details are correct, and click on 'Update.'`,
    },

    answerParkOparko_7: {
        paragraph1: `Active: The fine has been created in our system.`,
        paragraph2: `Collection: The fine has been sent for collection by our partner, and a letter has been sent to the offender.`,
        paragraph3: `Paid: When the fine is paid, its status changes to paid.`,
        paragraph4: `Settled: The fine's share has been disbursed to the issuer.`,
        paragraph5: `Canceled: The fine has been canceled in our system.`,
        paragraph6: `Protected: Foreign case.`,
    },

    // Usage of app
    'Hvordan laver man tilladelser i appen?': `How do I create permits in the app?`,
    'Hvordan opretter man afgift i appen?':
        'How do I create a fine in the app?',

    answerApp_1: {
        paragraph: `To create a permit in the OPARKO app, you first need to select the parking lot where the permit will apply. Then, enter the vehicle's license plate number and specify the dates for which the permit should be valid. If desired, you can also add additional details in the notes field, such as specific instructions. Next, enter an email address so the user can receive a confirmation. Once all required information is filled in, click "Create Permit." If a permit already exists for the entered license plate, the app will notify you and give you the option to edit the existing permit instead of creating a new one.`,
    },
    answerApp_2: {
        paragraph: `To create a parking fine in the OPARKO app, start by selecting the relevant parking lot. Then, manually enter the vehicle's license plate or use the app's live-scan feature to automatically capture the plate. Once the license plate is registered, select "Create Fine" and follow the process to attach a valid fine slip with a QR code. Scan the QR code on the yellow fine slip to link it to the fine. Next, take the four required photos as guided by the app. After capturing the photos correctly and according to the app's instructions, finalize the fine creation in the app. Lastly, place the golden slip on the vehicle's windshield as visible documentation. The fine is now correctly registered in the system.`,
    },

    // Settlements
    'Hvor ofte afregner I?': `How often do you settle?`,
    'Hvorfor afregnes jeg for en flere år gammel afgift nu?':
        'Why am I being paid for a parking fee that is several years old now?',

    answerSettlements_1: {
        paragraph: `In the cooperation agreement/contract we have entered into, you will find answers regarding how often settlements are made. The standard is once every three months.`,
    },
    answerSettlements_2: {
        paragraph: `How quickly a fine is paid after issuance can vary from 'immediately' to 'never.' This means that fines issued months or years ago may appear on your current settlement because they have been paid since our last settlement with you.`,
    },

    // weekdays
    weekdaysOnly: 'Weekdays only',
    Mon: 'Mon',
    Tue: 'Tue',
    Wed: 'Wed',
    Thur: 'Thu',
    Fri: 'Fri',
    Sat: 'Sat',
    Sun: 'Sun',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    Hourly: 'Hourly',
    Weekly: 'Weekly',
    Hour: 'Hour',
    hour: 'hour',
    hours: 'hours',
    Day: 'Day',
    day: 'day',
    'half-hour': 'half hour',
    'half-hours': 'half hours',
    days: 'days',
    week: 'week',
    Week: 'Week',
    weeks: 'weeks',
    Month: 'Month',
    months: 'months',
    'Number of': 'Number of',
    First: 'First',
    to: 'to',
    Free: 'Free',
    'Subscription per month': 'Subscription per month',
    'Price per month': 'Price per month',
    'No limit on': 'No limit on',
    After: 'After',
    Percentage: 'Percentage',
    Count: 'Count',
    Organisation: 'Organisation',
    Organisations: 'Organisations',
    'All days': 'All days',
    'All day': 'All day',
    Valid: 'Valid',
    month: 'month',
    Per: 'Per',

    // Months
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',

    // popup box - accepted
    accepted_title: 'Purchase accepted',
    accepted_description1:
        'Your have successfully bought a parking permit for your car',
    accepted_description2:
        'If an e-mail has been specified in the previous e-mail field, a confirmation e-mail will be sent to the specified e-mail address.',
    accepted_description3:
        'As documentation for the parking permit you can use:',
    accepted_description4:
        'A print screen of a bank transfer which has been debited',
    accepted_description5: 'Print screen of a Mobilepay-payment',
    accepted_description6: 'The confirmation email which has been sent to you',
    accepted_description7:
        'If there should be any further questions and/or doubts about your payment you can contact us on',
    accepted_description8: 'You can now close the window.',

    Ok: 'Ok',
    // popup box - successfull
    successfull_title: 'Welcome to Oparko!',
    successfull_description: 'Your subscription is now active.',
    successfull_description1:
        'You have received all the information about your subscription in your email. You can view and update details about your subscription directly on the platform by logging in.',
    successfull_description2:
        'You can now close this window to access your account.',

    // popup box - declined
    declined_title: 'Unfortunately, there was a mistake with your payment',
    declined_description:
        'Your subscription account was still created, but it is not active. This means we will not take any payments from you, nor will you have an active permit to park your car.',
    declined_description1:
        'You have received all the necessary information to log in to our platform via your email. From our platform, you can find the payment link to attempt another payment if you wish.',
    declined_description2:
        'Alternatively, you can use the link below to try again:',
    declined_description3: 'Or contact Oparko Support here:',
    declined_description4:
        'If you have any questions regarding the payment, you can contact us at',
    'Open Subscription': 'Open Subscription',
    pay_subscription_heading: 'Pay Subscription',
    pay_subscription_description:
        'You are attempting to pay for your subscription account, please confirm to proceed with your payment.',
    'Cancel Subscription': 'Cancel Subscription',
    cancel_sub_description:
        'We are sorry to see you leave Oparko. If you are sure about canceling your subscription, please click "Accept" to confirm your decision.',
    cancel_sub_description1:
        'Please note that your subscription will remain active until the end of your current billing period. We will not charge you further, and your subscription will become inactive starting next month.',
    subscription_already_cancelled:
        'This subscription has already been cancelled.',
    'No Future payments': 'No Future payments',

    // Disclaimer texts used in ticket service modal when you buy a ticket
    ticket_service_disclaimer_1:
        'Please note that it is not possible to stop your parking permit early. It is not possible to extend your parking permit, if you want to keep parking, you must buy a new permit when the first one has expired. Furthermore, it is not possible to cancel a permit after it has created.',
    ticket_service_disclaimer_2:
        "We draw particular attention to the fact that it is the user of the car's full responsibility that the information provided is correct. At the same time, org_name disclaims responsibility for any errors during creation. When you buy a parking ticket, you also agree to our terms and conditions. You therefore also consent to our personal data policy.",
    subscription_service_disclaimer:
        "We draw particular attention to the fact that it is the party's full responsibility that the information provided is correct. At the same time, org_name disclaims responsibility for any errors during creation. When you buy a subscription, you also agree to our terms and conditions. You therefore also consent to our personal data policy.",
    subscription_service_disclaimer_2: `The subscription parking agreement only entitles you to park in the area that appears in the subscription parking agreement, in the marked parking bays where it does not appear that there are special rules applicable to parking in these parking bays. Attention is drawn to the fact that the subscription parking agreement is not a valid parking permit for parking in parking stalls that have been reserved.`,
    'Update Card': 'Update Card',
    'Pay Subscription': 'Pay Subscription',
    'Update payment card': 'Update payment card',
    update_card_description:
        'You are trying to update your credit card information. Please confirm to proceed with the update.',
    update_card_cancel: 'Unfortunately, there was an error updating your card.',
    update_card_cancel_description:
        'Your subscription account is still active, with an active permit. If you wish to update your card information, please try again.',
    update_card_cancel_description2:
        'If you have any questions regarding updating your card, you can contact us at ',
    update_card_accept: 'Your card update was successful.',
    update_card_accept_description:
        'Your card information has been updated to your subscription account.',
    update_card_accept_description2:
        'If you have any questions regarding updating your card, you can contact us at ',

    // Months
    Jan: 'Jan',
    Feb: 'Feb',
    Mar: 'Mar',
    Apr: 'Apr',
    May: 'May',
    Jun: 'Jun',
    Jul: 'Jul',
    Aug: 'Aug',
    Sep: 'Sep',
    Oct: 'Oct',
    Nov: 'Nov',
    Dec: 'Dec',

    // redirectFromPK
    'Important announcement': 'Important announcement',
    'Welcome! You have landed here because Parkeringskompagniet has now become':
        'Welcome! You have landed here because Parkeringskompagniet has now become',
    'We have upgraded to a new management platform to offer you an even better user experience':
        'We have upgraded to a new management platform to offer you an even better user experience.',
    'What should you do now?': 'What should you do now?',
    'Your existing information is automatically transferred. You just have to log in from the new platform now':
        'Your existing information is automatically transferred. You just have to log in from the new platform now',
    'New Functions': 'New Functions',
    'The new platform can do everything you are used to, plus much more!':
        'The new platform can do everything you are used to, plus much more!',
    'Do you have questions? Contact us at service@oparko.com':
        'Do you have questions? Contact us at service@oparko.com',
    'E-mail at': 'E-mail til',
    'Call at': 'Call at',
    'Phone hours:': 'Phone hours:',
    'Go to new admin platform': 'Go to new admin platform',

    // Pay fine
    'How to appeal': 'How to appeal',
    'Get documentation': 'Get documentation',
    'Complaint form': 'Complaint form',
    'Select a reason': 'Select a reason',
    'Select driver identity': 'Select your identity',
    Appeal: 'Appeal',
    GoBack: 'Go Back',
    CloseCase: 'Close case',
    'Submit an appeal': 'Submit an appeal',
    'Pay fine': 'Pay fine',
    'Pay case': 'Pay case',
    'License plate': 'License plate',
    'Fine id': 'Fine-id',
    'Fine documentation': 'Fine documentation',
    retrieve_fine_documentation_text:
        'Please note that not all fines provide access to documentation. The reference number is the ID associated with your fine.',
    'Valid permit': 'Valid permit',
    'Type in complaint here': 'Type in complaint here',
    Attachments: 'Attachments',
    'Select files': 'Select files',
    'Select file': 'Select file',
    'Drop files here...': 'Drop files here...',
    'No files selected': 'No files selected',
    file_limit_info: 'Max {{maxFiles}} files, each up to {{maxSize}} MB',
    file_limit_error: 'You can upload up to {{max}} files only.',
    file_size_error:
        'Each file must be smaller than {{max}} MB. "{{name}}" is too large.',
    complaint_form_text:
        'Please note that all appeals related to parking fines, including complaints, payments, reminders, and similar matters, must be submitted in writing using the form provided below. It is imperative that we receive all necessary information in written form.',
    Received_fine: 'Why you received a parking fine',
    Offense: 'Select reason',
    selectReason2: 'Select reason 2',
    OffenseDocumentation: 'Offense',
    OffenseNote: 'Offense Note',
    DriverIdentity: {
        label: 'Identity',
    },
    DRIVER_OPTIONS: {
        DRIVER_MYSELF: 'I was the driver of the vehicle myself',
        DRIVER_NOT_MYSELF: 'Another person was the driver of the vehicle',
        BEHALF_OF_OTHER: 'I am contacting you on behalf of another person',
    },
    'Driver Name': 'Driver Name',
    'Your e-mail': 'Your e-mail',
    'Submitted information': 'Submitted information',
    'Driver phonenumber': 'Driver phone number',
    'Driver address': 'Driver address',
    'Driver postcode': 'Driver postcode',
    'Driver city': 'Driver city',
    '01': 'Parked outside of designated space',
    '001': 'The fine has been issued due to parking outside of a marked parking space. This can be either parking beyond the lines or entirely outside of a designated parking space. As indicated by the signage on the premises, parking is only allowed in marked parking spaces. Violation of this condition results in a parking fine. The parking attendant has documented the parking with photos.',
    '02': 'Parked in an inappropriate location, e.g., in front of a loading zone or traffic area',
    '002': 'The fine has been issued because the parking is inappropriate, for example, in relation to a loading zone, access road, or similar. This is the case if your car, for instance, obstructs access to other roads or blocks traffic in the area.',
    '03': 'No valid permit for the area',
    '003': 'The fine has been issued due to a lack of permission. As indicated by the signage on the premises, permission is required for stopping and parking on the premises. The vehicles stay on the premises exceeds the specified observation time. Therefore, a violation of the premises applicable terms has occurred, resulting in a parking fine.',
    '04': 'Permit not visible or expired',
    '004': 'The fine has been issued because the permit was either not visible or had expired. If the parking attendant has not been able to sufficiently verify the permit or if it has expired, the conditions have been violated. Violating the conditions results in a parking fine.',
    '05': 'Not paid for parking in a paid parking space',
    '005': 'The fine has been issued due to a lack of permission. As indicated by the signage on the premises, permission is required for stopping and parking on the premises. We have not registered a purchased permit in our system for the specific space, and thus, the premises conditions have been violated. Violating the conditions results in a parking fine.',
    '06': 'Exceeded the time on the parking disc',
    '006': "The fine has been issued because the car's parking disc exceeded the allowed time. The signs indicate that parking is allowed for a limited time with a correctly set parking disc.The cars parking disc was set incorrectly, not set at all, or the car was parked for longer than allowed. The parking attendant has documented the parking with photos.",
    '07': 'You have altered the time on the parking disc without moving the car',
    '007': 'The fine has been issued because the parking disc was altered, and parking continued. It is only allowed to park on the premises for a limited time, and by changing the parking disc, one can park for longer than what the rules allow. This results in a parking fine.',
    '08': 'Parking or stopping in a no-stopping zone',
    '008': 'The fine has been issued because the car was parked in an area where stopping and parking are prohibited. This results in a parking fine. The parking has been documented with photos.',
    '09': 'Parking on a fire lane',
    '009': 'The fine has been issued because the car was parked on a fire or rescue lane. Parking on such lanes is not allowed and results in a parking fine. The parking attendant has documented the parking with photos.',
    '10': 'Parking in a disabled parking space without a visible disabled parking sign',
    '010': 'The fine has been issued because the car was parked in a disabled parking space without a visible permit displayed. As indicated by the signage, the specific space is a disabled parking space. This means that a disabled parking permit is required. In this regard, reference is made to the "Executive Order on Parking Cards for Persons with Disabilities and Institutional Cards" (BEK no. 782 of 07/08/2019), especially § 13, paragraph 1, which states: "When a parking card or institutional card is used, it must be placed inside the windshield with the front side of the card clearly visible for inspection." Here is a link to the executive order: Link. The parking attendant has documented the parking with photos.',
    '11': 'Parked in a space reserved for electric cars charging, or not moved the car after charging is complete',
    '011': 'The fine has been issued because parking in this area is only allowed for electric cars during charging. If the car is no longer (or was not) charging, parking is not allowed in this area. Therefore, parking is in violation of the premises conditions, resulting in a parking fine. The parking attendant has documented the parking with photos.',
    '12': 'You have not complied with the rules and conditions posted on the premises',
    '012': 'The fine has been issued because the posted conditions on the premises have not been complied with. Violating the conditions results in a parking fine.',
    Disagree:
        'If you believe that your fine is unjustified, you can submit a written complaint, please fill in the fields below',
    Price: 'Price',
    'Extra Charges': 'Extra Charges',
    'Pay your fine here.': 'Pay your fine here.',
    'View your documentation here.': 'View your documentation here.',
    'File a Complaint': 'File a Complaint',
    'Fill in your information in the form below':
        'Fill in your information in the form below',
    Coords: 'Location',
    Continue: 'Continue',
    Topic: 'Subject',
    terms_acceptance_notice:
        'By using this service, you accept our privacy policy. You can read more here:',
    'Terms, conditions and privacy policy':
        'Terms, conditions and privacy policy',
    faq_message: 'You can read answers to the most common questions here:',
    'Why you received a control fee': 'Why you received a control fee',
    complaint_for_ticket_notice: 'When is it worth submitting an appeal?',
    complaint_for_ticket_details:
        'If you already know that the parking fee was issued because of a mistake you made while parking, an appeal will unfortunately not change anything – whether by phone or via the appeal form. This is because we are unable to cancel fees that were issued correctly.',
    email_usage_payment_receipt:
        'Your email address is used solely for the purpose of issuing a payment receipt. It will not be used for marketing purposes or shared with third parties.',

    Cant_find_Fine_id: {
        HeaderText:
            "We couldn't find a fine with the entered Reference Number and License Plate.",
        SubtextDocu:
            'The case is closed and it is not possible to access documentation about the case here. If you believe this is an error, please use the form under the "Submit an appeal" tab.',
        SubText:
            'Please double-check that the information is correct. If needed, go back and try again, or submit an appeal under the "Submit an appeal" tab',
    },

    ticket_info_login_form: {
        errors: {
            reference_number: 'Please enter a reference number',
            license_plate: 'Please enter a license plate',
        },
    },

    fineId: 'Reference id / fine id / invoice id',

    ComplaintFormErrors: {
        name: "Please enter the driver's name.",
        phone_required: "Please enter the driver's phone number.",
        phone_invalid: 'Please enter a valid phone number.',
        email_required: 'Please enter your email.',
        email_invalid: 'Please enter a valid email address.',
        address_required: "Please enter the driver's address.",
        zipCode_required: "Please enter the driver's postcode.",
        city_required: "Please enter the driver's city.",
        subject: 'Please enter a subject.',
        complaintText: 'Please enter your appeal.',
        offence: 'Please select a reason.',
        driverOption: 'Please select a driver option',
        driverIdentity: 'Please select your identity',
    },

    Fine_is_paid: 'This fine has already been paid.',
    Fine_paid:
        'This fine has already been paid. You can always view the documentation here for reference.',

    Fine_Paid: {
        HeaderText: 'This case has already been paid and is now closed.',
        SubtextDocu:
            'Therefore, it is not possible to access the documentation. If you believe this is an error, please use the form under the "Submit an appeal" tab.',
        SubText:
            'No further payment can be made. If you believe this is an error, please use the form under the "Submit an appeal" tab.',
    },

    case_closed: {
        HeaderText: 'This case is closed.',
        SubtextPay:
            'No further payment can be made. If you believe this is an error, please use the form under the "Submit an appeal" tab',
        SubtextDocu:
            'The case is closed and it is not possible to access documentation about the case here. If you believe this is an error, please use the form under the "Submit an appeal" tab.',
    },

    Cant_get_documentation:
        'It is no longer possible to retrieve documentation for this fine.',
    Send_complain: 'The complaint has been submitted.',
    Error_send_complain:
        'An error occurred, please check that all fields are filled in correctly.',
    // payment accepts
    payment_approve: 'Approved',
    payment_approve_1: 'Payment of the control fee has been completed',
    payment_approve_2:
        'We confirm that your payment of the control fee has been completed. The sent confirmation email serves as documentation that the control fee has been paid.',
    payment_approve_3:
        'We always send the fine notice by mail, but as indicated in the letter, this can be disregarded if sufficient payment has already been made.',
    payment_approve_4:
        'Terms and conditions for payment of the control fee can be read at the following link:',
    payment_approve_5:
        'If you have further questions or doubts regarding the payment, you are welcome to contact us at: ',
    payment_approve_6: 'The window can now be closed.',
    // payment decline
    payment_decline: 'Error during payment',
    payment_decline_l1: 'Sorry, but unfortunately something went wrong.',
    payment_decline_l2:
        'Your payment for the control fee could not be completed.',
    payment_decline_l3:
        'Please double check that the information entered is correct.',
    payment_decline_l4:
        'For more information about payment, please see the terms and conditions at the following link: ',
    payment_decline_l5:
        'If you have further questions or doubts regarding the payment, you are welcome to contact us at:',
    payment_decline_l6: 'The window can now be closed.',
    // Complaint sent
    complaint_appeal_submit: 'Recieved',
    complaint_appeal_submit_1: 'We confirm, that we have received your email',
    complaint_appeal_submit_2:
        'If the information in the form has been filled out correctly and includes the reference number, the case is on hold and will be reviewed as soon as possible.',
    complaint_appeal_submit_3:
        'We will get back to you once a decision has been made.',
    complaint_appeal_submit_4:
        'The expected processing time is 10 business days.',
    complaint_appeal_no_repeat_please:
        'Additional submissions regarding the same case will not speed up processing. On the contrary, repeated inquiries can increase the caseload and thereby extend the overall processing time.',
    backToStart: 'Back to start',
    'Back to start': 'Back to start',

    // report pdf
    'The amount is paid to the account details below':
        'Any remaining amount will be transferred to the account below',
    'Parking reading - Subscription (ready)':
        'Parking reading - Subscription (ready)',
    'The Address': 'The address',
    'CREDIT NOTE': 'CREDIT NOTE',
    'Settlement documents': 'Payout note',
    Monthly: 'Monthly',
    Quarterly: 'Quarterly',
    'Half-Yearly': 'Half-Yearly',
    'Half yearly': 'Half yearly',
    Yearly: 'Yearly',
    'Parking solution': 'Parking solution',
    'Payment of control fees': 'Payment of control fees',
    'Cancellation of control fee': 'Cancellation of control fee',
    'Payment of parking permits': 'Payment of parking permits',
    'Guard fine': 'Guard fine',
    'Camera fine': 'Camera fine',
    'Camera fines': 'Camera fines',
    'Camera collection': 'Camera collection',
    'Camera collection by day': 'Camera collection by day',
    'This settlement document is issued under a self-invoicing agreement between the parties.':
        'This settlement document is issued under a self-invoicing\nagreement between the parties.',
    'Payment is made': 'Payment is made',

    pay_for_parking: 'Pay For Parking',
    select_parking_lot: 'Select Parking Lot',
    enter_license: 'Enter License Plate Number',
    fetching: 'Fetching...',
    pay_for_parking_instruction:
        'Select a parking lot, enter license plate number and submit to fetch your parking sessions within last 48 hours.',
    no_parking_sessions_found:
        'No parking sessions found for this license plate number in the last 48 hours.',
    all_sessions_paid:
        'All parking sessions within the last 48 hours have been paid for this license plate.',
    parking_period: 'Parking period',
    total_time: 'Total time',
    invalid_email: 'Invalid email address',
    price: 'Price',
    transaction_fee: 'Transaction fee',
    total_price: 'Total price',
    pay: 'Pay',

    payment_successful: '✅ Payment Successful',
    parking_payment_success_1:
        'Thank you for your payment. The transaction was completed successfully, and a parking permit has now been issued for your vehicle.',
    parking_payment_success_2:
        'A receipt has been sent to the email address you provided during the purchase.',
    parking_payment_success_3:
        'Your vehicle is now properly registered, and you will not receive any parking fines as long as the permit remains valid.',
    parking_payment_success_4:
        'If you did not receive the receipt or have any questions regarding your payment or permit, please feel free to contact our customer service:',
    payment_failed: '❌ Payment Failed',
    parking_payment_failed_1:
        'Unfortunately, your payment was not successful, and a parking permit has not been issued for your vehicle.',
    parking_payment_failed_2:
        'This means your vehicle is not registered with a valid permit and may therefore be subject to parking fines.',
    parking_payment_failed_3:
        'If you experienced issues with the payment or have any questions regarding the process, please don’t hesitate to contact our customer service for assistance:',
    'Cancel subscription': 'Cancel subscription',
    Now: 'Now',

    // api documentation
    'API Documentation': 'API Documentation',
    intro: 'Introduction',
    gettingStarted: 'Getting Started',
    coreConcepts: 'Core Concepts',

    missingTime: 'Missing time',
    minParkingTime: 'Min parking time',

    permittedTime: 'Permitted time',
    lastFine: 'Fine',
    lastIssued: 'Last Issued',
    now: 'Now',
    bufferTime: 'Buffer time',
    bufferPercent: 'Buffer %',
    shortDay: 'd',
    shortHour: 'h',
    shortMinute: 'm',
    'Total Scan Events': 'Total Scan Events',
    'Missed Scan Events': 'Missed Scan Events',
    'Approved Camera Fines': 'Approved Camera Fines',
    'Rejected Camera Fines': 'Rejected Camera Fines',
    'Not Handled Camera Fines': 'Not Handled Camera Fines',
    'Daily Scan Events': 'Daily Scan Events',
    'Daily Missed Scan Events': 'Daily Missed Scan Events',
    'Daily Approved Camera Fines': 'Daily Approved Camera Fines',
    'Daily Rejected Camera Fines': 'Daily Rejected Camera Fines',
    'Daily Not Handled Camera Fines': 'Daily Not Handled Camera Fines',
    'OPARKO Go Activity': 'OPARKO Go Activity',
    'Total Scans': 'Total Scans',
    'Missed Scans': 'Missed Scans',
    'Approved Fines': 'Approved Fines',
    'Rejected Fines': 'Rejected Fines',
    'Average Occupancy': 'Average Occupancy',
    'Not Handled Fines': 'Not Handled Fines',
    'There is an error in Registration Number:':
        'There is an error in Registration Number:',
    'Number Plate should be between 2 and 10 chars long.':
        'Number Plate should be between 2 and 10 chars long.',
    'Spaces and special characters are not allowed.':
        'Spaces and special characters are not allowed.',
    'Payout of licenses': 'Payout of licenses',
    vat: 'VAT',
    'VAT exempt amount': 'VAT exempt amount',
    'VAT taxable amount': 'VAT taxable amount',
    'Customer no.': 'Customer no.',
    Fee: 'Fee',
    'Fee Activity': 'Fee Activity',
    Origin: 'Origin',
    'Fine Origin': 'Fine Origin',
    'Fee Origin': 'Fee Origin',
    'Fee Origin Filter': 'Fee Origin Filter',
    "Cannot take over because user doesn't have platform permission":
        "Cannot take over because user doesn't have platform permission.",
    'User information': 'User information',
    'Total Users': 'Total Users',
    'Active Users': 'Active Users',
    'Web Users': 'Web Users',
    'App Users': 'App Users',
    'Subscription Users': 'Subscription Users',
    'Note: Detailed user information is accessible only when parking lots or organisations are fewer than {{count}}.':
        'Note: Detailed user information is accessible only when parking lots or organisations are fewer than {{count}}.',
    'All Organizations': 'All Organizations',
    'Incorrect creation': 'Incorrect creation',
    'Customer request': 'Customer request',
    'Login with Entra ID': 'Login with Entra ID',
    normal: 'Normal',
    charging_station: 'Charging Station',
    handicap: 'Handicap',
    motor_cycle: 'Motorcycle',
    lærernes_pension: 'Lærernes Pension',
    fine_count: 'Fines Created',
    scan_count: 'Scans Done',
    parking_count: 'Parked Cars',
    'Select View': 'Select View',
    'Show Marker': 'Show Marker',

    notifications: {
        header: {
            title: 'Notifications',
            mark_all_read: 'Mark all as read',
            empty: 'No notifications.',
            empty_help: 'New notifications will show up here when they arrive.',
        },

        error: {
            title: 'Could not load notifications',
            body: 'Something went wrong while loading your notifications.',
            retry: 'Try again',
        },

        toasts: {
            mark_one_failed:
                'Could not mark the notification as read. Please try again.',
            mark_all_failed:
                'Could not mark all notifications as read. Please try again.',
        },

        sections: {
            today: 'Today',
            yesterday: 'Yesterday',
            last7: 'Last 7 days',
            earlier: 'Earlier',
        },

        permit_types: {
            '1': 'ticket',
            '2': 'guest parking',
            '3': 'resident',
            '4': 'paid ticket',
            '5': 'employee paid ticket',
            '6': 'employee',
            '7': 'employee upper basement',
            '8': 'employee lower basement',
            '9': 'permanent permit',
            '10': 'license',
            '11': 'contractor',
            '12': 'backoffice',
            '13': 'editable permit',
            '14': 'subscription',
            '15': 'session permit',
        },

        fine_origins: {
            '2': 'app fine',
            '3': 'camera fine',
            '4': 'camera collection',
            '11': 'camera collection by day',
        },

        permit: {
            created: {
                title: 'Permit #{{permit_id}} created',
                body: 'A ({{permit_type_label}}) has been created for license plate {{regno}} ({{country_code}}) on parking lot {{parking_lot_id}}. It is active from {{start_date}} to {{end_date}}.',
            },
        },

        fine: {
            created: {
                title: 'Fine #{{fine_id}} created',
                body: 'License plate {{regno}} ({{country_code}}) received a ({{fine_origin_label}}) on parking lot {{parking_lot_id}}.',
            },
        },

        title: {
            unknown: 'Notification',
            'permit.create': 'permit.create',
            'permit.expire': 'permit.expire',
            'user.signup': 'user.signup',
            'user.password': 'user.password',
            'order.confirmation': 'order.confirmation',
            'text.send': 'Text Sent',
            'observation.timer_expired': 'Observation time elapsed',
        },
    },

    notificationPreferences: {
        permits: {
            description: 'Get notified when permits are created or changed.',
        },
        fines: {
            description: 'Get notified when a new fine is issued.',
        },

        channels: {
            PLATFORM: 'Notification',
            EMAIL: 'Email',
            APP_PUSH: 'App Push',
        },

        status: {
            customSchedule: 'Custom schedule',
            alwaysOn: 'Always on',
        },

        parkingLots: {
            label: 'Parking lots',
            count_one: '{{count}} parking lot',
            count_other: '{{count}} parking lots',
            enableAll: 'Enable for all parking lots',
        },

        schedule: {
            custom: 'Custom schedule',
            daysLabel: 'Days',
            fromLabel: 'From',
            toLabel: 'To',
            timeCaption: 'Time',
            interval: 'Interval',
            dayShort: {
                mon: 'M',
                tue: 'T',
                wed: 'W',
                thu: 'T',
                fri: 'F',
                sat: 'S',
                sun: 'S',
            },
            october: 'october',
        },
        errors: {
            parkingLotsRequired:
                'Select at least one parking lot, or turn off this notification channel.',
            invalidDays: 'Choose at least one day for your schedule.',
            missingTimeRange: 'Choose both a start and end time.',
            invalidTimeRange: 'Start time must be before end time.',
            saveFailed:
                "We couldn't save your notification settings. Please try again.",
            loadFailed:
                "We couldn't load your notification settings. Please try again.",
        },
    },
    'Send Notification': 'Send Notification',
    'Send Notifications': 'Send Notifications',
    'Send via': 'Send via',
    'Select Template': 'Select Template',
    'The vehicle is cancelled in DMR': 'The vehicle is cancelled in DMR',
    'he vehicle has a special exemption, which therefore exempts it from the parking regulation':
        'The vehicle has a special exemption, which therefore exempts it from the parking regulation',
    'Platform Preview': 'Platform Preview',
    'App Preview': 'App Preview',
    Title: 'Title',
    Body: 'Body',
    Send: 'Send',
    rent: 'Rent',
    revenue: 'Revenue',
    total: 'Total',
    'share in number of units (count)': 'Share in number of units (count)',
    'Monthly lease payment': 'Monthly lease payment',
    'Cancellation Reasons': 'Cancellation Reasons',
    'Create Cancellation Reason': 'Create Cancellation Reason',
    'Cancellation Reason Details': 'Cancellation Reason Details',
    'Fine Cancellation Reasons': 'Fine Cancellation Reasons',
    'No {{tableName}} now': 'No {{tableName}}',
    'Name (Danish)': 'Name (Danish)',
    'Name (DA)': 'Name (DA)',
    'Description (Danish)': 'Description (Danish)',
    CommentDetails: 'Comment Details',

    // Print templates
    'Edit print template': 'Edit print template',
    'Create print template': 'Create print template',
    'Template name': 'Template name',
    'Template name is required': 'Template name is required',
    'Live preview': 'Live preview',
    'Show preview': 'Show preview',
    'Hide preview': 'Hide preview',
    'Available variables': 'Available variables',
    'Use these in block content with double curly braces, e.g.':
        'Use these in block content with double curly braces, e.g.',
    'Successfully created': 'Successfully created',
    'Successfully updated': 'Successfully updated',
    'Failed to create template': 'Failed to create template',
    'Failed to update template': 'Failed to update template',
    'Failed to load template': 'Failed to load template',
    'Failed to delete template': 'Failed to delete template',
    'Yes, delete': 'Yes, delete',
    noPrintTemplatesFound: 'No print templates found',
    'Creditor number': 'Creditor number',
    Logo: 'Logo',
    'Logo URL': 'Logo URL',
    'Payment information': 'Payment information',
    'Base url for QR-code': 'Base url for QR-code',
    'FIK number': 'FIK number',
    'auto-calculated': 'auto-calculated',
    'Company name': 'Company name',
    Footer: 'Footer',
    'Legal entity': 'Legal entity',
    'CVR number': 'CVR number',
    'System block': 'System block',
    Content: 'Content',
    'X position': 'X position',
    'Y position': 'Y position',
    'Font size': 'Font size',
    fontSizePT: 'Font size (pt)',
    'Max width': 'Max width',
    'Max lines': 'Max lines',
    Bold: 'Bold',
    Alignment: 'Alignment',
    Left: 'Left',
    Center: 'Center',
    Right: 'Right',
    blockLabel: {
        logo: 'Logo',
        title: 'Title',
        description: 'Description',
        qr_code: 'QR Code',
        run_number: 'Run number',
        main_body: 'Main body',
        alternative_payment: 'Alternative payment',
        fik_number: 'FIK number',
        guidance_text: 'Guidance text',
        parking_address: 'Parking zone',
        offense_label: 'Offense label',
        offense_note: 'Offense note',
        footer_company: 'Footer company',
        footer_entity: 'Footer entity',
        footer_cvr: 'Footer CVR',
        footer_url: 'Footer URL',
    },
    'Training Modules': 'Training Modules',
    'Create Training': 'Create Training',
    'Edit Training Module': 'Edit Training Module',
    'Create Training Module': 'Create Training Module',
    // training module
    'Read Duration (mins)': 'Read Duration (mins)',
    'Read Time (mins)': 'Read Time (mins)',
    'No training modules found': 'No training modules found',
    // access groups
    'Individual Settings': 'Individual Settings',
    'Access Group': 'Group',
    'Select Access Group': 'Select Group',
    'Permissions are managed by the selected Access Group':
        'Permissions are managed by the selected Group',
    roups: 'Groups',
    'Group Details': 'Group Details',
    'Create Group': 'Create Group',
    Addresses: 'Addresses',
    'Filter addresses by name or id': 'Filter addresses by name or id',
    'Deselect all': 'Deselect all',
    'Loading permissions...': 'Loading permissions...',
    'No permissions available': 'No permissions available',
    Brugerindstillinger: 'User Settings',
    'Name is required': 'Name is required',
    'Failed to save group': 'Failed to save group',
    'Failed to fetch groups': 'Failed to fetch groups',
    'Create Discount Code': 'Create Discount Code',
    'Active Discount Codes': 'Active Discount Codes',
    'Inactive Discount Codes': 'Inactive Discount Codes',
    'Discount Code Details': 'Discount Code Details',
    'Discount code is required': 'Discount code is required',
    'Ticket rule is required': 'Ticket rule is required',
    'Discounted price is required': 'Discounted price is required',
    'Discounted price must be a number': 'Discounted price must be a number',
    'Recipient email is invalid': 'Recipient email is invalid',
    'Recipient Email': 'Recipient Email',
    'Valid from is invalid': 'Valid from is invalid',
    'Valid to is invalid': 'Valid to is invalid',
    'Valid to must be after valid from': 'Valid to must be after valid from',
    'Please correct the highlighted fields':
        'Please correct the highlighted fields',
    'Failed to create discount code': 'Failed to create discount code',
    'Failed to update discount code': 'Failed to update discount code',
    'Failed to fetch discount codes': 'Failed to fetch discount codes',
    invalid_discount_code:
        'Discount code is invalid or not applicable for this ticket',
    'users.noAccessGroupsForOrganisation': 'No groups for this organisation',
    'An unexpected error occurred': 'An unexpected error occurred',
    // notification templates - send modal
    Individual: 'Individual',
    Recipients: 'Recipients',
    'Filter templates by name or id': 'Filter templates by name or id',
    'Filter users by name': 'Filter users by name',
    'Filter access groups by name': 'Filter groups by name',
    'Please select an organisation first':
        'Please select an organisation first',
    'Scroll to load more': 'Scroll to load more',
    'No users in selected groups': 'No users in selected groups',

    // App Message Templates
    'App Message Templates': 'App Announcement Templates',
    AppAnnouncements: 'App Announcements',
    'Create App Message Template': 'Create App Message Template',
    'Edit App Message Template': 'Edit App Message Template',
    'App Message Template Details': 'App Message Template Details',
    'Resource Name': 'Resource Name',
    'Title (English)': 'Title (English)',
    'Title (Danish)': 'Title (Danish)',
    'Description (English)': 'Description (English)',
    'Body (English)': 'Body (English)',
    'Body (Danish)': 'Body (Danish)',
    'Are you sure you want to delete this template?':
        'Are you sure you want to delete this template?',
    appMessageAllFieldsRequired: 'Please fill out all the required fields.',
    appMessageResourceNameRequired: 'Please enter a resource name.',
    appMessageTitleEnRequired: 'Please enter a title in English.',
    appMessageTitleDaRequired: 'Please enter a title in Danish.',
    appMessageDescriptionEnRequired: 'Please enter a description in English.',
    appMessageDescriptionDaRequired: 'Please enter a description in Danish.',
    'Successfully deleted': 'Successfully deleted',
    Resources: 'Resources',
    'appAnnouncement.shownOnLabel': 'Where will this announcement appear?',
    'appAnnouncement.shownOnHelp':
        'Pick one or more resources. The announcement card will show at the top of:',
    'appAnnouncement.shownOnFooter':
        'Selecting multiple resources publishes the same announcement to all of those landing pages — useful for messages that affect more than one section of the app.',
    'appAnnouncement.resource.homeHelp':
        'the main screen wardens land on after logging in',
    'appAnnouncement.resource.finesHelp':
        'the Fees/Fines landing page (after tapping the Fees tile on Home)',
    'appAnnouncement.resource.permitsHelp':
        'the Permits landing page (after tapping the Permits tile on Home)',
    'appAnnouncement.resource.subscriptionsHelp':
        'the Subscriptions landing page (after tapping the Subscriptions tile on Home)',
    'appAnnouncement.priority': 'Priority',
    'appAnnouncement.priorityHelp':
        'Lower number is shown first when multiple announcements share a page.',
    'appAnnouncement.atLeastOneResource': 'Please select at least one resource',
    'appAnnouncement.tooManyResources':
        'Pick at most 10 resources for one announcement.',
    'appAnnouncement.titleTooLong': 'Title must be 255 characters or fewer.',
    'appAnnouncement.bodyTooLong':
        'Description must be 2000 characters or fewer.',
    'appAnnouncement.priorityNegative': 'Priority must be 0 or greater.',
    'appAnnouncement.backgroundColor': 'Background Color',
    'appAnnouncement.accentColor': 'Accent Color',
    'appAnnouncement.fileHint': 'JPEG, PNG, GIF or WEBP — up to 8 MB',
    'appAnnouncement.fileUnsupported':
        'Unsupported file type. Allowed: JPEG, PNG, GIF, WEBP.',
    'appAnnouncement.fileTooLarge': 'File too large. Max size is 8 MB.',
    'appAnnouncement.notFound': 'Template not found',
    'appAnnouncement.somethingWentWrong':
        'Something went wrong, please try again',
    'appAnnouncement.resourceConflict':
        'These resources are already used by another template: {{list}}. Edit or delete the existing template before continuing.',
    'appAnnouncement.created': 'Successfully created',
    'appAnnouncement.updated': 'Successfully updated',
    'appAnnouncement.deleted': 'Successfully deleted',
    'permitReason.nameAndDescriptionRequired':
        'Please fill in both Name and Description.',
    'permitReason.createSuccess': 'Permit reason created successfully.',
    'permitReason.updateSuccess': 'Permit reason updated successfully.',
    'permitReason.deleteSuccess': 'Permit reason deleted successfully.',
    'permitReason.createFailed':
        'Could not create the permit reason. Please try again.',
    'permitReason.updateFailed':
        'Could not update the permit reason. Please try again.',
    'permitReason.deleteFailed':
        'Could not delete the permit reason. Please try again.',
    'permitType.nameRequired': 'Please enter a name.',
    'permitType.confirmDeletePrompt': 'Click delete again to confirm.',
    'permitType.createSuccess': 'Permit type created successfully.',
    'permitType.updateSuccess': 'Permit type updated successfully.',
    'permitType.createFailed':
        'Could not create the permit type. Please try again.',
    'permitType.updateFailed':
        'Could not update the permit type. Please try again.',
    'permitType.deleteFailed':
        'Could not delete the permit type. Please try again.',
    'fines.parkingLotsFetchFailed':
        'Could not fetch parking lots. Please refresh and try again.',
    'fines.offenseListFetchFailed': 'Could not fetch the offence list.',
    'fines.fineNotFound': 'Could not find the fine you were looking for.',
    'fines.offlineId': 'Offline ID',
    'fines.copyCoordinatesTooltip': 'Click to copy coordinates',
    'externalNote.createSuccess':
        'External note template created successfully.',
    'externalNote.updateSuccess':
        'External note template updated successfully.',
    'externalNote.deleteSuccess':
        'External note template deleted successfully.',
    'externalNote.createFailed':
        'Could not create the external note template. Please try again.',
    'externalNote.updateFailed':
        'Could not update the external note template. Please try again.',
    'externalNote.deleteFailed':
        'Could not delete the external note template. Please try again.',
    'cancelReason.nameAndDescriptionRequired':
        'Please fill in both Name and Description.',
    'cancelReason.createSuccess': 'Cancellation reason created successfully.',
    'cancelReason.updateSuccess': 'Cancellation reason updated successfully.',
    'cancelReason.deleteSuccess': 'Cancellation reason deleted successfully.',
    'cancelReason.createFailed':
        'Could not create the cancellation reason. Please try again.',
    'cancelReason.updateFailed':
        'Could not update the cancellation reason. Please try again.',
    'cancelReason.deleteFailed':
        'Could not delete the cancellation reason. Please try again.',
    'cancelReason.filterPlaceholder': 'Filter cancel reasons by name or id',
    'parkingLot.nameRequired': 'Please enter a name.',
    'parkingLot.organisationRequired': 'Please select an organisation.',
    'parkingLot.permitSharingRequired':
        'Please select a permit sharing option.',
    'parkingLot.streetNameRequired': 'Please enter a street name.',
    'parkingLot.streetNumberRequired': 'Please enter a street number.',
    'parkingLot.postalCodeRequired': 'Please enter a postal code.',
    'parkingLot.cityRequired': 'Please enter a city.',
    'parkingLot.latitudeRequired': 'Please enter a latitude.',
    'parkingLot.latitudeAboveMin': 'Latitude must be at least -90.',
    'parkingLot.latitudeBelowMax': 'Latitude must be at most 90.',
    'parkingLot.longitudeRequired': 'Please enter a longitude.',
    'parkingLot.longitudeAboveMin': 'Longitude must be at least -180.',
    'parkingLot.longitudeBelowMax': 'Longitude must be at most 180.',
    'parkingLot.areaCoordinatesMin':
        'Area coordinates must have at least 3 points.',
    'parkingLot.economicDepartmentRequired':
        'Please choose an economic department.',
    'parkingLot.guardControlPercentRange':
        'Guard control percentage must be between 0% and 100%.',
    'parkingLot.selfTicketingPercentRange':
        'Self-ticketing percentage must be between 0% and 100%.',
    'parkingLot.cameraControlPercentRange':
        'Camera control percentage must be between 0% and 100%.',
    'parkingLot.permitPercentRange':
        'Permit percentage must be between 0% and 100%.',
    'parkingLot.subscriptionPercentRange':
        'Subscription percentage must be between 0% and 100%.',
    'parkingLot.guestRuleNameRequired': 'Please enter a guest rule name.',
    'parkingLot.negativeNumber': 'Value cannot be a negative number.',
    'parkingLot.maxPermitsPerMonthTooLow':
        'Max permits per month must be at least the max active permits.',
    'parkingLot.invalidAddressId': 'Invalid or missing address ID.',
    'parkingLot.customCompanyRules': 'Custom company rules',
    'parkingLot.maxActivePermits': 'Max active permits',
    Image: 'Image',
    Remove: 'Remove',
    'Drag and drop': 'Drag and drop',
    or: 'or',
    'Upload image': 'Upload image',
    'Background Color': 'Background Color',
    'Accent Color': 'Accent Color',
    Preview: 'Preview',
    'See more': 'See more',
    'See less': 'See less',
    'JPEG, PNG, GIF or WEBP — up to 8 MB':
        'JPEG, PNG, GIF or WEBP — up to 8 MB',
    'Unsupported file type. Allowed: JPEG, PNG, GIF, WEBP.':
        'Unsupported file type. Allowed: JPEG, PNG, GIF, WEBP.',
    'File too large. Max size is 8 MB.': 'File too large. Max size is 8 MB.',
    'Could not read file': 'Could not read file',
    'Template not found': 'Template not found',
    'Something went wrong, please try again':
        'Something went wrong, please try again',
    'These resources are already used by another template: {{list}}. Edit or delete the existing template before continuing.':
        'These resources are already used by another template: {{list}}. Edit or delete the existing template before continuing.',
    Paragraph: 'Paragraph',
    'Custom observation time(Minutes)': 'Custom observation time(Minutes)',
    'Custom fine price': 'Fine price multiplier (× base price)',
    'Enter distance in meters (required)':
        'Enter distance in meters (required)',
    'Indskriv afstand i meter (påkrævet)':
        'Enter distance in meters (required)',
    'Local date and time (required)': 'Local date and time (required)',
    'Angiv lokal dato og tid (påkrævet)':
        'Enter local date and time (required)',
    'Key values': 'Translations',
    'Time local date': 'Time local date',
    'Measurement in meter check': 'Measurement in meter check',
    'Ventilkontrol (påkrævet)': 'Valve check (required)',
    'Valve control check': 'Valve control check',
    Enabled: 'Enabled',
    Disabled: 'Disabled',
    'Street Qualifier': 'Street Qualifier',
    // observations modal
    observations: 'Observations',
    Observations: 'Observations',
    observationDetails: 'Observation Details',
    observationStartedAt: 'Observation Started At',
    isShared: 'Is Shared',
    observationFilterAll: 'All',
    observationFilterShared: 'Shared',
    observationFilterNotShared: 'Not shared',
    observationPinsTruncated:
        'Too many observations in view; results were limited.',
    internalNote: 'Internal Note',
    externalNote: 'External Note',
    externalNoteTemplates: 'External Note Templates',
    externalNoteDetails: 'External Note Details',
    createExternalNoteTemplate: 'Create External Note Template',
    updatedAt: 'Updated At',
    createdAt: 'Created At',
    clickToCopyCoordinates: 'Click to copy coordinates',
    fineInterruptionDetails: 'Fine Interruption Details',
    finesInterruption: 'Fines Interruption',
    removalReasons: 'Removal Reasons',
    back: 'Back',
    regNr: 'Reg. nr.',
    parkinglotId: 'Parkinglot Id',
    parkingLot: 'Parking Lot',
    feeInterruptionReason: 'Fee Interruption Reason',
    userName: 'User Name',
    faildToFecthFineInterruptions: 'Failed to fetch fine interruptions',
    eventType: 'Event Type',
    eventComment: 'Event Comment',
    locationReadDate: 'Location Read Date',
    model: 'Model',
    comment: 'Comment',
    wrongDoing: 'Wrong Doing',
    vehicleInformationDmr: 'Vehicle Information (DMR)',
    failedToFetchObservations: 'Failed to fetch observations',
    unableToGenerateReport200k:
        'Unable to generate report. The amount of rows exceeded 200,000 — please apply filters to minimize the amount.',
    regnoPseudonymizationInfo:
        'Reg. no. for ScannerUsed events is pseudonymized. The number shown is an anonymized ID, not the actual license plate. The same ID means the same plate was scanned multiple times.',
    dontSendFineToAddress: "Don't Send Fine to Address",
    enableDontSendFineToAddress: "Enable Don't Send Fine to Address",
    addNewAddress: '+ Add new Address',
    noTranslationsAdded: 'No translations added',
    removeTranslation: 'Remove translation',
    addTranslation: 'Add translation...',
    avanceretSoeg: 'Advanced search',
    faerreValg: 'Fewer options',
    MessageTemplates: 'Message Templates',
    MessageHistory: 'Message History',
    SendMessage: 'Send Message',
    MessageTemplate: 'Message Template',
    SentAt: 'Sent At',
    MessageDetails: 'Message Details',

    reportOverallSummary: 'Overall Summary',
    reportPerAddressDetails: 'Per Address Details',
    reportPerAttendant: 'Per Attendant',
    shiftWardenOverview: 'Parking Warden Overview',
    shiftWardenDetails: 'P-Warden Activity',
    'View hourly breakdown': 'View hourly breakdown',
    shiftWardenGps: 'Warden GPS',
    reportPerParkingLot: 'Per Parking Lot',
    reportPerStreet: 'Per Street',
    reportPerPatrolArea: 'Per Patrol Area',
    reportPaidTimeLimitedZoneSummary: 'Paid Time Limited Zone Summary',
    reportUserActivity: 'User Activity',
    reportEvScans: 'EV Scans',
    reportCounterScans: 'Parking Counter',
    reportScanList: 'Scan List',
    reportValveCheck: 'Valve Check',
    reportSelectReports: 'Select Reports',
    reportSelectAll: 'Select All',
    reportClear: 'Clear',
    mapReportTimeoutHint:
        'The report took too long. Try a smaller date range or tighter filters, then try again.',
    mapReportEmptyResult:
        'No data matched your filters. The report was not downloaded.',
    mapReportDownloadStarted: 'Download started: {{name}}',
    mapReportTruncatedWarning:
        'This file may be incomplete: the report hit the maximum number of rows. Narrow your filters for a full export.',
    mapReportExportScopeHint:
        'The Excel file uses the search filters above. Map heat mode and which zone layers are visible only change the map, not the report.',
    mapActiveDateRangeLabel: 'Active period',
    mapActiveDateRangeUnlimited: 'No date limit',
    mapActiveDateRangeSummary: '{{from}} – {{to}}',
    mapActiveTimeRangeSuffix: '· {{from}}–{{to}}',
    mapDatePresetLast7Days: 'Last 7 days',
    mapDatePresetThisMonth: 'This month',
    mapReportGenericFailure: 'Could not generate the report. Please try again.',
    mapReportNetworkFailure:
        'The connection to the server could not be established. Check your internet connection and try again.',
    mapReportInternalError:
        'An internal error occurred while generating the report. Please try again.',
    AvailableOn: 'Available on',
    'Enter distance in meters': 'Enter distance in meters',
    'Indskriv afstand i meter': 'Enter distance in meters',
    'Local date and time': 'Local date and time',
    'Angiv lokal dato og tid': 'P-skive',
    Ventilkontrol: 'Valve Control',
    'Valve Control': 'Valve Control',
    'Initial check': 'Initial check',
    'Follow up check': 'Follow up check',
    'No image': 'No image',
    fineInterruptions: 'Fine Interruptions',
    guardGps: 'Guard Gps',
    flowType: 'Flow Type',
    flowType_0: 'Unknown',
    flowType_1: 'Auto start & Stop',
    flowType_2: 'Manual start & Stop',
    flowType_3: 'Re-entry stop',
    flowType_4: 'Auto stop after 48h',
    flowType_5: 'Manual stop after 48h',
    flowType_6: 'Auto start, manual stop',
    flowType_7: 'EasyPark stop success',
    flowType_8: 'EasyPark stop fallback',
    flowType_9: 'AreaNo 0 stop',
    flowType_10: 'Cronjob stop after 48h',
    flowType_11: 'Backoffice manual stop',
    flowType_12: 'Manual start, auto stop',
    ShowPins: 'Show Pins',
    NoteTemplate: 'Note Template',
    Visibility: 'Visibility',
    Visibility_backoffice: 'Visible only for backoffice',
    Visibility_dashboard: 'Dashboard',
    Visibility_all: 'Visible for all organisations',
    Delete_parking_status: 'Delete Parking Status',
    Parking_status_delete_check_info:
        'We check whether this parking status is currently being used before it can be deleted.',
    Status_is_in_use: 'Status is in use',
    Parking_status_in_use_info:
        'You cannot delete this status before updating all related records listed below.',
    Status_is_not_in_use: 'Status is not in use',
    Parking_status_not_in_use_info:
        'No records are currently using this status. It is safe to delete.',
    Usage_by_type: 'Usage by type',
    Failed_to_fetch_usage: 'Failed to fetch usage',
    Parking_status_no_records_found:
        'No related records were found for this parking status.',
    Confirm_delete: 'Confirm Delete',
    Deleting: 'Deleting...',
    parkingStatusNameRequired: 'Please enter a name.',
    parkingStatusDanishRequired:
        'Please provide at least one Danish translation.',
    parkingStatusCancelReasonRequired:
        'Please select at least one cancel reason.',

    // Entra user
    'entraUser.banner':
        'This user is managed by Entra. Some fields cannot be edited.',
    'entraUser.role': 'Entra Role',
    'entraUser.fieldDisabled': 'This field is managed by Entra',
    Entra: 'Entra',
    'entraUser.permissionsDisabled':
        'Permissions are managed by Entra and cannot be changed here.',
    'fines.actionValue.measurementMeter': 'Measured distance (cm)',
    'fines.actionValue.timeLocalDate': 'Time',
    'fines.actionValue.pDisc1Time': 'P-disc time 1',
    'fines.actionValue.pDisc2Time': 'P-disc time 2',
    'fines.vehicleTypeLabel': 'Vehicle type',
    'fines.observationDuration': 'Duration (m)',
    'fines.internalNoteFromApp': 'Internal note from app',
    'fines.externalNoteFromApp': 'External note from app',
    'fine.startdate': 'Created in platform',
    'fine.startdate.tooltip':
        'The synchronisation timestamp of the fine with the platform',
    'fine.created': 'Fee imposed',
    'fine.created.tooltip':
        'Time when the fee is imposed on the vehicle by the user',
    'fine.enddate': 'No new fine until',
    'fine.vehicleinfo': 'Vehicle Information',
    'fines.feeReason': 'Delivery Method',
    'fines.attachedFineLabel': 'Attached fine',
    'fines.attachedFineYes': 'Yes',
    'fines.attachedFineNo': 'Sent afterwards',
    'fines.userName': 'Name',
    'fines.userNote': 'Note',
    'fines.streetCode': 'Street Code',
    observation: 'Observation',
    totalCount: 'Total Count',
    monthYear: 'Month / Year',
    userNote: 'User Note',
    nameIsRequired: 'Name is required',
    nameCannotExceed255: 'Name cannot exceed 255 characters',
    nameLessThan4: 'Name must be at least 4 characters.',
    descriptionIsRequired: 'Description is required',
    descriptionCannotExceed500: 'Description cannot exceed 500 characters',
    descriptionLessThan4: 'Description must be at least 4 characters.',
    priority: 'Priority',
    deletedBy: 'Deleted by',
    deletedReason: 'Deleted Reason',
    parkingFeeID: 'Parking Fee Id',
    gpsAge1Min: '1 minute ago',
    gpsAgeXMins: '{{count}} minutes ago',
    gpsAge1Hour: '1 hour ago',
    gpsAgeXHours: '{{count}} hours ago',
    gpsAgeToday: 'Today',
    gpsAgeYesterday: 'Yesterday — {{date}}',
    gpsAgeWeekday: '{{weekday}} — {{date}}',
    gpsAgeXDays: '{{count}} days ago — {{date}}',
    gpsAgeXMonths: '{{count}} months ago — {{date}}',
    gpsAgeXYears: '{{count}} years ago — {{date}}',
    gpsTracking: 'GPS Tracking',
    somethingWentWrong: 'Something went wrong',
    unexpectedErrorOccurred:
        'An unexpected error occurred. You can try reloading the page or resetting the view.',
    stackTrace: 'Stack trace',
    reloadPage: 'Reload page',
    noSubscriptionsFound: 'No subscriptions found',
    noTrainingModulesFound: 'No training modules found',
    noUsersFound: 'No users found',
    noPermitsFound: 'No permits found',
    noGroupsFound: 'No groups found',
    noAppMessageTemplatesFound: 'No app message templates found',
    noNotificationsFound: 'No notifications found',
    noTrainingDataFound: 'No training data found',
    noFinesFound: 'No fines found',
    noDataFound: 'No data found',
    noDiscountCodesFound: 'No discount codes found',
    noCameraPermitsOrFinesFound: 'No camera permits or fines found',
    noCameraFinesFound: 'No camera fines found',
    noCameraPermitsFound: 'No camera permits found',
    noObservationsFound: 'No observations found',
    noFineInterruptionsFound: 'No fine interruptions found',
    noParkingStatusesFound: 'No parking statuses found',
    noParkingStatusFound: 'No parking status found',
    noAddressesFound: 'No addresses found',
    noAttendantsFound: 'No attendants found',
    noStreetsFound: 'No streets found',
    noPatrolAreasFound: 'No patrol areas found',
    'fine.delete.title': 'Delete fine',
    'fine.delete.warning':
        'You are about to permanently delete this fine and all associated data. This cannot be undone.',
    'fine.delete.affectedData': 'Information affected by the deletion',
    'fine.delete.dataType': 'Data type',
    'fine.delete.description': 'Description',
    'fine.delete.personalData': 'Fine and personal data',
    'fine.delete.personalDataDesc':
        'The fine itself is permanently deleted incl. license plate, country code and GPS location.',
    'fine.delete.imagesDesc': 'All images attached to the fine are deleted.',
    'fine.delete.observation': 'Observation',
    'fine.delete.observationDesc':
        'Linked parking observation is released and deleted.',
    'fine.delete.eventHistory': 'Event history',
    'fine.delete.eventHistoryDesc':
        "Event log for the parking guard's creation of the observation and fine is deleted.",
    'fine.delete.noticeTitle': 'Notice - Deletion occurs after 24 hours',
    'fine.delete.noticeBody':
        'Upon confirmation, the fine and all associated data will be permanently deleted after 24 hours. This action cannot be undone.',
    viewImage: 'View image',
    imageTooBig: 'Image is too big. Maximum size is 4 MB.',
    FineCreated: 'Fine Created',
    FineSearched: 'Fine Searched',
    PermitCreated: 'Permit Created',
    PermitSearched: 'Permit Searched',
    ScannerUsed: 'Scanner Used',
    FeeSearch: 'Fee Search',
    FineObservation: 'Fine Observation',
    FineCancelled: 'Fine Cancelled',
    CreateCleanFine: 'Aborted Fine Creation',
    ParkedCar: 'Parked Car',
    ValidPermit: 'Valid Permit',
    InValidPermit: 'Invalid Permit',
    DeleteObservation: 'Delete Observation',
    'Rows per page': 'Rows per page',
    'Spots & sections': 'Spots & sections',
    'Sections count': 'Sections count',
    'Spot count': 'Spot count',
    'Spots and sections': 'Spots and sections',
    'SmartHub enabled': 'SmartHub enabled',
    'Parking Lot Rules': 'Parking Lot Rules',
    'Complaints handling': 'Complaints handling',
    'Note for parkinglot specific guidelines':
        'Note for parkinglot specific guidelines',
    'Passenger car': 'Passenger car',
    Van: 'Van',
    Truck: 'Truck',
    Bus: 'Bus',
    Motorcycle: 'Motorcycle',
    'Moped 45': 'Moped 45',
    Trailer: 'Trailer',
    Diesel: 'Diesel',
    Electric: 'Electric',
    Hybrid: 'Hybrid',
    Petrol: 'Petrol',
    searchForLocation: 'Search for location',
    'financeReports.createCustomInvoice': 'Create custom invoice',
    'financeReports.typeStandard': 'Standard',
    'financeReports.typeCustom': 'Custom',
    'financeReports.customLines': 'Custom lines',
    'financeReports.customLinesHint':
        'A positive unit price goes to the OPARKO cut. A negative unit price goes to the customer cut.',
    'financeReports.addLine': 'Add line',
    'financeReports.lineDescription': 'Description',
    'financeReports.lineQuantity': 'Quantity',
    'financeReports.lineUnitPrice': 'Unit price',
    'financeReports.lineTotal': 'Line total',
    'financeReports.saveCustomInvoice': 'Save custom invoice',
    'financeReports.customInvoiceCreated': 'Custom invoice created',
    'financeReports.customInvoiceUpdated': 'Custom invoice updated',
    'financeReports.parkingAddressRequired': 'Parking address is required',
    'financeReports.periodRequired': 'Period start and end are required',
    'financeReports.minimumRent': 'Minimum rent',
    'financeReports.minimumRentAdjustment': 'Minimum rent adjustment',
};

export default english;
